import { JSONString, FileUpload, ButlerCommand } from './customScalarTypes';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * An object that represents a parsed Butler command. Typing this in the schema would be very
   * expensive. Currently supported commands are typed in the butler-command-parser package,
   * but this list is not extensive. Cannot trivially use JSONString scalar because the alternative
   * type of a Butler command is a string, so passing it around as an object makes refining its type
   * dramatically easier.
   */
  ButlerCommand: ButlerCommand;
  /** An alias for the File type. Should be used for any mutation where we are uploading a file. */
  FileUpload: FileUpload;
  /**
   * An object which contains unknown (user generated) keys and values serialized to a string.
   * Should only be used in scenarios where we cannot provide stricter typing, for example, the
   * custom emoji data required to render Trello Markdown. The consuming component is responsible
   * for parsing the string into JSON.
   * See https://github.com/apollographql/apollo-feature-requests/issues/2 for discussion
   */
  JSONString: JSONString;
  /**
   * ISO-8601 standard in UTC
   * Example: 2011-08-12T20:17:46.384Z
   */
  TrelloDateTime: any;
  /**
   * A unique short string that can be used to fetch a board, card, etc. It's
   * usually used as a part of the entity URL. In some cases can be used as
   * as the ID.
   */
  TrelloShortLink: any;
};

/** The user's Aa profile data used in AA onboarding */
export type AaOnboardingProfile = {
  __typename: 'AaOnboardingProfile';
  /** The url of the user's Aa avatar */
  avatarUrl: Scalars['String'];
  /** The name of the user */
  fullName: Scalars['String'];
};

export type AccessRequest = {
  __typename: 'AccessRequest';
  allowed: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type AccessRequestVerification = {
  __typename: 'AccessRequestVerification';
  success: Scalars['Boolean'];
};

/** Object that represents the response of requestBoardAccess mutation */
export type AccessRequest_Response = {
  __typename: 'AccessRequest_Response';
  /** Whether requesting access was successful */
  success: Scalars['Boolean'];
};

/**
 * Actions are generated whenever an action occurs in Trello. For instance, when a user deletes a card, a
 * `deleteCard` action is generated and includes information about the deleted card.
 */
export type Action = {
  __typename: 'Action';
  /** Relevant information regarding the Action */
  data: Scalars['JSONString'];
  /** When the Action occurred */
  date: Scalars['String'];
  /** Relevant information for displaying the Action */
  display: Action_Display;
  /** The ID of the Action */
  id: Scalars['ID'];
  /** The ID of the Member who caused the Action */
  idMemberCreator: Scalars['String'];
  /** The Member who caused the Action */
  memberCreator: Member;
  /** The Reactions on the Action */
  reactions: Array<Reaction>;
  /** The type of the Action */
  type: Action_Type;
};

/** Relevant information for displaying the Action */
export type Action_Display = {
  __typename: 'Action_Display';
  /** Information about any Entities involved in the Action */
  entities: Scalars['JSONString'];
  /** The key used to translate the Action */
  translationKey?: Maybe<Scalars['String']>;
};

/** The Types of Actions */
export const Action_Type = {
  AcceptEnterpriseJoinRequest: 'acceptEnterpriseJoinRequest',
  AddAdminToEnterprise: 'addAdminToEnterprise',
  AddAttachmentToCard: 'addAttachmentToCard',
  AddChecklistToCard: 'addChecklistToCard',
  AddMemberToBoard: 'addMemberToBoard',
  AddMemberToCard: 'addMemberToCard',
  AddMemberToOrganization: 'addMemberToOrganization',
  AddOrganizationToEnterprise: 'addOrganizationToEnterprise',
  AddToEnterprisePluginWhitelist: 'addToEnterprisePluginWhitelist',
  AddToOrganizationBoard: 'addToOrganizationBoard',
  ChangeEnterprisePublicBoardVisibility: 'changeEnterprisePublicBoardVisibility',
  CommentCard: 'commentCard',
  ConvertToCardFromCheckItem: 'convertToCardFromCheckItem',
  CopyBoard: 'copyBoard',
  CopyCard: 'copyCard',
  CopyCommentCard: 'copyCommentCard',
  CreateBoard: 'createBoard',
  CreateCard: 'createCard',
  CreateCustomField: 'createCustomField',
  CreateEnterpriseJoinRequest: 'createEnterpriseJoinRequest',
  CreateList: 'createList',
  CreateOrganization: 'createOrganization',
  DeactivatedMemberInEnterprise: 'deactivatedMemberInEnterprise',
  DeactivatedMemberInOrganization: 'deactivatedMemberInOrganization',
  DeclineEnterpriseJoinRequest: 'declineEnterpriseJoinRequest',
  DeleteAttachmentFromCard: 'deleteAttachmentFromCard',
  DeleteBoardInvitation: 'deleteBoardInvitation',
  DeleteCard: 'deleteCard',
  DeleteCustomField: 'deleteCustomField',
  DeleteOrganizationInvitation: 'deleteOrganizationInvitation',
  DisableEnterprisePluginWhitelist: 'disableEnterprisePluginWhitelist',
  DisableIssuingOfConsentTokensInEnterprise: 'disableIssuingOfConsentTokensInEnterprise',
  DisablePlugin: 'disablePlugin',
  DisablePowerUp: 'disablePowerUp',
  EmailCard: 'emailCard',
  EnableEnterprisePluginWhitelist: 'enableEnterprisePluginWhitelist',
  EnableIssuingOfConsentTokensInEnterprise: 'enableIssuingOfConsentTokensInEnterprise',
  EnablePlugin: 'enablePlugin',
  EnablePowerUp: 'enablePowerUp',
  EnterpriseAdminViewedPrivateBoard: 'enterpriseAdminViewedPrivateBoard',
  GrantEnterpriseLicense: 'grantEnterpriseLicense',
  GrantOrganizationLicenses: 'grantOrganizationLicenses',
  MakeAdminOfBoard: 'makeAdminOfBoard',
  MakeNormalMemberOfBoard: 'makeNormalMemberOfBoard',
  MakeNormalMemberOfOrganization: 'makeNormalMemberOfOrganization',
  MakeObserverOfBoard: 'makeObserverOfBoard',
  MemberJoinedTrello: 'memberJoinedTrello',
  MoveCardFromBoard: 'moveCardFromBoard',
  MoveCardToBoard: 'moveCardToBoard',
  MoveListFromBoard: 'moveListFromBoard',
  MoveListToBoard: 'moveListToBoard',
  ReactivatedMemberInEnterprise: 'reactivatedMemberInEnterprise',
  ReactivatedMemberInOrganization: 'reactivatedMemberInOrganization',
  RemoveAdminFromEnterprise: 'removeAdminFromEnterprise',
  RemoveChecklistFromCard: 'removeChecklistFromCard',
  RemoveFromEnterprisePluginWhitelist: 'removeFromEnterprisePluginWhitelist',
  RemoveFromOrganizationBoard: 'removeFromOrganizationBoard',
  RemoveMemberFromCard: 'removeMemberFromCard',
  RemoveOrganizationFromEnterprise: 'removeOrganizationFromEnterprise',
  RemovedAllTokensFromOwnedMembers: 'removedAllTokensFromOwnedMembers',
  RemovedTokensFromMember: 'removedTokensFromMember',
  RevokeEnterpriseLicense: 'revokeEnterpriseLicense',
  TrelloAddAdminToEnterprise: 'trelloAddAdminToEnterprise',
  TrelloAddOrganizationToEnterprise: 'trelloAddOrganizationToEnterprise',
  TrelloRemoveAdminFromEnterprise: 'trelloRemoveAdminFromEnterprise',
  TrelloRemoveOrganizationFromEnterprise: 'trelloRemoveOrganizationFromEnterprise',
  UnconfirmedBoardInvitation: 'unconfirmedBoardInvitation',
  UnconfirmedOrganizationInvitation: 'unconfirmedOrganizationInvitation',
  UpdateBoard: 'updateBoard',
  UpdateBoardOrg: 'updateBoardOrg',
  UpdateBoardVisibility: 'updateBoardVisibility',
  UpdateCard: 'updateCard',
  UpdateCardClosed: 'updateCardClosed',
  UpdateCardDue: 'updateCardDue',
  UpdateCardDueComplete: 'updateCardDueComplete',
  UpdateCardIdList: 'updateCardIdList',
  UpdateCheckItemStateOnCard: 'updateCheckItemStateOnCard',
  UpdateChecklist: 'updateChecklist',
  UpdateCustomField: 'updateCustomField',
  UpdateCustomFieldItem: 'updateCustomFieldItem',
  UpdateEnterprise: 'updateEnterprise',
  UpdateList: 'updateList',
  UpdateListClosed: 'updateListClosed',
  UpdateMember: 'updateMember',
  UpdateOrganization: 'updateOrganization',
  WithdrawEnterpriseJoinRequest: 'withdrawEnterpriseJoinRequest'
} as const;

export type Action_Type = typeof Action_Type[keyof typeof Action_Type];
/** Specifies whether to add powerup when adding a board */
export const AddBoardPowerUpsArgs = {
  Calendar: 'calendar',
  CardAging: 'cardAging',
  Voting: 'voting'
} as const;

export type AddBoardPowerUpsArgs = typeof AddBoardPowerUpsArgs[keyof typeof AddBoardPowerUpsArgs];
/** Price quotes for additional members */
export type AddMembersPriceQuotes = {
  __typename: 'AddMembersPriceQuotes';
  /** The price quote for the remainder of the current subscription period */
  prorated: PriceQuote;
  /** The price quote for the next renewal */
  renewal: PriceQuote;
};

/** Announcements appear in the header in the Taco component */
export type Announcement = {
  __typename: 'Announcement';
  /** The HTML content of the Announcement */
  html: Scalars['String'];
  /** The ID of the Announcement */
  id: Scalars['ID'];
  /** The locale of the Announcement */
  locale: Scalars['String'];
  /** The title of the Announcement */
  title: Scalars['String'];
  /** The type of Announcement */
  type: AnnouncementType;
  /** The url to learn more about the Announcement */
  url?: Maybe<Scalars['String']>;
};

/**
 * The types of Announcements. Most are blog posts, but there is a reserved type for announcing
 * maintenance downtime that will give the Roo component an alternate appearance
 */
export const AnnouncementType = {
  Blog: 'blog',
  Downtime: 'downtime'
} as const;

export type AnnouncementType = typeof AnnouncementType[keyof typeof AnnouncementType];
/** The response when dismissing an announcement. Just indicates success */
export type Announcement_DismissResponse = {
  __typename: 'Announcement_DismissResponse';
  success: Scalars['Boolean'];
};

/**
 * This enum is the names of API groupings within the total Atlassian API.
 *
 * This is used by our documentation tooling to group together types and fields into logical groups
 */
export const ApiGroup = {
  Caas: 'CAAS',
  CollaborationGraph: 'COLLABORATION_GRAPH',
  Compass: 'COMPASS',
  Confluence: 'CONFLUENCE',
  ContentPlatformApi: 'CONTENT_PLATFORM_API',
  DevopsAriGraph: 'DEVOPS_ARI_GRAPH',
  DevopsContainerRelationship: 'DEVOPS_CONTAINER_RELATIONSHIP',
  DevopsService: 'DEVOPS_SERVICE',
  Forge: 'FORGE',
  Help: 'HELP',
  Identity: 'IDENTITY',
  Jira: 'JIRA',
  Polaris: 'POLARIS',
  Teams: 'TEAMS',
  XenLogsApi: 'XEN_LOGS_API'
} as const;

export type ApiGroup = typeof ApiGroup[keyof typeof ApiGroup];
export type AppCreator = {
  __typename: 'AppCreator';
  icon?: Maybe<AppCreator_Icon>;
  iconClass?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  idPlugin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  urlSuffix?: Maybe<Scalars['String']>;
};

export type AppCreator_Icon = {
  __typename: 'AppCreator_Icon';
  url?: Maybe<Scalars['String']>;
};

/** Details of an Atlassian Account */
export type AtlassianAccount = {
  __typename: 'AtlassianAccount';
  email: Scalars['String'];
};

/** An object representing an attachment belonging to a card */
export type Attachment = {
  __typename: 'Attachment';
  /** The size of the attachment in bytes */
  bytes: Scalars['Int'];
  /** The date the attachment was added */
  date: Scalars['String'];
  /** For image attachments, the extracted edge color */
  edgeColor?: Maybe<Scalars['String']>;
  /** The filename of the attachment */
  fileName: Scalars['String'];
  /** The ID of the attachment */
  id: Scalars['ID'];
  /** The ID of the member who added the attachment */
  idMember: Scalars['ID'];
  /** Whether the attachment was uploaded */
  isUpload: Scalars['Boolean'];
  /** The mimeType for the attachment */
  mimeType?: Maybe<Scalars['String']>;
  /** The name of the attachment */
  name: Scalars['String'];
  /** The position of the attachment in the attachments list */
  pos: Scalars['Float'];
  /** If the attachment is an image, an array of generated previews of the image in various sizes */
  previews?: Maybe<Array<Attachment_Preview>>;
  /** The URL to the attachment */
  url: Scalars['String'];
};

/** A filter for the Attachments being requested */
export const Attachment_Filter = {
  /** Only attachments which are Card covers */
  Cover: 'cover'
} as const;

export type Attachment_Filter = typeof Attachment_Filter[keyof typeof Attachment_Filter];
export type Attachment_Preview = {
  __typename: 'Attachment_Preview';
  /** The id of the attachment preview */
  _id: Scalars['ID'];
  /** The size of the attachment preview in bytes */
  bytes: Scalars['Int'];
  /** The height of the image */
  height: Scalars['Int'];
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'];
  /** The URL to the preview */
  url: Scalars['String'];
  /** The width of the image */
  width: Scalars['Int'];
};

/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type Board = {
  __typename: 'Board';
  /** The Actions taken on this Board */
  actions: Array<Action>;
  /** The ids of plugins that a board has enabled */
  boardPlugins: Array<BoardPlugin>;
  /** The limit for how many Butler buttons a board can show */
  butlerButtonLimit: Scalars['Int'];
  butlerButtonOverrides?: Maybe<Array<ButlerButtonOverrides>>;
  /** The Cards on the Board */
  cards: Array<Card>;
  /** Boolean whether the board has been closed or not */
  closed: Scalars['Boolean'];
  /** How the Board was created */
  creationMethod?: Maybe<CreationMethod>;
  /** The CustomFields configured for the Board */
  customFields: Array<CustomField>;
  dashboardViewTile?: Maybe<Board_DashboardViewTile>;
  /** The tiles configured for the board's dashboard view */
  dashboardViewTiles: Array<Board_DashboardViewTile>;
  /** The date that the last activity occured on the Board */
  dateLastActivity?: Maybe<Scalars['String']>;
  /** The date that the current Member last viewed the Board */
  dateLastView?: Maybe<Scalars['String']>;
  /** The date that plugins are scheduled to be disabled */
  datePluginDisable?: Maybe<Scalars['String']>;
  /** The description of the Board (About this Board) */
  desc: Scalars['String'];
  /** If the description includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONString']>;
  /** The Enterprise this Board belongs to */
  enterprise?: Maybe<Enterprise>;
  /** Boolean whether the board belongs to an Enterprise */
  enterpriseOwned: Scalars['Boolean'];
  /** A specific Export on this board */
  export?: Maybe<Export>;
  /** The Exports on this Board */
  exports: Array<Export>;
  /** Historical data for the board */
  history?: Maybe<Board_History>;
  /** The ID of the Board */
  id: Scalars['ID'];
  /** The ID of the Template the board was copied from */
  idBoardSource: Scalars['ID'];
  /** MongoID of the Enterprise to which the board belongs */
  idEnterprise?: Maybe<Scalars['String']>;
  /** MongoID of the organization to which the board belongs */
  idOrganization?: Maybe<Scalars['String']>;
  /** The ids for the Collections(Tags) that the Board is part of */
  idTags: Array<Scalars['String']>;
  /** Object containing color keys and the label names given for one label of each color on the board */
  labelNames: Board_LabelNames;
  /** The Labels on this Board */
  labels: Array<Label>;
  /** The limits on the Board */
  limits: Board_Limits;
  /** The Lists on the Board */
  lists: Array<List>;
  /** The Members on the Board */
  members: Array<Member>;
  /** The counts of membership types on this Board */
  membershipCounts?: Maybe<MembershipCounts>;
  /** The Memberships of the Board */
  memberships: Array<Board_Membership>;
  /** The Member's preferences specific to this Board */
  myPrefs: MyPrefs;
  /** The name of the Board */
  name: Scalars['String'];
  /** The Organization this Board belongs to */
  organization?: Maybe<Organization>;
  /** Boolean whether the board has been pinned or not */
  pinned: Scalars['Boolean'];
  /** The PluginData for this Board */
  pluginData: Array<PluginData>;
  /** The Plugins on the Board */
  plugins: Array<Plugin>;
  /** List of powerups as strings */
  powerUps?: Maybe<Array<Scalars['String']>>;
  /** Short for 'preferences', these are the settings for the board */
  prefs?: Maybe<Board_Prefs>;
  /** The premium features allowed for this board */
  premiumFeatures: Array<PremiumFeatures>;
  /** The Butler Buttons the board owns */
  privateButlerButtons: Array<ButlerButton>;
  /** Recommended Members */
  recommendedMembers: Array<RecommendedMember>;
  /** Related templates for the board */
  related: Array<Board>;
  sharedButlerButtons: Array<ButlerButton>;
  /** The shortMongoId for this Board */
  shortLink: Scalars['String'];
  /** URL for the board using only its shortMongoID */
  shortUrl: Scalars['String'];
  /** The counts for this Board being starred */
  starCounts?: Maybe<StarCounts>;
  /** Whether the board has been starred by the current user */
  starred: Scalars['Boolean'];
  /** View and copy counts for the board */
  stats?: Maybe<Board_Stats>;
  /** Whether the current Member is subscribed to the Board */
  subscribed: Scalars['Boolean'];
  /** The field that determine how a template renders in the template gallery */
  templateGallery?: Maybe<TemplateGallery>;
  /** Persistent URL for the board */
  url: Scalars['String'];
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardActionsArgs = {
  filter?: InputMaybe<Array<Action_Type>>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardCardsArgs = {
  filter?: InputMaybe<Card_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardDashboardViewTileArgs = {
  id: Scalars['ID'];
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardExportArgs = {
  id: Scalars['ID'];
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardExportsArgs = {
  id: Scalars['ID'];
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardLabelsArgs = {
  filter?: InputMaybe<Label_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardListsArgs = {
  filter?: InputMaybe<List_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardMembersArgs = {
  filter?: InputMaybe<Member_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardMembershipCountsArgs = {
  filter?: InputMaybe<MembershipCounts_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardMembershipsArgs = {
  filter?: InputMaybe<Board_Membership_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardPluginsArgs = {
  filter?: InputMaybe<Plugin_Filter>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardRelatedArgs = {
  count?: InputMaybe<Scalars['Int']>;
};


/** Boards are fundamental to Trello. A board may belong to 0 or 1 workspace and can have 0 or more lists. */
export type BoardStatsArgs = {
  id: Scalars['ID'];
};

export type BoardEntity = {
  __typename: 'BoardEntity';
  id?: Maybe<Scalars['String']>;
  shortLink?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Board invitation secret */
export type BoardInviteSecret = {
  __typename: 'BoardInviteSecret';
  secret: Scalars['String'];
  type: Scalars['String'];
};

/** An object representing the response from the disableBoardInvitationSecret mutation */
export type BoardInviteSecret_DeleteResponse = {
  __typename: 'BoardInviteSecret_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

export type BoardNotificationData = {
  __typename: 'BoardNotificationData';
  closed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shortLink?: Maybe<Scalars['String']>;
};

/** Board Plugin schema */
export type BoardPlugin = {
  __typename: 'BoardPlugin';
  id: Scalars['ID'];
  idPlugin: Scalars['ID'];
};

/** A starred Board for a Member */
export type BoardStar = {
  __typename: 'BoardStar';
  /** The ID of the BoardStar relationship */
  id: Scalars['ID'];
  /** The ID of the Board */
  idBoard: Scalars['String'];
  /** The relative position of the starred Board */
  pos: Scalars['Int'];
};

export type Board_DashboardViewTile = {
  __typename: 'Board_DashboardViewTile';
  /** The date this tile was last modified */
  dateLastActivity: Scalars['String'];
  /** The start of the timeframe for historical charts */
  from?: Maybe<Board_DashboardViewTile_From>;
  /** The configuration of this tile's graph */
  graph: Board_DashboardViewTile_Graph;
  id: Scalars['ID'];
  /** The position of this tile in the dashboard */
  pos: Scalars['Int'];
  /** The type of this tile */
  type: Scalars['String'];
};

export type Board_DashboardViewTile_From = {
  __typename: 'Board_DashboardViewTile_From';
  /** Either absolute or relative */
  dateType: Scalars['String'];
  /**
   * Either a unix timestamp (ms) for an absolute date, or an offset (ms)
   * for relative dates
   */
  value: Scalars['Int'];
};

export type Board_DashboardViewTile_Graph = {
  __typename: 'Board_DashboardViewTile_Graph';
  /** The type of graph (bar, pie, ...) */
  type: Scalars['String'];
};

/** A filter for the Boards being requested */
export const Board_Filter = {
  /** Returns all boards that are closed */
  Closed: 'closed',
  /** Returns all boards that have visibility set to Private */
  Members: 'members',
  /** Returns all boards that are open */
  Open: 'open',
  /** Returns all boards that have visibility set to Team */
  Organization: 'organization',
  /** Returns all boards that have visibility set to Public. */
  Public: 'public',
  /** Returns all boards that have been starred (avoid using). Note: Currently this filter is not updating in real-time. */
  Starred: 'starred',
  /** Returns all boards that are templates. */
  Template: 'template'
} as const;

export type Board_Filter = typeof Board_Filter[keyof typeof Board_Filter];
/** A board's historical data */
export type Board_History = {
  __typename: 'Board_History';
  /** Data for the # of cards whose due date is in each of the different due date states */
  cardsPerDueDateStatus: Board_History_CardsPerDueDateStatus;
  /** Data for the # of cards assigned to each of the board's labels over time */
  cardsPerLabel: Board_History_CardsPerLabel;
  /** Data for the # of cards in each of the board's lists over time */
  cardsPerList: Board_History_CardsPerList;
  /** Data for the # of cards assigned to each of the board's members over time */
  cardsPerMember: Board_History_CardsPerMember;
  /** The id of the board the history is for. */
  id: Scalars['ID'];
};


/** A board's historical data */
export type Board_HistoryCardsPerDueDateStatusArgs = {
  from?: InputMaybe<Scalars['String']>;
};


/** A board's historical data */
export type Board_HistoryCardsPerLabelArgs = {
  from?: InputMaybe<Scalars['String']>;
};


/** A board's historical data */
export type Board_HistoryCardsPerListArgs = {
  from?: InputMaybe<Scalars['String']>;
};


/** A board's historical data */
export type Board_HistoryCardsPerMemberArgs = {
  from?: InputMaybe<Scalars['String']>;
};

/** A board's cardsPerDueDateStatus history */
export type Board_History_CardsPerDueDateStatus = {
  __typename: 'Board_History_CardsPerDueDateStatus';
  /**
   * The board history API has limits on how many actions can be processed. This field
   * says whether or not the result being returned is complete or not.
   */
  complete: Scalars['Boolean'];
  /** The timeseries for each due date status */
  series: Board_History_CardsPerDueDateStatus_Series;
};

/** A set of series for each different due date status */
export type Board_History_CardsPerDueDateStatus_Series = {
  __typename: 'Board_History_CardsPerDueDateStatus_Series';
  done: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
  dueLater: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
  dueSoon: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
  noDueDate: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
  overdue: Array<Board_History_CardsPerDueDateStatus_Series_DataPoint>;
};

export type Board_History_CardsPerDueDateStatus_Series_DataPoint = {
  __typename: 'Board_History_CardsPerDueDateStatus_Series_DataPoint';
  /** The data point timestamp */
  dateTime: Scalars['String'];
  /** The number of cards in the DueDateStatus */
  value: Scalars['Int'];
};

/** A board's cardsPerLabel history */
export type Board_History_CardsPerLabel = {
  __typename: 'Board_History_CardsPerLabel';
  /**
   * The board history API has limits on how many actions can be processed. This field
   * says whether or not the result being returned is complete or not.
   */
  complete: Scalars['Boolean'];
  /** The timeseries for each of the board's Labels */
  series: Array<Board_History_CardsPerLabel_Series>;
};

/** A Label history timeseries */
export type Board_History_CardsPerLabel_Series = {
  __typename: 'Board_History_CardsPerLabel_Series';
  /** The data points of the timeseries */
  dataPoints: Array<Board_History_CardsPerLabel_Series_DataPoint>;
  /** The id of the Label the history is for */
  idLabel: Scalars['ID'];
};

export type Board_History_CardsPerLabel_Series_DataPoint = {
  __typename: 'Board_History_CardsPerLabel_Series_DataPoint';
  /** The data point timestamp */
  dateTime: Scalars['String'];
  /** The number of cards in the Label */
  value: Scalars['Int'];
};

/** A board's cardsPerList history */
export type Board_History_CardsPerList = {
  __typename: 'Board_History_CardsPerList';
  /**
   * The board history API has limits on how many actions can be processed. This field
   * says whether or not the result being returned is complete or not.
   */
  complete: Scalars['Boolean'];
  /** The timeseries for each of the board's lists */
  series: Array<Board_History_CardsPerList_Series>;
};

/** A list history timeseries */
export type Board_History_CardsPerList_Series = {
  __typename: 'Board_History_CardsPerList_Series';
  /** The data points of the timeseries */
  dataPoints: Array<Board_History_CardsPerList_Series_DataPoint>;
  /** The id of the list the history is for */
  idList: Scalars['ID'];
};

export type Board_History_CardsPerList_Series_DataPoint = {
  __typename: 'Board_History_CardsPerList_Series_DataPoint';
  /** The data point timestamp */
  dateTime: Scalars['String'];
  /** The number of cards in the list */
  value: Scalars['Int'];
};

/** A board's cardsPerMember history */
export type Board_History_CardsPerMember = {
  __typename: 'Board_History_CardsPerMember';
  /**
   * The board history API has limits on how many actions can be processed. This field
   * says whether or not the result being returned is complete or not.
   */
  complete: Scalars['Boolean'];
  /** The timeseries for each of the board's Members */
  series: Array<Board_History_CardsPerMember_Series>;
};

/** A Member history timeseries */
export type Board_History_CardsPerMember_Series = {
  __typename: 'Board_History_CardsPerMember_Series';
  /** The data points of the timeseries */
  dataPoints: Array<Board_History_CardsPerMember_Series_DataPoint>;
  /** The id of the Member the history is for */
  idMember: Scalars['ID'];
};

export type Board_History_CardsPerMember_Series_DataPoint = {
  __typename: 'Board_History_CardsPerMember_Series_DataPoint';
  /** The data point timestamp */
  dateTime: Scalars['String'];
  /** The number of cards in the Member */
  value: Scalars['Int'];
};

/** The type of board membership a board invite link will give a member */
export const Board_Invite_MemberType = {
  /** A normal member */
  Normal: 'normal',
  /** An observer (no write permissions) */
  Observer: 'observer'
} as const;

export type Board_Invite_MemberType = typeof Board_Invite_MemberType[keyof typeof Board_Invite_MemberType];
/**
 * An object containing each of the Label colors used on a board, with their
 * corresponding names. If there are multiple labels using the same color, the first
 * name will be used.
 */
export type Board_LabelNames = {
  __typename: 'Board_LabelNames';
  /** The first black label's name */
  black: Scalars['String'];
  /** The first blue label's name */
  blue: Scalars['String'];
  /** The first green label's name */
  green: Scalars['String'];
  /** The first lime label's name */
  lime: Scalars['String'];
  /** The first orange label's name */
  orange: Scalars['String'];
  /** The first pink label's name */
  pink: Scalars['String'];
  /** The first purple label's name */
  purple: Scalars['String'];
  /** The first red label's name */
  red: Scalars['String'];
  /** The first sky label's name */
  sky: Scalars['String'];
  /** The first yellow label's name */
  yellow: Scalars['String'];
};

/** The limits on the Board */
export type Board_Limits = {
  __typename: 'Board_Limits';
  /** The board-attachment limits */
  attachments: Board_Limits_Attachments;
  /** The board limits */
  boards: Board_Limits_Boards;
  /** The board-card limits */
  cards: Board_Limits_Cards;
  /** The board-checkItem limits */
  checkItems: Board_Limits_CheckItems;
  /** The board-checklist limits */
  checklists: Board_Limits_Checklists;
  /** The board-customFieldOption limits */
  customFieldOptions: Board_Limits_CustomFieldOptions;
  /** The board-customField limits */
  customFields: Board_Limits_CustomFields;
  /** The board-label limits */
  labels: Board_Limits_Labels;
  /** The board-list limits */
  lists: Board_Limits_Lists;
  /** The board-reaction limits */
  reactions: Board_Limits_Reactions;
  /** The board-stickers limits */
  stickers: Board_Limits_Stickers;
};

/** The board-attachment limits */
export type Board_Limits_Attachments = {
  __typename: 'Board_Limits_Attachments';
  /** Attachments per Board limit */
  perBoard: Limit;
  /** Attachments per Card limit */
  perCard: Limit;
};

/** The board limits */
export type Board_Limits_Boards = {
  __typename: 'Board_Limits_Boards';
  /** Total Access Requests per Board limit */
  totalAccessRequestsPerBoard: Limit;
  /** Total Members per Board limit */
  totalMembersPerBoard: Limit;
};

/** The board-card limits */
export type Board_Limits_Cards = {
  __typename: 'Board_Limits_Cards';
  /** Open Cards per Board limit */
  openPerBoard: Limit;
  /** Open Cards per List limit */
  openPerList: Limit;
  /** Total Cards per Board limit */
  totalPerBoard: Limit;
  /** Total Cards per List limit */
  totalPerList: Limit;
};

/** The board-checkItem limits */
export type Board_Limits_CheckItems = {
  __typename: 'Board_Limits_CheckItems';
  /** CheckItems per Checklist Limit */
  perChecklist: Limit;
};

/** The board-checklist limits */
export type Board_Limits_Checklists = {
  __typename: 'Board_Limits_Checklists';
  /** Checklists per Board limit */
  perBoard: Limit;
  /** Checklists per Card limit */
  perCard: Limit;
};

/** The board-customFieldOptions limits */
export type Board_Limits_CustomFieldOptions = {
  __typename: 'Board_Limits_CustomFieldOptions';
  /** CustomFieldOptions per CustomField limit */
  perField: Limit;
};

/** The board-customField limits */
export type Board_Limits_CustomFields = {
  __typename: 'Board_Limits_CustomFields';
  /** CustomFields per Board limit */
  perBoard: Limit;
};

/** The board-labeljj limits */
export type Board_Limits_Labels = {
  __typename: 'Board_Limits_Labels';
  /** Labels per Board limit */
  perBoard: Limit;
};

/** The board-list limits */
export type Board_Limits_Lists = {
  __typename: 'Board_Limits_Lists';
  /** Open Lists per Board limit */
  openPerBoard: Limit;
  /** Total Lists per Board limit */
  totalPerBoard: Limit;
};

/** The board-reaction limits */
export type Board_Limits_Reactions = {
  __typename: 'Board_Limits_Reactions';
  /** Reactions per Action limit */
  perAction: Limit;
  /** Unique Reactions per Action limit */
  uniquePerAction: Limit;
};

/** The board-sticker limits */
export type Board_Limits_Stickers = {
  __typename: 'Board_Limits_Stickers';
  /** Stickers per Card limit */
  perCard: Limit;
};

/** An object representing the response from the removeMemberFromBoard mutation */
export type Board_Member_DeleteResponse = {
  __typename: 'Board_Member_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** An association between a Member and a Board */
export type Board_Membership = {
  __typename: 'Board_Membership';
  /** Whether the Member has been deactivated */
  deactivated: Scalars['Boolean'];
  /** The ID of the Membership */
  id: Scalars['String'];
  /** The ID of the Member */
  idMember: Scalars['String'];
  /** The Member this membership is for */
  member: Member;
  /** The type of Membership this is */
  memberType: Board_Membership_MemberType;
  /** The organization membership type */
  orgMemberType: Organization_Membership_MemberType;
  /** Whether the Member has confirmed their email address */
  unconfirmed: Scalars['Boolean'];
};

/** A filter for the board memberships */
export const Board_Membership_Filter = {
  /** Get the members that are active */
  Active: 'active',
  /** Get the admins */
  Admin: 'admin',
  /** Get the members that are deactivated */
  Deactivated: 'deactivated',
  /** Only get the membership for the active member from the board */
  Me: 'me',
  /** Get the memberType normal memberships */
  Normal: 'normal'
} as const;

export type Board_Membership_Filter = typeof Board_Membership_Filter[keyof typeof Board_Membership_Filter];
/** The type of membership a member has on a Board */
export const Board_Membership_MemberType = {
  /** An admin */
  Admin: 'admin',
  /** A normal member */
  Normal: 'normal',
  /** An observer (no write permissions) */
  Observer: 'observer'
} as const;

export type Board_Membership_MemberType = typeof Board_Membership_MemberType[keyof typeof Board_Membership_MemberType];
/** The preferences for a Board */
export type Board_Prefs = {
  __typename: 'Board_Prefs';
  /** The Board background (can be a color like 'orange' or an ID */
  background: Scalars['String'];
  /** Hex color for the bottom of the background */
  backgroundBottomColor: Scalars['String'];
  /** Whether the background is considered 'dark' or 'light' or 'unknown' */
  backgroundBrightness: Board_Prefs_BackgroundBrightness;
  /** Hex color for the Board background */
  backgroundColor?: Maybe<Scalars['String']>;
  /** The Board background (can be a color like 'orange' or an ID) */
  backgroundImage?: Maybe<Scalars['String']>;
  /** Pre-scaled background images for the Board */
  backgroundImageScaled?: Maybe<Array<Board_Prefs_BackgroundImageScaled>>;
  /** Whether the background should tile */
  backgroundTile: Scalars['Boolean'];
  /** Hex color for the tope of the background */
  backgroundTopColor: Scalars['String'];
  /** Whether a calendar feed is enabled for the Board */
  calendarFeedEnabled: Scalars['Boolean'];
  /** Whether the Board visibility can be set to Enterprise */
  canBeEnterprise: Scalars['Boolean'];
  /** Whether the Board visibility can be set to Organization */
  canBeOrg: Scalars['Boolean'];
  /** Whether the Board visibility can be set to Private */
  canBePrivate: Scalars['Boolean'];
  /** Whether the Board visibility can be set to Public */
  canBePublic: Scalars['Boolean'];
  /** Whether invitations are enabled for the Board */
  canInvite: Scalars['Boolean'];
  /** The Card aging mode */
  cardAging: Board_Prefs_CardAging;
  /** Whether Card covers are enabled */
  cardCovers: Scalars['Boolean'];
  /** The comment permissions for the Board */
  comments: Board_Prefs_Comments;
  /** List of board buttons to not show on header */
  hiddenPluginBoardButtons: Array<Scalars['String']>;
  /** Whether votes from other members are hidden on this Board */
  hideVotes: Scalars['Boolean'];
  /** The invite permissions for the Board */
  invitations: Board_Prefs_Invitations;
  /** Whether this Board is a Template */
  isTemplate: Scalars['Boolean'];
  /** The permission level (visibility) of the Board */
  permissionLevel: Board_Prefs_PermissionLevel;
  /** Whether users are allowed to join the Board without invite */
  selfJoin: Scalars['Boolean'];
  /** List of switcher view preferences for the board header */
  switcherViews: Array<Board_Prefs_SwitcherView>;
  /** Permission level for voting */
  voting: Board_Voting_Permission;
};

/** The brightness of the Board background */
export const Board_Prefs_BackgroundBrightness = {
  Dark: 'dark',
  Light: 'light',
  Unknown: 'unknown'
} as const;

export type Board_Prefs_BackgroundBrightness = typeof Board_Prefs_BackgroundBrightness[keyof typeof Board_Prefs_BackgroundBrightness];
/** A pre-scaled version of the Board background */
export type Board_Prefs_BackgroundImageScaled = {
  __typename: 'Board_Prefs_BackgroundImageScaled';
  height: Scalars['Int'];
  url: Scalars['String'];
  width: Scalars['Int'];
};

/** The card aging mode of the Board */
export const Board_Prefs_CardAging = {
  /** Cards age in Lists */
  Pirate: 'pirate',
  /** Cards don't age */
  Regular: 'regular'
} as const;

export type Board_Prefs_CardAging = typeof Board_Prefs_CardAging[keyof typeof Board_Prefs_CardAging];
/** Board commenting permissions */
export const Board_Prefs_Comments = {
  /** Comments are disabled */
  Disabled: 'disabled',
  /** Board members can comment */
  Members: 'members',
  /** Obververs can comment */
  Observers: 'observers',
  /** Organization members can comment */
  Org: 'org',
  /** Anyone can comment */
  Public: 'public'
} as const;

export type Board_Prefs_Comments = typeof Board_Prefs_Comments[keyof typeof Board_Prefs_Comments];
/** Board invitation permissions */
export const Board_Prefs_Invitations = {
  /** Only admins can invite more Members */
  Admins: 'admins',
  /** All Board Members can invite more Members */
  Members: 'members'
} as const;

export type Board_Prefs_Invitations = typeof Board_Prefs_Invitations[keyof typeof Board_Prefs_Invitations];
/** The permission level (visibility) of an Board */
export const Board_Prefs_PermissionLevel = {
  /** Visible to to Enterprise members */
  Enterprise: 'enterprise',
  /** Visible to the Organization members */
  Org: 'org',
  /** Only visible to Board members */
  Private: 'private',
  /** Visible to everyone */
  Public: 'public'
} as const;

export type Board_Prefs_PermissionLevel = typeof Board_Prefs_PermissionLevel[keyof typeof Board_Prefs_PermissionLevel];
/** The switcher views preference of a Board */
export type Board_Prefs_SwitcherView = {
  __typename: 'Board_Prefs_SwitcherView';
  enabled: Scalars['Boolean'];
  viewType: Board_Prefs_SwitcherView_ViewType;
};

/** The view types on a board */
export const Board_Prefs_SwitcherView_ViewType = {
  Board: 'Board',
  Calendar: 'Calendar',
  Dashboard: 'Dashboard',
  Map: 'Map',
  Table: 'Table',
  Timeline: 'Timeline'
} as const;

export type Board_Prefs_SwitcherView_ViewType = typeof Board_Prefs_SwitcherView_ViewType[keyof typeof Board_Prefs_SwitcherView_ViewType];
/** Board voting permissions */
export const Board_Prefs_Voting = {
  /** Comments are disabled */
  Disabled: 'disabled',
  /** Board members can vote */
  Members: 'members',
  /** Obververs can vote */
  Observers: 'observers',
  /** Organization members can vote */
  Org: 'org',
  /** Anyone can vote */
  Public: 'public'
} as const;

export type Board_Prefs_Voting = typeof Board_Prefs_Voting[keyof typeof Board_Prefs_Voting];
/** View and Copy counts of the Board */
export type Board_Stats = {
  __typename: 'Board_Stats';
  /** Number of copy actions on the board */
  copyCount: Scalars['Int'];
  /** Number of logged in views of the board */
  viewCount: Scalars['Int'];
};

/** Permission level for voting on Board */
export const Board_Voting_Permission = {
  Disabled: 'disabled',
  Private: 'private',
  Public: 'public'
} as const;

export type Board_Voting_Permission = typeof Board_Voting_Permission[keyof typeof Board_Voting_Permission];
/** A sort for the boards being requested */
export const Boards_SortBy = {
  /** sorts by date of the last activity */
  DateLastActivity: 'dateLastActivity'
} as const;

export type Boards_SortBy = typeof Boards_SortBy[keyof typeof Boards_SortBy];
/** A sort direction for the boards being requested */
export const Boards_SortOrder = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type Boards_SortOrder = typeof Boards_SortOrder[keyof typeof Boards_SortOrder];
/** Bulk Edit Plugins on Workspace boards */
export type BulkEditPlugins_Response = {
  __typename: 'BulkEditPlugins_Response';
  plugins: Array<Maybe<Plugin>>;
  updateQueued?: Maybe<Scalars['Boolean']>;
};

/** Butler Buttons schema */
export type ButlerButton = {
  __typename: 'ButlerButton';
  close?: Maybe<Scalars['Boolean']>;
  /**
   * Scalar representing `object`; today this is really just a string,
   * but eventually should represent a full Butler command.
   */
  cmd: Scalars['ButlerCommand'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  idMemberOwner: Scalars['ID'];
  image: Scalars['String'];
  label: Scalars['String'];
  pos: Scalars['Int'];
  type: Scalars['String'];
};

/** Butler Buttons overrides schema */
export type ButlerButtonOverrides = {
  __typename: 'ButlerButtonOverrides';
  idBoard: Scalars['ID'];
  idButton: Scalars['ID'];
  idMember: Scalars['ID'];
  overrideTime: Scalars['Int'];
  overrides: ButlerButtonOverrides_Overrides;
};

/** Butler Buttons override options */
export type ButlerButtonOverrides_Overrides = {
  __typename: 'ButlerButtonOverrides_Overrides';
  enabled: Scalars['Boolean'];
};

export const CalendarView_TimeHorizons = {
  Day: 'day',
  Month: 'month',
  Week: 'week'
} as const;

export type CalendarView_TimeHorizons = typeof CalendarView_TimeHorizons[keyof typeof CalendarView_TimeHorizons];
/** Ad Campaigns in Trello */
export type Campaign = {
  __typename: 'Campaign';
  currentStep: Scalars['String'];
  dateDismissed?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Lists in Trello contain Cards. A Card belongs to exactly one List. */
export type Card = {
  __typename: 'Card';
  /** Address of card location. */
  address?: Maybe<Scalars['String']>;
  /** The Attachments belonging to the card */
  attachments: Array<Attachment>;
  /** Pieces of information about the card that are displayed on the front of the card. */
  badges: Card_Badges;
  /** The Board the Card is on */
  board: Board;
  /** The role/type of the card */
  cardRole?: Maybe<CardRole>;
  /** The states of CheckItems on this card */
  checkItemStates: Array<Card_CheckItem_State>;
  /** The Checklists belonging to the Card */
  checklists: Array<Checklist>;
  /** Whether the card is closed (archived). Note: Archived lists and boards do not cascade archives to cards. A card can have closed: false but be on an archived board. */
  closed: Scalars['Boolean'];
  /** An object containing keys for latitude and longitude whose values are numbers between -180 and 180. */
  coordinates?: Maybe<Card_Coordinates>;
  /** An object containing the cover information of the card. */
  cover?: Maybe<Card_Cover>;
  /** How the Card was created */
  creationMethod?: Maybe<CreationMethod>;
  /** The CustomFieldItems on this Card */
  customFieldItems: Array<CustomFieldItem>;
  /** The CustomFields configured for the Board */
  customFields: Array<CustomField>;
  /** The datetime of the last activity on the card. Note: There are activities that update dateLastActivity that do not create a corresponding action. For instance, updating the name field of a checklist item on a card does not create an action but does update the card and board's dateLastActivity value. */
  dateLastActivity: Scalars['String'];
  /** The description for the card. Up to 16384 chars. */
  desc: Scalars['String'];
  /** If the description includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONString']>;
  /** The due date on the card, if one exists. */
  due?: Maybe<Scalars['String']>;
  /** Whether the due date has been marked complete. */
  dueComplete: Scalars['Boolean'];
  /** The number of minutes before the due date that the Member should be notified. No value indicates the default (5 minutes). */
  dueReminder?: Maybe<Scalars['String']>;
  /** The email address of the Card, emails sent to this address will appear as a comment by the current Member on the Card */
  email?: Maybe<Scalars['String']>;
  /** The ID of the card. */
  id: Scalars['ID'];
  /** The id of the attachment selected as the cover image, if one exists. */
  idAttachmentCover?: Maybe<Scalars['ID']>;
  /** The ID of the board the card is on. */
  idBoard: Scalars['ID'];
  /** An array of checklist IDs that are on this card. */
  idChecklists: Array<Scalars['ID']>;
  /** An array of label IDs that are on this card. */
  idLabels: Array<Scalars['ID']>;
  /** The ID of the list the card is in. */
  idList: Scalars['ID'];
  /** An array of member IDs that are on this card. */
  idMembers: Array<Scalars['ID']>;
  /** An array of member IDs who have voted on this card. */
  idMembersVoted: Array<Scalars['ID']>;
  /** Numeric ID for the card on this board. Only unique to the board, and subject to change as the card moves. */
  idShort: Scalars['Int'];
  /** Whether this Card is a Template */
  isTemplate: Scalars['Boolean'];
  /** The Labels on this Card */
  labels: Array<Label>;
  /** The limits on the Card */
  limits: Card_Limits;
  /** The List the Card is on */
  list: List;
  /** Name of card location. */
  locationName?: Maybe<Scalars['String']>;
  /** Whether the card cover image was selected automatically by Trello, or manually by the user. */
  manualCoverAttachment: Scalars['Boolean'];
  /** The members on this card */
  members: Array<Member>;
  /** Name of the card. */
  name: Scalars['String'];
  /** The PluginData for this Card */
  pluginData: Array<PluginData>;
  /** Position of the card in the list. */
  pos: Scalars['Float'];
  /** The role/type whose criteria are met by the card */
  possibleCardRole?: Maybe<CardRole>;
  /** The 8 character shortened ID for the card. */
  shortLink: Scalars['String'];
  /** URL to the card without the name slug. */
  shortUrl: Scalars['String'];
  /** Start date of the card */
  start: Scalars['String'];
  /** A string containing the signed static map URL for google API */
  staticMapUrl?: Maybe<Scalars['String']>;
  /** The Stickers on the card */
  stickers: Array<Sticker>;
  /** Whether this member is subscribed to the card. */
  subscribed: Scalars['Boolean'];
  /** Full URL to the card, with the name slug. */
  url: Scalars['String'];
};


/** Lists in Trello contain Cards. A Card belongs to exactly one List. */
export type CardAttachmentsArgs = {
  filter?: InputMaybe<Attachment_Filter>;
};


/** Lists in Trello contain Cards. A Card belongs to exactly one List. */
export type CardChecklistsArgs = {
  filter?: InputMaybe<Checklist_Filter>;
};

export type CardEntity = {
  __typename: 'CardEntity';
  due?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  shortLink?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Advanced date for representing relative and absolute dates in views */
export type CardFilter_AdvancedDate = {
  __typename: 'CardFilter_AdvancedDate';
  dateType: Scalars['String'];
  value: Scalars['Int'];
};

export const CardFilter_AdvancedDate_DateType = {
  Absolute: 'absolute',
  Relative: 'relative'
} as const;

export type CardFilter_AdvancedDate_DateType = typeof CardFilter_AdvancedDate_DateType[keyof typeof CardFilter_AdvancedDate_DateType];
/** A Date Range for Workspace Views */
export type CardFilter_Criteria_DateRange = {
  __typename: 'CardFilter_Criteria_DateRange';
  end?: Maybe<CardFilter_AdvancedDate>;
  special?: Maybe<CardFilter_Criteria_DateRange_Special>;
  start?: Maybe<CardFilter_AdvancedDate>;
};

export const CardFilter_Criteria_DateRange_Special = {
  Any: 'any',
  None: 'none'
} as const;

export type CardFilter_Criteria_DateRange_Special = typeof CardFilter_Criteria_DateRange_Special[keyof typeof CardFilter_Criteria_DateRange_Special];
export type CardNotificationData = {
  __typename: 'CardNotificationData';
  id?: Maybe<Scalars['String']>;
  idShort?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  shortLink?: Maybe<Scalars['String']>;
};

export const CardRole = {
  Board: 'board',
  Link: 'link',
  Mirror: 'mirror',
  Separator: 'separator'
} as const;

export type CardRole = typeof CardRole[keyof typeof CardRole];
/** An object containing values necessary to render the front of a card */
export type Card_Badges = {
  __typename: 'Card_Badges';
  /** The number of attachments on the card */
  attachments: Scalars['Int'];
  /** An object containing more granular attachment counts */
  attachmentsByType: Card_Badges_AttachmentsByType;
  /** The count of checkItems on the card */
  checkItems: Scalars['Int'];
  /** The count of checkItems on the card in the 'complete' state */
  checkItemsChecked: Scalars['Int'];
  /** The date of the earliest checkItem due date */
  checkItemsEarliestDue?: Maybe<Scalars['String']>;
  /** The count of comments on the card */
  comments: Scalars['Int'];
  /** A boolean indicating whether the card has a description */
  description: Scalars['Boolean'];
  /** The due date of the Card, if one has been set */
  due?: Maybe<Scalars['String']>;
  /** Whether the due date has been marked as 'complete' */
  dueComplete: Scalars['Boolean'];
  /** Whether the location badge is visible */
  location: Scalars['Boolean'];
  /** The start date of the Card, if one has been set */
  start?: Maybe<Scalars['String']>;
  /** Whether the user is subscribed to the card */
  subscribed: Scalars['Boolean'];
  /** Whether the user has voted on the card */
  viewingMemberVoted: Scalars['Boolean'];
  /** The count of votes on the card */
  votes: Scalars['Int'];
};

/** An object containing counts of attachments by type */
export type Card_Badges_AttachmentsByType = {
  __typename: 'Card_Badges_AttachmentsByType';
  /** The trello-specific attachment counts on the Card */
  trello: Card_Badges_AttachmentsByType_Trello;
};

/** An object containing counts of trello attachments */
export type Card_Badges_AttachmentsByType_Trello = {
  __typename: 'Card_Badges_AttachmentsByType_Trello';
  /** The count of Board attachments on the Card */
  board: Scalars['Int'];
  /** The count of Card attachments on the Card */
  card: Scalars['Int'];
};

export type Card_CheckItem_State = {
  __typename: 'Card_CheckItem_State';
  /** The ID of the CheckItem */
  idCheckItem?: Maybe<Scalars['String']>;
  /** The state of the CheckItem */
  state?: Maybe<CheckItem_State>;
};

/** An object containing keys for latitude and longitude whose values are numbers between -180 and 180 */
export type Card_Coordinates = {
  __typename: 'Card_Coordinates';
  /** The latitude (between -180 and 180) */
  latitude: Scalars['Float'];
  /** The longitude (between -180 and 180) */
  longitude: Scalars['Float'];
};

export type Card_Cover = {
  __typename: 'Card_Cover';
  /** The brightness for the card cover. It is either dark or light. */
  brightness?: Maybe<Card_Cover_Brightness>;
  /** The color that is used as the card cover. */
  color?: Maybe<Card_Cover_Color>;
  /** For image covers, the extracted edge color */
  edgeColor?: Maybe<Scalars['String']>;
  /** The ID of the image attachment used as the card cover. */
  idAttachment?: Maybe<Scalars['String']>;
  /** The ID of the Power-Up that provided the current card cover. */
  idPlugin?: Maybe<Scalars['String']>;
  /** The ID of the uploaded background used as the card cover. */
  idUploadedBackground?: Maybe<Scalars['String']>;
  /** If the cover is an image, an array of generated previews of the image in various sizes */
  scaled?: Maybe<Array<Card_Cover_Scaled>>;
  /** For shared uploaded backgrounds, the url that the image was downloaded from */
  sharedSourceUrl?: Maybe<Scalars['String']>;
  /** The size of the card cover. It is either normal or full. */
  size?: Maybe<Card_Cover_Size>;
};

export const Card_Cover_Brightness = {
  Dark: 'dark',
  Light: 'light'
} as const;

export type Card_Cover_Brightness = typeof Card_Cover_Brightness[keyof typeof Card_Cover_Brightness];
export const Card_Cover_Color = {
  Black: 'black',
  Blue: 'blue',
  Green: 'green',
  Lime: 'lime',
  Orange: 'orange',
  Pink: 'pink',
  Purple: 'purple',
  Red: 'red',
  Sky: 'sky',
  Yellow: 'yellow'
} as const;

export type Card_Cover_Color = typeof Card_Cover_Color[keyof typeof Card_Cover_Color];
export type Card_Cover_Scaled = {
  __typename: 'Card_Cover_Scaled';
  _id: Scalars['String'];
  /** The size of the cover preview in bytes */
  bytes: Scalars['Int'];
  /** The height of the image */
  height: Scalars['Int'];
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'];
  /** The URL to the preview */
  url: Scalars['String'];
  /** The width of the image */
  width: Scalars['Int'];
};

export const Card_Cover_Size = {
  Full: 'full',
  Normal: 'normal'
} as const;

export type Card_Cover_Size = typeof Card_Cover_Size[keyof typeof Card_Cover_Size];
/** An object representing the response from the deleteCard mutation */
export type Card_DeleteResponse = {
  __typename: 'Card_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** A filter for the Cards being requested */
export const Card_Filter = {
  /** Returns all cards that have at least one checkItem assigned to the member. Currently only supported if `member(id: 'me')` is the top-level query. */
  CheckItemsAssigned: 'checkItemsAssigned',
  /** Returns all cards that are closed or in lists that have been archived */
  Closed: 'closed',
  /** Returns all cards that are open in lists that have not been archived */
  Open: 'open',
  /** Returns all template cards */
  Template: 'template',
  /** Returns all open cards in lists that are not closed */
  Visible: 'visible'
} as const;

export type Card_Filter = typeof Card_Filter[keyof typeof Card_Filter];
/** The limits on the Card */
export type Card_Limits = {
  __typename: 'Card_Limits';
  /** The card-attachment limits */
  attachments: Card_Limits_Attachments;
  /** The card-checklist limits */
  checklists: Card_Limits_Checklists;
  /** The card-sticker limits */
  stickers: Card_Limits_Stickers;
};

/** The card-attachment limits */
export type Card_Limits_Attachments = {
  __typename: 'Card_Limits_Attachments';
  /** Attachments per Card limit */
  perCard: Card_Limits_Attachments_PerCard;
};

/** Attachments per Card limit */
export type Card_Limits_Attachments_PerCard = {
  __typename: 'Card_Limits_Attachments_PerCard';
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>;
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'];
  /** The status of the limit */
  status: LimitStatus;
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'];
};

/** The card-checklist limits */
export type Card_Limits_Checklists = {
  __typename: 'Card_Limits_Checklists';
  /** Checklists per Card limit */
  perCard: Card_Limits_Checklists_PerCard;
};

/** Checklists per Card limit */
export type Card_Limits_Checklists_PerCard = {
  __typename: 'Card_Limits_Checklists_PerCard';
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>;
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'];
  /** The status of the limit */
  status: LimitStatus;
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'];
};

/** The card-sticker limits */
export type Card_Limits_Stickers = {
  __typename: 'Card_Limits_Stickers';
  /** Stickers per Card limit */
  perCard: Card_Limits_Stickers_PerCard;
};

/** Stickers per Card limit */
export type Card_Limits_Stickers_PerCard = {
  __typename: 'Card_Limits_Stickers_PerCard';
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>;
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'];
  /** The status of the limit */
  status: LimitStatus;
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'];
};

/** An object representing the response from the removeMemberFromCard mutation */
export type Card_Member_DeleteResponse = {
  __typename: 'Card_Member_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** Authentication for Avalara CertCapture tax integration in the client */
export type CertCaptureToken = {
  __typename: 'CertCaptureToken';
  /** Auth token */
  token: Scalars['String'];
};

/** The information about the channel (stable/beta/alpha) the Member is on and what they have access to */
export type Channels = {
  __typename: 'Channels';
  /** The channel the Member is currently using */
  active: Scalars['String'];
  /** The channels the Member is allowed to use */
  allowed: Array<Scalars['String']>;
  /** Whether the Member is allowed to pick releases from the Channel Switcher */
  dev: Scalars['Boolean'];
};

/**
 * CheckItems in Trello are contained within Checklists on a Card. They represent a single
 * task to be done and can be in an 'incomplete' or 'complete' state
 */
export type CheckItem = {
  __typename: 'CheckItem';
  /** The due date of the check item */
  due?: Maybe<Scalars['String']>;
  /** The ID of the check item. */
  id: Scalars['ID'];
  /** The ID of the checklist the check item is on. */
  idChecklist: Scalars['ID'];
  /** The id of the member assigned to the check item. */
  idMember?: Maybe<Scalars['ID']>;
  /** The name of the check item. */
  name: Scalars['String'];
  /** If the name includes custom emoji, this object will contain the information necessary to display them. */
  nameData?: Maybe<Scalars['JSONString']>;
  /** The position of the check item on the checklist (relative to any other check items on the checklist). */
  pos: Scalars['Float'];
  /** The state of the check item. */
  state: CheckItem_State;
  /** A temporary ID that is returned when creating a new check item */
  temporaryId?: Maybe<Scalars['String']>;
};

/** An object representing the response from the deleteCheckItem mutation */
export type CheckItem_DeleteResponse = {
  __typename: 'CheckItem_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** A filter for the CardItems being requested */
export const CheckItem_Filter = {
  /** Returns all checkItems */
  All: 'all',
  /** Returns all checkItems assigned to the member. Currently only supported if `member(id: 'me')` is the top-level query. */
  Assigned: 'assigned',
  /** Returns all checkItems due in a Checklist. Currently only supported if nested under card_checklist (and optimal if card_checklist='due') */
  Due: 'due',
  /** Returns no checkItems */
  None: 'none'
} as const;

export type CheckItem_Filter = typeof CheckItem_Filter[keyof typeof CheckItem_Filter];
/** The completion state of a CheckItem */
export const CheckItem_State = {
  Complete: 'complete',
  Incomplete: 'incomplete'
} as const;

export type CheckItem_State = typeof CheckItem_State[keyof typeof CheckItem_State];
/** CheckLists are a container for CheckItems on a Card */
export type Checklist = {
  __typename: 'Checklist';
  /** The cards the Checklist is on */
  cards: Array<Card>;
  /** The list of CheckItems contained within this Checklist */
  checkItems: Array<CheckItem>;
  /** The ID of the checklist. */
  id: Scalars['ID'];
  /** The ID of the board the checklist is on. */
  idBoard: Scalars['ID'];
  /** The ID of the card the checklist is on. */
  idCard: Scalars['ID'];
  /** The name of the checklist. */
  name: Scalars['String'];
  /** The position of the checklist on the card (relative to any other checklists on the card). */
  pos: Scalars['Float'];
  /** A temporary ID that is returned when creating a new checklist */
  temporaryId?: Maybe<Scalars['String']>;
};


/** CheckLists are a container for CheckItems on a Card */
export type ChecklistCheckItemsArgs = {
  filter?: InputMaybe<CheckItem_Filter>;
};

/** An object representing the response from the deleteChecklist mutation */
export type Checklist_DeleteResponse = {
  __typename: 'Checklist_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** A filter for the Cardlists being requested */
export const Checklist_Filter = {
  /** Returns all checklists */
  All: 'all',
  /** Returns all checklists that have at least one checkItem assigned to the member. Currently only supported if `member(id: 'me')` is the top-level query. */
  CheckItemsAssigned: 'checkItemsAssigned',
  /** Returns all checklists containing at least one due checkItem. Currently only supported if nested under card */
  Due: 'due',
  /** Return no checklists */
  None: 'none'
} as const;

export type Checklist_Filter = typeof Checklist_Filter[keyof typeof Checklist_Filter];
/**
 * An organization owned by a managed member of an enterprise. This is not a model, but rather just a set
 * of fields of an Organization that is solely used for the enteprise dashboard.
 */
export type ClaimableOrganization = {
  __typename: 'ClaimableOrganization';
  activeMembershipCount: Scalars['Int'];
  /** The most recently updated entity (i.e. board) within the org */
  dateLastActivity?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  idActiveAdmins: Array<Scalars['ID']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  products: Array<Scalars['Int']>;
};

/**
 * The list of claimable organizations (see below), as well as the total count (the endpoint does not return
 * all of them)
 */
export type ClaimableOrganizations = {
  __typename: 'ClaimableOrganizations';
  count: Scalars['Int'];
  cursor?: Maybe<Scalars['String']>;
  organizations: Array<ClaimableOrganization>;
};

export type CommentEntity = {
  __typename: 'CommentEntity';
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Configuration for creating a CustomField */
export type CreateCustomField_Display = {
  /** Whether the CustomField should be displayed on the card front */
  cardFront: Scalars['Boolean'];
};

export type CreateCustomField_Option = {
  /** The color of the CustomField option (can be 'none') */
  color: Scalars['String'];
  /** The value for the CustomField option */
  value: CreateCustomField_Option_Value;
};

export type CreateCustomField_Option_Value = {
  /** The text value for a CustomField option */
  text: Scalars['String'];
};

export type CreateDashboardViewTile = {
  from?: InputMaybe<CreateDashboardViewTile_From>;
  graph: CreateDashboardViewTile_Graph;
  pos: Scalars['Int'];
  type: Scalars['String'];
};

export type CreateDashboardViewTile_From = {
  dateType: Scalars['String'];
  value: Scalars['Int'];
};

export type CreateDashboardViewTile_Graph = {
  type: Scalars['String'];
};

/** How an item was created */
export const CreationMethod = {
  /** Item was generated automatically, but with some member input. eg. Cards created through the onboarding flow */
  Assisted: 'assisted',
  /** Item was generated without the member input, eg. the ToDo board created for new users */
  Automatic: 'automatic',
  /** Item was created to demonstrate Trello features. eg. Cards on the welcome board */
  Demo: 'demo'
} as const;

export type CreationMethod = typeof CreationMethod[keyof typeof CreationMethod];
/** A Credit indicates a 'free reward' (typically free bc or gold membership) */
export type Credit = {
  __typename: 'Credit';
  /** Whether the credits have been applied */
  applied: Scalars['Boolean'];
  /** The count of credits */
  count: Scalars['Int'];
  /** The type of count */
  countType: Scalars['String'];
  /** The ID of the credit */
  id: Scalars['String'];
  /** The ID of the member that was invited to earn these credits */
  idMemberInvited?: Maybe<Scalars['String']>;
  /** The ID of the model these credits are for */
  idModel: Scalars['String'];
  /** The member that was invited to earn these credits */
  memberInvited?: Maybe<Member>;
  /** The type of entity these credits are for (Member or Organization) */
  modelType: Scalars['String'];
  /** The reward for the Credit (gold or bc) */
  reward?: Maybe<Credit_Reward>;
  /** The type of Credit this is */
  type: Credit_Type;
  /** A description of how the Credit was rewarded */
  via?: Maybe<Scalars['String']>;
};

/** A reward applicable to a Credit */
export const Credit_Reward = {
  Bc: 'bc',
  Gold: 'gold'
} as const;

export type Credit_Reward = typeof Credit_Reward[keyof typeof Credit_Reward];
/** The type of the Credit */
export const Credit_Type = {
  FreeTrial: 'freeTrial',
  Invitation: 'invitation',
  PromoCode: 'promoCode',
  Support: 'support'
} as const;

export type Credit_Type = typeof Credit_Type[keyof typeof Credit_Type];
/** A configurable field that can be added to a Card, and optionally shown on the Card Front */
export type CustomField = {
  __typename: 'CustomField';
  /** The display options for the CustomField */
  display: CustomField_Display;
  /** The computed has of the name and type fields of this CustomField (sometimes used for grouping) */
  fieldGroup: Scalars['String'];
  /** The ID of the CustomField */
  id: Scalars['ID'];
  /** The ID of the model that the CustomField is configured for */
  idModel: Scalars['String'];
  /** Whether the custom field is a suggested field */
  isSuggestedField: Scalars['Boolean'];
  /** The type of the model that the CustomField is on (currently only Board) */
  modelType: Scalars['String'];
  /** The name of this Custom Field */
  name: Scalars['String'];
  /** The list of options available to a 'list' CustomField */
  options?: Maybe<Array<CustomField_Option>>;
  /** The position (on the Card back and Card front) of the CustomField relative to others */
  pos: Scalars['Int'];
  /** The type of CustomField this is */
  type: CustomField_Type;
};

/** An item representing a value for a particular CustomField on a Card */
export type CustomFieldItem = {
  __typename: 'CustomFieldItem';
  /** The ID of the CustomFieldItem */
  id: Scalars['ID'];
  /** The ID of the CustomField that this item holds a value for */
  idCustomField: Scalars['String'];
  /** The ID of the model this CustomFieldItem is on (the Card ID) */
  idModel: Scalars['String'];
  /** The id for the CustomField list option */
  idValue: Scalars['String'];
  /** The type of model this CustomFieldItem is on (only Cards are supported) */
  modelType: CustomFieldItem_ModelType;
  /** The value for this CustomFieldItem, the shape of this data depends on the type of CustomField this is for */
  value: Scalars['JSONString'];
};

/** The type of model a CustomFieldItem is on (only Cards are supported) */
export const CustomFieldItem_ModelType = {
  Card: 'card'
} as const;

export type CustomFieldItem_ModelType = typeof CustomFieldItem_ModelType[keyof typeof CustomFieldItem_ModelType];
/** Configuration for displaying a CustomField */
export type CustomField_Display = {
  __typename: 'CustomField_Display';
  /** Whether the CustomField should be displayed on the card front */
  cardFront: Scalars['Boolean'];
};

/** An option in the 'list' CustomField */
export type CustomField_Option = {
  __typename: 'CustomField_Option';
  /** The color of the CustomField option (can be 'none') */
  color: Scalars['String'];
  /** The ID of the CustomField option */
  id: Scalars['ID'];
  /** The ID of the CustomField this option belongs to */
  idCustomField: Scalars['String'];
  /** An integer indicating the position of the CustomField Option in its list */
  pos: Scalars['Int'];
  /** The value for the CustomField option */
  value: CustomField_Option_Value;
};

/** The value for a CustomField option */
export type CustomField_Option_Value = {
  __typename: 'CustomField_Option_Value';
  /** The text value for a CustomField option */
  text: Scalars['String'];
};

/** The type of a CustomField */
export const CustomField_Type = {
  Checkbox: 'checkbox',
  Date: 'date',
  List: 'list',
  Number: 'number',
  Text: 'text'
} as const;

export type CustomField_Type = typeof CustomField_Type[keyof typeof CustomField_Type];
/**
 * Organization within this block refers to the conceptional container for a
 * real world entity and is either represented as the users Enterprise or
 * implicitly from the domain that the user belongs to through their email
 * address.
 */
export type DomainOrganization = {
  __typename: 'DomainOrganization';
  /**
   * The Enterprise's displayName. If the Enterprise is backed by an
   * actual Enterprise entity in Mongo, this will be an actual Organization
   * name like "Nike". If the Enterprise is not represented by an actual DB
   * entity, it will be a domain, like "nike.com".
   */
  displayName: Scalars['String'];
  /**
   * The domains that are assigned to the organization, if there is an
   * Enterprise there may be more that one, if this is implicit then it
   * will only contain a single domain.
   */
  domains: Array<Maybe<Scalars['String']>>;
  /** The enterprise id for this organization. */
  idEnterprise?: Maybe<Scalars['ID']>;
  /** This is the "Workspaces" that belong to this "Organization" entity. */
  organizations: Array<Organization>;
  /** A map of extra meta data about the "Workspaces" within this "Organization" entity. */
  organizationsInfo: Array<Maybe<DomainOrganizationInformation>>;
  /** The counts of boards, members and workspaces in the domain */
  stats?: Maybe<DomainStats>;
};


/**
 * Organization within this block refers to the conceptional container for a
 * real world entity and is either represented as the users Enterprise or
 * implicitly from the domain that the user belongs to through their email
 * address.
 */
export type DomainOrganizationOrganizationsArgs = {
  filter?: InputMaybe<Organization_Filter>;
};

export type DomainOrganizationAdmin = {
  __typename: 'DomainOrganizationAdmin';
  /** Avatar url of the Admin */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Name of the Admin */
  fullName: Scalars['String'];
  /** id of the Admin */
  id: Scalars['ID'];
};

/** Extra meta data about the "Workspace" within this "Organization" entity. */
export type DomainOrganizationInformation = {
  __typename: 'DomainOrganizationInformation';
  /** Details of the admins of this "Workspace" */
  admins: Array<Maybe<DomainOrganizationAdmin>>;
  /**
   * The date the "Workspace" was last active. This is the
   * date that the last activity occurred on one of the Workspace's
   * Boards.
   */
  dateLastActivity?: Maybe<Scalars['String']>;
  /** id of the "Workspace" */
  id: Scalars['ID'];
  /** The membership type of the current member */
  memberType: DomainOrganizationInformationMemberType;
  /** Number of boards in this "Workspace" */
  orgBoardsCount: Scalars['Int'];
  /** Number of members in this "Workspace" */
  orgMembersCount: Scalars['Int'];
};

/** The type of membership a member has on an "Workspace" */
export const DomainOrganizationInformationMemberType = {
  /** An admin */
  Admin: 'admin',
  /** A guest */
  Guest: 'guest',
  /** A non-member */
  None: 'none',
  /** A normal member */
  Normal: 'normal'
} as const;

export type DomainOrganizationInformationMemberType = typeof DomainOrganizationInformationMemberType[keyof typeof DomainOrganizationInformationMemberType];
export type DomainStats = {
  __typename: 'DomainStats';
  /** Number of boards in the Domain */
  boardsCount?: Maybe<Scalars['Int']>;
  /** Number of members in the Domain */
  membersCount?: Maybe<Scalars['Int']>;
  /** Number of workspaces in the Domain */
  organizationsCount?: Maybe<Scalars['Int']>;
  /** Number of private workspaces in the domain */
  privateOrganizationsCount?: Maybe<Scalars['Int']>;
};

export type DueEntity = {
  __typename: 'DueEntity';
  current?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** The name and url of a given email provider that is retrieved from the MX records for a given email address */
export type EmailProvider = {
  __typename: 'EmailProvider';
  /** Name of the email provider e.g. Gmail */
  name: Scalars['String'];
  /** Url to the providers inbox */
  url: Scalars['String'];
};

/** An Enterprise in Trello is made up of many Organizations (teams) */
export type Enterprise = {
  __typename: 'Enterprise';
  /** The timestamp of when Atlassian Access was enabled for the enterprise */
  accessEnabled?: Maybe<Scalars['String']>;
  /** The display name of the associated Atlassian organization, if one exists */
  atlOrgDisplayName?: Maybe<Scalars['String']>;
  /** The parent organization in Atlassian */
  atlOrgId?: Maybe<Scalars['ID']>;
  /** The Auditlog for Enterprises actions */
  auditlog: Array<Enterprise_Auditlog>;
  /** A list of teams that can be claimed by an enterprise */
  claimableOrganizations: ClaimableOrganizations;
  /** The display name of the Enterprise */
  displayName: Scalars['String'];
  /** Domains claimed by the Enterprise */
  enterpriseDomains: Array<Scalars['String']>;
  /** Most recent export for this enterprise */
  export?: Maybe<Export>;
  /** The Exports on this Enterprise */
  exports: Array<Export>;
  /** Whether this Enterprise has Atlassian Access */
  hasAtlassianAccess: Scalars['Boolean'];
  /** Whether this Enterprise has any claimed domains */
  hasClaimedDomains: Scalars['Boolean'];
  /** The ID of the Enterprise */
  id: Scalars['ID'];
  /** The ids of the admins in the enterprise */
  idAdmins: Array<Scalars['String']>;
  /** The ids of the plugins allowed on the Enterprise */
  idPluginsAllowed: Array<Scalars['String']>;
  /** Whether this Enterprise is associated with an Atlassian organization */
  isAtlassianOrg: Scalars['Boolean'];
  isEnterpriseWithoutSSO: Scalars['Boolean'];
  /** Whether this Enterprise is really an Enterprise, or a Business Class Purchase Order (BCPO) 'Enterprise' */
  isRealEnterprise: Scalars['Boolean'];
  /** Data regarding the Enterprise's licenses */
  licenses: Enterprise_Licenses;
  /** The hash of the custom logo for the Enterprise */
  logoHash?: Maybe<Scalars['String']>;
  /** The URL of the custom logo for the Enterprise */
  logoUrl?: Maybe<Scalars['String']>;
  /** A list of the enterprise's members who have issues consent tokens for third-party apps */
  managedMembersWithTokens: Array<Member>;
  /** The name of the Enterprise */
  name: Scalars['String'];
  /** The overridden prefs for individual Organizations owned by the Enterprise */
  organizationPrefs: Organization_Prefs;
  /** Information about the paid account of Enterprise */
  paidAccount?: Maybe<PaidAccount>;
  /** Whether the Enterprise has enabled plugin whitelisting restrictions */
  pluginWhitelistingEnabled: Scalars['Boolean'];
  /** The preferences for the Enterprise */
  prefs?: Maybe<Enterprise_Prefs>;
  /** The product code (SKU) that the enterprise is billed under */
  products: Array<Scalars['Int']>;
  /** Boolean for whether the max attempts for sso activation was reached */
  ssoActivationFailed: Scalars['Boolean'];
  ssoDateDelayed?: Maybe<Scalars['String']>;
  /** Data used to represent the effects of transferring an organization to an enterprise */
  transferrableData: Array<Maybe<TransferrableData>>;
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseClaimableOrganizationsArgs = {
  activeSince?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  inactiveSince?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseExportArgs = {
  idEnterprise: Scalars['ID'];
  idExport: Scalars['ID'];
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseExportsArgs = {
  id: Scalars['ID'];
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseManagedMembersWithTokensArgs = {
  filter?: InputMaybe<Scalars['String']>;
};


/** An Enterprise in Trello is made up of many Organizations (teams) */
export type EnterpriseTransferrableDataArgs = {
  idOrganizations: Array<InputMaybe<Scalars['ID']>>;
};

export type EnterpriseEntity = {
  __typename: 'EnterpriseEntity';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Describing the items inside the audit log */
export type Enterprise_Auditlog = {
  __typename: 'Enterprise_Auditlog';
  board?: Maybe<Board>;
  date: Scalars['String'];
  idAction: Scalars['ID'];
  member?: Maybe<Member>;
  memberCreator?: Maybe<Member>;
  organization?: Maybe<Organization>;
  plugin?: Maybe<Plugin>;
  type: Action_Type;
};

/** An object representing the response from the deleteAllManagedMemberTokens mutation */
export type Enterprise_DeleteAllManagedMemberTokensResponse = {
  __typename: 'Enterprise_DeleteAllManagedMemberTokensResponse';
  success: Scalars['Boolean'];
};

/** An object representing the response from the deleteManagedMemberTokens mutation */
export type Enterprise_DeleteManagedMemberTokensResponse = {
  __typename: 'Enterprise_DeleteManagedMemberTokensResponse';
  success: Scalars['Boolean'];
};

/** A filter for the Enterprises being requested */
export const Enterprise_Filter = {
  Member: 'member',
  MemberUnconfirmed: 'memberUnconfirmed',
  /** Only Enterprises that 'own' the Member */
  Owned: 'owned',
  Saml: 'saml'
} as const;

export type Enterprise_Filter = typeof Enterprise_Filter[keyof typeof Enterprise_Filter];
export type Enterprise_Licenses = {
  __typename: 'Enterprise_Licenses';
  /** The maximum number of members allowed in the Enterprise without purchasing additional seats */
  maxMembers?: Maybe<Scalars['Int']>;
  /** The number of members in the Enterprise */
  totalMembers: Scalars['Int'];
};

/** An object representing the response from the linkEnterpriseWithAtlassianOrganization mutation */
export type Enterprise_LinkAtlassianOrganizationResponse = {
  __typename: 'Enterprise_LinkAtlassianOrganizationResponse';
  success?: Maybe<Scalars['Boolean']>;
};

/** Represents the preferences of an Enterprise */
export type Enterprise_Prefs = {
  __typename: 'Enterprise_Prefs';
  /** The custom branding color for the Enterprise */
  brandingColor?: Maybe<Scalars['String']>;
  /** Whether managed members of the enterprise can issue consent tokens for third-party apps */
  canIssueManagedConsentTokens: Scalars['Boolean'];
  /** Expansion method the enterprise will use to request more seats */
  selfServiceExpansionType?: Maybe<Expansion_Type>;
  /** Whether SSO login is enforced for managed users */
  ssoOnly: Scalars['Boolean'];
};

/** Self Serve Expansion Price Estimate */
export type ExpansionPriceEstimate = {
  __typename: 'ExpansionPriceEstimate';
  dtEnd: Scalars['String'];
  dtStart: Scalars['String'];
  nLicenseSeats: Scalars['Int'];
  nTotal: Scalars['Float'];
};

export const Expansion_Type = {
  /** Enterprise does not have an expansion option and will contact sales */
  Disabled: 'disabled',
  /** Enterprise can participate in self service expansion */
  Purchase: 'purchase',
  /** Enterprise can submit a GSAC ticket to request more seats */
  Ticket: 'ticket'
} as const;

export type Expansion_Type = typeof Expansion_Type[keyof typeof Expansion_Type];
export type Export = {
  __typename: 'Export';
  exportUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  size?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['String']>;
  status: ExportStatus;
};

export const ExportStage = {
  CreatingArchive: 'Creating_archive',
  ExportCompleted: 'Export_completed',
  ExportFailed: 'Export_failed',
  ExportQueued: 'Export_queued',
  FetchingBoardData: 'Fetching_board_data',
  PreparingToExport: 'Preparing_to_export'
} as const;

export type ExportStage = typeof ExportStage[keyof typeof ExportStage];
export type ExportStatus = {
  __typename: 'ExportStatus';
  attempts: Scalars['Int'];
  finished: Scalars['Boolean'];
  stage: ExportStage;
};

export const GrantCheckProduct = {
  Avocado: 'AVOCADO',
  Compass: 'COMPASS',
  Confluence: 'CONFLUENCE',
  Jira: 'JIRA',
  JiraServicedesk: 'JIRA_SERVICEDESK',
  /** Don't check whether a user has been granted access to a specific site(cloudId) */
  NoGrantChecks: 'NO_GRANT_CHECKS'
} as const;

export type GrantCheckProduct = typeof GrantCheckProduct[keyof typeof GrantCheckProduct];
export type GuestOrganization = {
  __typename: 'GuestOrganization';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  logoHash?: Maybe<Scalars['String']>;
};

export type InputButlerButton = {
  close?: InputMaybe<Scalars['Boolean']>;
  cmd: Scalars['ButlerCommand'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  image: Scalars['String'];
  label: Scalars['String'];
  shared?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

/** Advanced date for representing relative and absolute dates in views */
export type InputCardFilter_AdvancedDate = {
  dateType: Scalars['String'];
  value: Scalars['Int'];
};

/** Organization View card filter criteria input */
export type InputCardFilter_Criteria = {
  due?: InputMaybe<InputCardFilter_Criteria_DateRange>;
  dueComplete?: InputMaybe<Scalars['Boolean']>;
  /** A list of board IDs whose cards will be included in the view */
  idBoards?: InputMaybe<Array<Scalars['ID']>>;
  idLists?: InputMaybe<Array<Scalars['ID']>>;
  idMembers?: InputMaybe<Array<Scalars['String']>>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  start?: InputMaybe<InputCardFilter_Criteria_DateRange>;
};

/** OrganizationView CardFilter DateRange */
export type InputCardFilter_Criteria_DateRange = {
  end?: InputMaybe<InputCardFilter_AdvancedDate>;
  special?: InputMaybe<CardFilter_Criteria_DateRange_Special>;
  start?: InputMaybe<InputCardFilter_AdvancedDate>;
};

export type InputCover = {
  brightness?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  idAttachment?: InputMaybe<Scalars['String']>;
  idUploadedBackground?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Input for updating a label */
export type InputLabel = {
  /** The color of the label. */
  color?: InputMaybe<Label_Color>;
  /** The ID of the Label */
  id: Scalars['ID'];
  /** The ID of the board the label is on. */
  idBoard: Scalars['String'];
  /** The name of the label. */
  name?: InputMaybe<Scalars['String']>;
};

/** Top level OrganizationView model input for updating an organizationView */
export type InputOrganizationView = {
  /** The name of the organization view */
  name?: InputMaybe<Scalars['String']>;
  /** An object that describes the permission level of the organization view */
  prefs?: InputMaybe<InputOrganizationView_Prefs>;
};

/** Prefs argument for creating and updating Organization Views */
export type InputOrganizationView_Prefs = {
  /** The permission level for the organizaiton view. Currently we support 'team' and 'private' */
  permissionLevel: OrganizationView_Prefs_PermissionLevel;
};

/** A single view argument for creating and updating Organzation Views */
export type InputOrganizationView_View = {
  /** An object specifying which cards to include in the view */
  cardFilter?: InputMaybe<InputOrganizationView_View_CardFilter>;
  /** The type of visualization this view uses, such as 'table' or 'timeline' */
  defaultViewType?: InputMaybe<Scalars['String']>;
  /** Options specific to individual views */
  viewOptions?: InputMaybe<InputOrganizationView_View_ViewOptions>;
};

/** Organization View card filter input */
export type InputOrganizationView_View_CardFilter = {
  /** An object specifying the criteria that determines which cards are included in the view */
  criteria?: InputMaybe<Array<InputCardFilter_Criteria>>;
};

export type InputOrganizationView_View_ViewOptions = {
  Calendar?: InputMaybe<InputOrganizationView_View_ViewOptions_Calendar>;
};

export type InputOrganizationView_View_ViewOptions_Calendar = {
  timeHorizon: Scalars['String'];
};

export type InputPluginListing = {
  /** The description of the plugin. */
  description: Scalars['String'];
  /** The locale of the listing. */
  locale: Scalars['String'];
  /** The name of the plugin. */
  name: Scalars['String'];
  /** The overview of the plugin. */
  overview: Scalars['String'];
};

export type InputSavedSearch = {
  name: Scalars['String'];
  pos: Scalars['Int'];
  query: Scalars['String'];
};

/** The input for the switcher views preference of a Board */
export type Input_Board_Prefs_SwitcherView = {
  enabled: Scalars['Boolean'];
  viewType: Board_Prefs_SwitcherView_ViewType;
};

/** Response from adding a member to a team */
export type InviteMember_Response = {
  __typename: 'InviteMember_Response';
  success: Scalars['Boolean'];
};

/** Labels are defined per board, and can be applied to the cards on that board */
export type Label = {
  __typename: 'Label';
  /** The color of the label. */
  color?: Maybe<Label_Color>;
  /** The ID of the Label */
  id: Scalars['ID'];
  /** The ID of the board the label is on. */
  idBoard: Scalars['String'];
  /** The name of the label. */
  name: Scalars['String'];
};

export const Label_Color = {
  Black: 'black',
  BlackDark: 'black_dark',
  BlackLight: 'black_light',
  Blue: 'blue',
  BlueDark: 'blue_dark',
  BlueLight: 'blue_light',
  Green: 'green',
  GreenDark: 'green_dark',
  GreenLight: 'green_light',
  Lime: 'lime',
  LimeDark: 'lime_dark',
  LimeLight: 'lime_light',
  Orange: 'orange',
  OrangeDark: 'orange_dark',
  OrangeLight: 'orange_light',
  Pink: 'pink',
  PinkDark: 'pink_dark',
  PinkLight: 'pink_light',
  Purple: 'purple',
  PurpleDark: 'purple_dark',
  PurpleLight: 'purple_light',
  Red: 'red',
  RedDark: 'red_dark',
  RedLight: 'red_light',
  Sky: 'sky',
  SkyDark: 'sky_dark',
  SkyLight: 'sky_light',
  Yellow: 'yellow',
  YellowDark: 'yellow_dark',
  YellowLight: 'yellow_light'
} as const;

export type Label_Color = typeof Label_Color[keyof typeof Label_Color];
/** An object representing the response from the deleteLabel mutation */
export type Label_DeleteResponse = {
  __typename: 'Label_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** A filter for the Labels being requested */
export const Label_Filter = {
  /** Get all of the labels */
  All: 'all',
  /** Get none of the labels */
  None: 'none'
} as const;

export type Label_Filter = typeof Label_Filter[keyof typeof Label_Filter];
/** An object containing information about a Limit */
export type Limit = {
  __typename: 'Limit';
  /** The count that the limited number is currently at. Will only be populated for limits over the warn threshold */
  count?: Maybe<Scalars['Int']>;
  /** The threshold at which a limit will enter the 'disabled'/'maxExceeded' status */
  disableAt: Scalars['Int'];
  /** The status of the limit */
  status: LimitStatus;
  /** The threshold at which a limit will enter the 'warn' status */
  warnAt: Scalars['Int'];
};

/** The status of a Limit */
export const LimitStatus = {
  /** The limit is at the disabled threshold */
  Disabled: 'disabled',
  /** The limit is over the disabled thershold */
  MaxExceeded: 'maxExceeded',
  /** The limit is not within the warning range */
  Ok: 'ok',
  /** The limit is at/over the warning threshold */
  Warn: 'warn'
} as const;

export type LimitStatus = typeof LimitStatus[keyof typeof LimitStatus];
/** A Board is made up of vertical Lists which contain Cards */
export type List = {
  __typename: 'List';
  /** The Board that the List is on */
  board: Board;
  /** The Cards in the List */
  cards: Array<Card>;
  /** Whether the List is closed (archived) */
  closed: Scalars['Boolean'];
  /** How the List was created */
  creationMethod?: Maybe<CreationMethod>;
  /** The ID of the List */
  id: Scalars['String'];
  /** The ID of the Board the List is on */
  idBoard: Scalars['String'];
  /** The limits on the List */
  limits: List_Limits;
  /** The name of the List */
  name: Scalars['String'];
  /** The position of the List on the Board */
  pos: Scalars['Float'];
  /** The 'soft' limit of Cards in the List */
  softLimit?: Maybe<Scalars['Int']>;
  /** Whether the Member is subscribed to this List */
  subscribed: Scalars['Boolean'];
};


/** A Board is made up of vertical Lists which contain Cards */
export type ListCardsArgs = {
  filter?: InputMaybe<Card_Filter>;
};

export type ListEntity = {
  __typename: 'ListEntity';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** List price quotes for a subscriber */
export type ListPriceQuoteInfo = {
  __typename: 'ListPriceQuoteInfo';
  /** The base price quote info */
  base: PriceQuoteInfo;
  /** The price quote info for the subscriber which might reflect a subscriber-specific discount */
  subscriber: PriceQuoteInfo;
};

/** A filter for the Lists being requested */
export const List_Filter = {
  /** Only closed (archived) Lists */
  Closed: 'closed',
  /** Only open Lists */
  Open: 'open'
} as const;

export type List_Filter = typeof List_Filter[keyof typeof List_Filter];
/** The limits on the List */
export type List_Limits = {
  __typename: 'List_Limits';
  /** The list-card limits */
  cards: List_Limits_Cards;
};

/** The list-card limits */
export type List_Limits_Cards = {
  __typename: 'List_Limits_Cards';
  /** Open Cards per List Limit */
  openPerList: Limit;
  /** Total Cards per List Limit */
  totalPerList: Limit;
};

/** A Login method for a Member */
export type Login = {
  __typename: 'Login';
  /** Whether this email address can be claimed by an org */
  claimable: Scalars['Boolean'];
  /** The email address associated with this Login */
  email: Scalars['String'];
  /** The ID of the Login */
  id: Scalars['ID'];
  /** Whether this is the primary login for this user */
  primary: Scalars['Boolean'];
  /** The types of Login methods that can be used with this email */
  types: Array<Member_LoginType>;
};

/** Everyone with a Trello account is called a member. */
export type Member = {
  __typename: 'Member';
  /** Date profile syncing from Atlassian account to Trello will be unblocked on the member */
  aaBlockSyncUntil?: Maybe<Scalars['String']>;
  /** The Atlassian Account email of the member. */
  aaEmail?: Maybe<Scalars['String']>;
  /** The Atlassian Account ID of the member. */
  aaId?: Maybe<Scalars['String']>;
  /** Whether the member has been active recently */
  active?: Maybe<Scalars['Boolean']>;
  /** Whether activity has been blocked for this Member */
  activityBlocked: Scalars['Boolean'];
  /** The agreements made by the member. */
  agreements: Array<Member_Agreement>;
  /** Atlassian organizations the member belongs to. */
  atlassianOrganizations: Array<Member_Atlassian_Organization>;
  avatarHash?: Maybe<Scalars['String']>;
  /** The source of the user's avatar - either via 'upload' or 'gravatar'. */
  avatarSource?: Maybe<Member_AvatarSource>;
  /** The URL of the current avatar being used, regardless of whether it is a gravatar or uploaded avatar. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Banners which might be visible to the member. */
  banners: Array<Member_Banner>;
  /** Optional bio for the member. */
  bio: Scalars['String'];
  /** If the bio includes custom emoji, this object will contain the information necessary to display them. */
  bioData?: Maybe<Scalars['JSONString']>;
  /** The Boards the Member has starred */
  boardStars: Array<BoardStar>;
  /** The boards the user is a member of */
  boards: Array<Board>;
  /** The ad campaigns the member is in */
  campaigns: Array<Campaign>;
  /** The cards the member is on */
  cards: Array<Card>;
  /** The information about the channel (stable/alpha) the Member is on and what they have access to */
  channels?: Maybe<Channels>;
  /** Whether the member has confirmed their email address after signing up. */
  confirmed: Scalars['Boolean'];
  credentials: Array<Member_Credential>;
  /** Count of any credentials removed in Atlassian onboarding process */
  credentialsRemovedCount?: Maybe<Scalars['String']>;
  /** The Credits owned by this Member */
  credits?: Maybe<Array<Credit>>;
  domain?: Maybe<DomainOrganization>;
  /** Date the member was domain claimed by an Atlassian organization */
  domainClaimed?: Maybe<Scalars['String']>;
  /** The primary email address for the member. You can only read your own. */
  email?: Maybe<Scalars['String']>;
  /** The Enterprise licenses granted to the member */
  enterpriseLicenses?: Maybe<Array<Member_EnterpriseLicense>>;
  /** This route returns an enterprise if the member is owned and licensed by an enterprise that has set a value for Enterprise.prefs.personalBoardsOwnership.ownDate. */
  enterpriseToExplicitlyOwnBoards?: Maybe<Member_EnterpriseToExplicitlyOwnBoards>;
  enterpriseWithRequiredConversion?: Maybe<Member_EnterpriseWithRequiredConversion>;
  /** The Enterprises this Member is a part of */
  enterprises: Array<Enterprise>;
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>;
  /** Org id for where the gold promo free trial was activated */
  goldSunsetFreeTrialIdOrganization: Scalars['String'];
  /** Same as avatarUrl above; member profile images are hosted at: https://trello-members.s3.amazonaws.com/{idMember}/{gravatarHash}/{size}.png size can be 30, 50, or 170 string. */
  gravatarHash?: Maybe<Scalars['String']>;
  /** Guest organizations the member belongs to. */
  guestOrganizations: Array<GuestOrganization>;
  /** The ID of the member. */
  id: Scalars['ID'];
  /** An array of board IDs this member is on. */
  idBoards: Array<Scalars['String']>;
  /** The enterprise that 'owns' this Member (i.e this member is owned by a Trello Enterprise customer) */
  idEnterprise?: Maybe<Scalars['String']>;
  /** An array of enterprise IDs this member is an admin of. */
  idEnterprisesAdmin: Array<Scalars['String']>;
  /** Enterprises that have explicitly deactivated this member */
  idEnterprisesDeactivated: Array<Scalars['String']>;
  /** The id of the Member that referred this Member to Trello */
  idMemberReferrer?: Maybe<Scalars['String']>;
  /** An array of organization IDs this member is in. */
  idOrganizations: Array<Scalars['String']>;
  /** An array of organization IDs this member is an admin of. */
  idPremOrgsAdmin: Array<Scalars['String']>;
  /** The member's initials, used for display when there isn't an avatar set. */
  initials?: Maybe<Scalars['String']>;
  /** Whether the member is 'mastered' by Atlassian Account */
  isAaMastered: Scalars['Boolean'];
  /** How many delta updates have been processed by this Member */
  ixUpdate: Scalars['String'];
  /** The limits on this Member */
  limits: Member_Limits;
  /** The types of logins a user can use: password, saml, google, android or atlassian */
  loginTypes?: Maybe<Array<Maybe<Member_LoginType>>>;
  /** The logins for the members. */
  logins: Array<Login>;
  /** Information about if/when the Member has opted in/out of marketing communication */
  marketingOptIn?: Maybe<Member_MarketingOptIn>;
  /** One of: 'normal', 'ghost'. A ghost is an individual who has been invited to join but has not yet created a Trello account. */
  memberType: Member_MemberType;
  /** Information about in-app messages that the Member has dismissed */
  messagesDismissed?: Maybe<Array<Member_MessageDismissed>>;
  /** The information the Member has chosen to be non-public */
  nonPublic?: Maybe<Member_NonPublic>;
  /** Whether non public information is available for the Member */
  nonPublicAvailable: Scalars['Boolean'];
  /** A list of the 'one time messages' that have been dismissed by the member */
  oneTimeMessagesDismissed?: Maybe<Array<Scalars['String']>>;
  /** The organizations the user is a member of */
  organizations: Array<Organization>;
  /** Information about the paid account of Member */
  paidAccount?: Maybe<PaidAccount>;
  /** The PluginData on this Member */
  pluginData: Array<PluginData>;
  /** The preferences (settings) for this member */
  prefs?: Maybe<Member_Prefs>;
  /** The premium features allowed for this member */
  premiumFeatures: Array<PremiumFeatures>;
  /** 10 - member has Trello Gold as a result of being in a Business Class team. 37 - member has monthly Trello Gold. 38 - member has annual Trello Gold. */
  products: Array<Scalars['Int']>;
  /** Object that includes data necessary for Aa onboarding UI */
  requiresAaOnboarding?: Maybe<RequiresAaOnboarding>;
  /** The saved search queries for this Member */
  savedSearches: Array<SavedSearch>;
  sessions: Array<Member_Session>;
  status?: Maybe<Scalars['String']>;
  /** Values that monitor the progress of the automatic board migration into teams */
  teamify: Member_Teamify;
  tokenCount: Scalars['Int'];
  /** The users tokens */
  tokens?: Maybe<Array<Maybe<Token>>>;
  /** The trophies the Member has earned */
  trophies: Array<Scalars['String']>;
  uploadedAvatarHash?: Maybe<Scalars['String']>;
  /** The URL of the uploaded avatar if one has been uploaded. */
  uploadedAvatarUrl?: Maybe<Scalars['String']>;
  /** The URL to the member's profile page. */
  url: Scalars['String'];
  /** The username for the member. What is shown in @mentions for example. */
  username: Scalars['String'];
  /** indicates whether this member would be become a multi-board billable guest */
  wouldBecomeBillableGuest?: Maybe<Scalars['Boolean']>;
};


/** Everyone with a Trello account is called a member. */
export type MemberBoardsArgs = {
  filter?: InputMaybe<Array<InputMaybe<Board_Filter>>>;
};


/** Everyone with a Trello account is called a member. */
export type MemberCardsArgs = {
  filter?: InputMaybe<Card_Filter>;
};


/** Everyone with a Trello account is called a member. */
export type MemberCreditsArgs = {
  filter: Array<Credit_Type>;
};


/** Everyone with a Trello account is called a member. */
export type MemberEnterprisesArgs = {
  filter?: InputMaybe<Array<InputMaybe<Enterprise_Filter>>>;
};


/** Everyone with a Trello account is called a member. */
export type MemberOrganizationsArgs = {
  filter?: InputMaybe<Organization_Filter>;
};

export type MemberEntity = {
  __typename: 'MemberEntity';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** Member as Input for adding a member to a team */
export type MemberOrEmail = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type MemberProfileFields = {
  bio?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** The agreements made by the member */
export type Member_Agreement = {
  __typename: 'Member_Agreement';
  agreementType: Scalars['String'];
  id: Scalars['ID'];
};

/** Atlassian Organizations the member is a part of */
export type Member_Atlassian_Organization = {
  __typename: 'Member_Atlassian_Organization';
  domains: Array<Scalars['String']>;
  flexAuthError: Scalars['Boolean'];
  id: Scalars['ID'];
  idEnterprise: Scalars['ID'];
  isIdentityAdmin: Scalars['Boolean'];
  linked: Scalars['Boolean'];
  name: Scalars['String'];
  ssoUrl: Scalars['String'];
  ssoUrls: Array<Scalars['String']>;
};

/** The source of an avatar */
export const Member_AvatarSource = {
  /** The avatar has been sourced from Atlassian account */
  AtlassianAccount: 'atlassianAccount',
  /** The avatar is hosted by gravatar */
  Gravatar: 'gravatar',
  /** No avatar */
  None: 'none',
  /** The avatar has been uploaded */
  Upload: 'upload'
} as const;

export type Member_AvatarSource = typeof Member_AvatarSource[keyof typeof Member_AvatarSource];
/** Banners that a member may be able to interact with */
export type Member_Banner = {
  __typename: 'Member_Banner';
  dismissible: Scalars['Boolean'];
  id: Scalars['String'];
  message: Scalars['String'];
  meta?: Maybe<Member_BannerMeta>;
  url?: Maybe<Scalars['String']>;
};

export type Member_BannerMeta = {
  __typename: 'Member_BannerMeta';
  totalMembersInDomain?: Maybe<Scalars['Int']>;
  totalWorkspacesInDomain?: Maybe<Scalars['Int']>;
};

export type Member_Credential = {
  __typename: 'Member_Credential';
  email: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

/** An Enterprise license granted to a Member */
export type Member_EnterpriseLicense = {
  __typename: 'Member_EnterpriseLicense';
  /** The ID of the Enterprise that the license is for */
  idEnterprise: Scalars['ID'];
  /** The type of license granted */
  type: Member_EnterpriseLicenseType;
};

/** A type of Enterprise license */
export const Member_EnterpriseLicenseType = {
  /** A user who is a member of an Enterprise board, but has not previously been granted a 'team' license */
  Collaborator: 'collaborator',
  /** The standard enterprise license, designating a paid member of the enterprise */
  Team: 'team'
} as const;

export type Member_EnterpriseLicenseType = typeof Member_EnterpriseLicenseType[keyof typeof Member_EnterpriseLicenseType];
/**
 * This route returns an enterprise if the member is owned and licensed
 * by an enterprise that has set a value for
 * Enterprise.prefs.personalBoardsOwnership.ownDate.
 */
export type Member_EnterpriseToExplicitlyOwnBoards = {
  __typename: 'Member_EnterpriseToExplicitlyOwnBoards';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownDate?: Maybe<Scalars['String']>;
};

export type Member_EnterpriseWithRequiredConversion = {
  __typename: 'Member_EnterpriseWithRequiredConversion';
  displayName?: Maybe<Scalars['String']>;
  prefs?: Maybe<Member_EnterpriseWithRequiredConversionPrefs>;
};

export type Member_EnterpriseWithRequiredConversionPrefs = {
  __typename: 'Member_EnterpriseWithRequiredConversionPrefs';
  mandatoryTransferDate?: Maybe<Scalars['String']>;
  ssoOnly?: Maybe<Scalars['Boolean']>;
};

/** A filter for the Members being requested */
export const Member_Filter = {
  /** Admin members of the Organization or Board */
  Admins: 'admins',
  /** All members of the Organization or Board */
  All: 'all',
  /** None members of the Organization or Board. Dont use with gql */
  None: 'none',
  /** Normal members of the Organization or Board */
  Normal: 'normal',
  /** Owners members of the Organization or Board */
  Owners: 'owners'
} as const;

export type Member_Filter = typeof Member_Filter[keyof typeof Member_Filter];
/** The limits on the Member */
export type Member_Limits = {
  __typename: 'Member_Limits';
  /** The member-board limits */
  boards: Member_Limits_Boards;
  /** The member-organization limits */
  orgs: Member_Limits_Orgs;
};

/** The member-board limits */
export type Member_Limits_Boards = {
  __typename: 'Member_Limits_Boards';
  /** The limit for the total boards per member */
  totalPerMember: Limit;
};

/** The member-organization limits */
export type Member_Limits_Orgs = {
  __typename: 'Member_Limits_Orgs';
  /** The limit for the total organizations per member */
  totalPerMember: Limit;
};

/** The types of logins a user can use */
export const Member_LoginType = {
  Android: 'android',
  Atlassian: 'atlassian',
  Google: 'google',
  Password: 'password',
  Saml: 'saml'
} as const;

export type Member_LoginType = typeof Member_LoginType[keyof typeof Member_LoginType];
/** Information about if/when the Member has opted in/out of marketing communication */
export type Member_MarketingOptIn = {
  __typename: 'Member_MarketingOptIn';
  /** When the Member last opted in/out of marketing communication */
  date: Scalars['String'];
  /** Whether the Member is opted in to marketing communication */
  optedIn: Scalars['Boolean'];
};

/**
 * Whether the member is a registered Trello user or a 'ghost' user
 * created by an email invite
 */
export const Member_MemberType = {
  Ghost: 'ghost',
  Normal: 'normal'
} as const;

export type Member_MemberType = typeof Member_MemberType[keyof typeof Member_MemberType];
/** Information about in-app messages that the Member has dismissed */
export type Member_MessageDismissed = {
  __typename: 'Member_MessageDismissed';
  /** The ID of the MessageDismissed record (not the id of the message itself) */
  _id: Scalars['ID'];
  /** The number of times the message has been dismissed */
  count: Scalars['Int'];
  /** Copy of _id, that gets set via prepareDataForApolloCache. Im not sure why we have _id at all */
  id: Scalars['ID'];
  /** The date the message was last dismissed */
  lastDismissed: Scalars['String'];
  /** The name of the message dismissed */
  name: Scalars['String'];
};

/** The information the Member has chosen to be non-public */
export type Member_NonPublic = {
  __typename: 'Member_NonPublic';
  avatarHash?: Maybe<Scalars['String']>;
  /** The URL of the current avatar being used, regardless of whether it is a gravatar or uploaded avatar. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>;
  /** The member's initials, used for display when there isn't an avatar set. */
  initials?: Maybe<Scalars['String']>;
};

/** The preferences for a Member */
export type Member_Prefs = {
  __typename: 'Member_Prefs';
  /** Whether the user has enabled color blind mode */
  colorBlind: Scalars['Boolean'];
  /** The user's locale preference */
  locale: Scalars['String'];
  /** The default minutes before a due date to send a notification */
  minutesBeforeDeadlineToNotify: Scalars['Int'];
  /** How often the user should receive email summaries */
  minutesBetweenSummaries: Scalars['Int'];
  /** Privacy settings for a user's details */
  privacy: Member_Prefs_Privacy;
  /** The users timezone preference */
  timezoneInfo: Member_Prefs_TimezoneInfo;
  /** The users twoFactor authentication info */
  twoFactor?: Maybe<Member_Prefs_TwoFactor>;
};

/** Privacy settings for a user's details */
export type Member_Prefs_Privacy = {
  __typename: 'Member_Prefs_Privacy';
  /** Privacy setting for displaying the user's avatar */
  avatar: Member_Prefs_PrivacyOption;
  /** Privacy setting for displaying the user's full name */
  fullName: Member_Prefs_PrivacyOption;
};

/** The visibility of a user detail */
export const Member_Prefs_PrivacyOption = {
  /** Visible to collaborators only */
  Collaborator: 'collaborator',
  /** Not visible to anyone */
  Private: 'private',
  /** Visible to everyone */
  Public: 'public'
} as const;

export type Member_Prefs_PrivacyOption = typeof Member_Prefs_PrivacyOption[keyof typeof Member_Prefs_PrivacyOption];
/** Information about a user's Timezone */
export type Member_Prefs_TimezoneInfo = {
  __typename: 'Member_Prefs_TimezoneInfo';
  dateNext: Scalars['String'];
  offsetCurrent: Scalars['Int'];
  offsetNext: Scalars['Int'];
  timezoneCurrent: Scalars['String'];
  timezoneNext: Scalars['String'];
};

/** Information about a user's 2-factor authentication */
export type Member_Prefs_TwoFactor = {
  __typename: 'Member_Prefs_TwoFactor';
  /** Whether 2-factor-auth is enabled for the user */
  enabled: Scalars['Boolean'];
  /** Whether new backup codes are needed for the user */
  needsNewBackups: Scalars['Boolean'];
};

/** Information about members to be invited to a Workspace */
export type Member_Search_Result = {
  __typename: 'Member_Search_Result';
  /** Whether the member has been active recently */
  active?: Maybe<Scalars['Boolean']>;
  /** Whether activity has been blocked for this Member */
  activityBlocked?: Maybe<Scalars['Boolean']>;
  /** Avatar hash of the member */
  avatarHash?: Maybe<Scalars['String']>;
  /** The URL of the current avatar being used, regardless of whether it is a gravatar or uploaded avatar. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** The boards the user is a member of */
  boards: Board;
  /** Whether the member has confirmed their email address after signing up. */
  confirmed?: Maybe<Scalars['Boolean']>;
  /** Whether the Member has been deactivated */
  deactivated?: Maybe<Scalars['Boolean']>;
  /** The primary email address for the member. You can only read your own. */
  email?: Maybe<Scalars['String']>;
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** An array of board IDs this member is on. */
  idBoards?: Maybe<Array<Scalars['String']>>;
  /** The id of the Member that referred this Member to Trello */
  idMemberReferrer?: Maybe<Scalars['String']>;
  /** An array of organization IDs this member is in. */
  idOrganization?: Maybe<Array<Scalars['String']>>;
  /** The member's initials, used for display when there isn't an avatar set. */
  initials?: Maybe<Scalars['String']>;
  joined?: Maybe<Scalars['Boolean']>;
  /** One of: 'normal', 'ghost'. A ghost is an individual who has been invited to join but has not yet created a Trello account. */
  memberType: Organization_Membership_MemberType;
  /** The information the Member has chosen to be non-public */
  nonPublic?: Maybe<Member_NonPublic>;
  /** Whether non public information is available for the Member */
  nonPublicAvailable?: Maybe<Scalars['Boolean']>;
  /** The username for the member. What is shown in @mentions for example. */
  username?: Maybe<Scalars['String']>;
  /** Indicates whether this member would be become a multi-board billable guest */
  wouldBecomeBillableGuest?: Maybe<Scalars['Boolean']>;
};

export type Member_Session = {
  __typename: 'Member_Session';
  data: Member_Session_Data;
  dateCreated: Scalars['String'];
  dateExpires: Scalars['String'];
  dateLastUsed: Scalars['String'];
  id: Scalars['String'];
  ipAddress: Scalars['String'];
  isCurrent: Scalars['Boolean'];
  isRecent: Scalars['Boolean'];
  type: Scalars['String'];
  userAgent: Scalars['String'];
};

export type Member_Session_Data = {
  __typename: 'Member_Session_Data';
  email: Scalars['String'];
};

/** Fields to monitor migrating all boards of a member into a team. */
export type Member_Teamify = {
  __typename: 'Member_Teamify';
  /** The date when auto-migration will run for this user */
  autoMigration?: Maybe<Scalars['String']>;
  /** Number of collaborative teamless boards for a member */
  collaborativeTeamlessBoards: Scalars['Int'];
  /** Whether we added a free trial of BC to the team above */
  createdOrgHasBcTrial?: Maybe<Scalars['Boolean']>;
  /** The id of the new team created to house all boards in the automatic migration */
  idOrgCreated?: Maybe<Scalars['String']>;
  /** The id of the existing team selected to house all boards in the automatic migration */
  idOrgSelected?: Maybe<Scalars['String']>;
  /** Whether a user will be very impacted, not impacted at all, or minorly impacted by the migration */
  impact?: Maybe<Member_Teamify_Impact>;
  /** Whether the user is in an org with at least one other user */
  inCollaborativeOrg?: Maybe<Scalars['Boolean']>;
  /** Number of solo teamless boards for a member */
  soloTeamlessBoards: Scalars['Int'];
  /** Whether migration has started, is running, or has finished */
  state: Member_Teamify_State;
  /** Whether the user has gone through voluntary migration at least once */
  voluntaryDone?: Maybe<Scalars['String']>;
};

export const Member_Teamify_Impact = {
  /** User is likely to be disrupted by us migrating their boards automatically */
  High: 'high',
  /** User is unlikely to be disrupted by us migrating their boards automatically */
  Low: 'low',
  /** User will not be disrupted by automatic migration of boards into teams */
  None: 'none'
} as const;

export type Member_Teamify_Impact = typeof Member_Teamify_Impact[keyof typeof Member_Teamify_Impact];
export const Member_Teamify_State = {
  /** Migration has finished */
  Done: 'done',
  /** Migration has not started */
  Nope: 'nope',
  /** Migration has started but has not finished */
  Pending: 'pending'
} as const;

export type Member_Teamify_State = typeof Member_Teamify_State[keyof typeof Member_Teamify_State];
/** Counts of various membership types on the Board */
export type MembershipCounts = {
  __typename: 'MembershipCounts';
  /** The count of active Members on the Board */
  active?: Maybe<Scalars['Int']>;
  /** The count of admin Members on the Board */
  admin?: Maybe<Scalars['Int']>;
  /** The count of deactivated Members on the Board */
  deactivated?: Maybe<Scalars['Int']>;
  /** 0 or 1 indicating whether you are a Member of the Board */
  me?: Maybe<Scalars['Int']>;
  /** The count of normal Members on the Board */
  normal?: Maybe<Scalars['Int']>;
};

/** Filters for only certain counts to be aggregated on MembershipCounts */
export const MembershipCounts_Filter = {
  Active: 'active',
  Admin: 'admin',
  Deactivated: 'deactivated',
  Me: 'me',
  Normal: 'normal'
} as const;

export type MembershipCounts_Filter = typeof MembershipCounts_Filter[keyof typeof MembershipCounts_Filter];
/** Information on whether an entity is a member or organization, and its corresponding ID. */
export type ModelType = {
  __typename: 'ModelType';
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Create an Agreement for developer terms */
  acceptDeveloperTerms?: Maybe<Member_Agreement>;
  /** Add an attachment to card */
  addAttachmentToCard?: Maybe<Attachment>;
  /** Adds a new board */
  addBoard: Board;
  /** Adds board star to the user */
  addBoardStar?: Maybe<BoardStar>;
  /** Add a Butler button */
  addButlerButton?: Maybe<ButlerButton>;
  /** Adds a campaign */
  addCampaign?: Maybe<Campaign>;
  /** Add a CheckItem to a checklist on a Card */
  addCheckItem?: Maybe<CheckItem>;
  /** Add a Checklist to a Card */
  addChecklist?: Maybe<Checklist>;
  /** Add a List Option to an existing Custom Field */
  addCustomFieldOption?: Maybe<CustomField_Option>;
  /** Adds free trial to an organization */
  addFreeTrial?: Maybe<Organization>;
  /** Adds Member to Board */
  addMemberToBoard?: Maybe<InviteMember_Response>;
  /** Adds Member to Organization */
  addMemberToOrg?: Maybe<InviteMember_Response>;
  /** Adds a message to messagesDismissed */
  addMessageDismissed?: Maybe<Member>;
  /** Adds a message to oneTimeMessagesDismissed */
  addOneTimeMessagesDismissed?: Maybe<Member>;
  /** Add a member to a Plugin's collaborators */
  addPluginCollaborator?: Maybe<Plugin_Collaborators_UpdateResponse>;
  /** Adds a reaction */
  addReaction: Reaction;
  /** Add a saved search */
  addSavedSearch?: Maybe<SavedSearch>;
  /** Adds a tag for the organization */
  addTag?: Maybe<Scalars['Boolean']>;
  /** Applies 3 month bc discount to an organization */
  applyBCDiscount?: Maybe<Scalars['Boolean']>;
  /** Archives a card */
  archiveCard?: Maybe<Card>;
  /** Disable a Power-Up on all boards in a Workspace */
  bulkDisableWorkspacePowerUp?: Maybe<BulkEditPlugins_Response>;
  /** Enable a Power-Up on all boards in a Workspace */
  bulkEnableWorkspacePowerUp?: Maybe<BulkEditPlugins_Response>;
  /** Cancel a Gold paid account */
  cancelGoldPaidAccount: Member;
  /** Cancel a Workspace paid account */
  cancelWorkspacePaidAccount: Organization;
  /** Change card due date */
  changeCardDueDate?: Maybe<Card>;
  /** Changes the current member's primary email */
  changeMemberEmail?: Maybe<Member>;
  /** Put a team under an Enterprise's ownership */
  claimOrganization: Organization;
  /** Close board */
  closeBoard?: Maybe<Board>;
  /** Copies a board to an organization's workspace */
  copyBoardToOrg?: Maybe<Board>;
  /** Copies a card */
  copyCard?: Maybe<Card>;
  /** Create a board invitation secret */
  createBoardInviteSecret?: Maybe<BoardInviteSecret>;
  /** Create a new card */
  createCard?: Maybe<Card>;
  /** Create a new template card */
  createCardTemplate?: Maybe<Card>;
  /** Create a new Custom Field */
  createCustomField?: Maybe<CustomField>;
  createDashboardViewTile: Board_DashboardViewTile;
  /** Creates a label for a board, and optionally adds it to a card */
  createLabel?: Maybe<Label>;
  /** Create a new list in a board */
  createList?: Maybe<List>;
  /** Creates an organization */
  createOrganization?: Maybe<Organization>;
  /** Creates an organization invite secret to be included in the organization invitation link */
  createOrganizationInviteSecret?: Maybe<OrganizationInviteSecretResponse>;
  /** Add a new organization view */
  createOrganizationView?: Maybe<OrganizationView>;
  /** Create a Plugin */
  createPlugin?: Maybe<Plugin>;
  /** Create a Plugin listing */
  createPluginListing?: Maybe<Plugin_Listing>;
  /** Starts a self serve expansions request */
  createSelfServeExpansion?: Maybe<SelfServeExpansionResponse>;
  /** Sign up for Trello Business Class or Trello Standard */
  createWorkspacePaidAccount?: Maybe<Organization>;
  /** Deletes data from a serviced access request */
  deleteAccessRequest?: Maybe<AccessRequest_Response>;
  /** Delete all consent tokens issued by all managed members of the enterprise */
  deleteAllManagedMemberTokens: Enterprise_DeleteAllManagedMemberTokensResponse;
  /** Delete board */
  deleteBoard?: Maybe<Board>;
  /** Delete a Butler Button */
  deleteButlerButton?: Maybe<Scalars['Boolean']>;
  /** Delete a card */
  deleteCard?: Maybe<Card_DeleteResponse>;
  /** Delete a CheckItem from a Checklist on a Card */
  deleteCheckItem?: Maybe<CheckItem_DeleteResponse>;
  /** Delete a Checklist from a Card */
  deleteChecklist?: Maybe<Checklist_DeleteResponse>;
  /** Delete an existing Custom Field */
  deleteCustomField?: Maybe<CustomField>;
  /** Delete an existing Custom Field's List Option */
  deleteCustomFieldOption?: Maybe<CustomField_Option>;
  /** Delete a Tile from a Board's dashboardViewTiles */
  deleteDashboardViewTile?: Maybe<Scalars['Boolean']>;
  /** Delete a label */
  deleteLabel?: Maybe<Label_DeleteResponse>;
  /** Delete all consent tokens issued by a single managed member of the enterprise */
  deleteManagedMemberTokens: Enterprise_DeleteManagedMemberTokensResponse;
  /** Internal endpoint for development and trelloinc members */
  deleteOneTimeMessagesDismissed?: Maybe<Member>;
  /** Deletes the organization */
  deleteOrganization?: Maybe<Scalars['Boolean']>;
  /** Deletes organization invite secret */
  deleteOrganizationInviteSecret?: Maybe<Scalars['Boolean']>;
  /** Deletes the logo for the organization */
  deleteOrganizationLogo?: Maybe<Organization>;
  /** Delete an organization view */
  deleteOrganizationView?: Maybe<Scalars['Boolean']>;
  /** Delete a Plugin */
  deletePlugin?: Maybe<Plugin_DeleteResponse>;
  /** Delete a Plugin's listing */
  deletePluginListing?: Maybe<Plugin_Listing_DeleteResponse>;
  /** Deletes a reaction */
  deleteReaction?: Maybe<Scalars['Boolean']>;
  /** Delete a saved search */
  deleteSavedSearch?: Maybe<SavedSearch>;
  /** Disable a board invitation secret */
  disableBoardInviteSecret?: Maybe<BoardInviteSecret_DeleteResponse>;
  /** Dismisses an Announcement */
  dismissAnnouncement?: Maybe<Announcement_DismissResponse>;
  /** Unset aaBlockSyncUntil immediately */
  enableMemberProfileSync?: Maybe<Member>;
  /** Enable a Plugin on a Board */
  enablePlugin?: Maybe<Plugin_EnableResponse>;
  /** Link an Enterprise to an Atlassian organization */
  linkEnterpriseWithAtlassianOrganization?: Maybe<Enterprise_LinkAtlassianOrganizationResponse>;
  /** Reactivate a canceled Gold paid account */
  reactivateGoldPaidAccount: Member;
  /** Reactivate a canceled Business Class or Standard paid account */
  reactivateWorkspacePaidAccount: Organization;
  /** Redeem a promocode against a workspace */
  redeemPromoCode: Organization;
  /** Remove board star from the user */
  removeBoardStar?: Maybe<Scalars['Boolean']>;
  /** Remove member from board */
  removeMemberFromBoard?: Maybe<Board_Member_DeleteResponse>;
  /** Remove member from card */
  removeMemberFromCard?: Maybe<Card_Member_DeleteResponse>;
  /** Removes Member from a Workspace */
  removeMemberFromWorkspace?: Maybe<RemoveMembersFromWorkspace_Response>;
  /** Remove a member from a Plugin's collaborators */
  removePluginCollaborator?: Maybe<Plugin_Collaborators_UpdateResponse>;
  /** Reopen board */
  reopenBoard?: Maybe<Board>;
  /** Resend verification email */
  resendVerificationEmail?: Maybe<Member>;
  /** Sent board access request */
  sendAccessRequest?: Maybe<AccessRequest_Response>;
  /** Mark all notifications as read */
  setAllNotificationsRead?: Maybe<Notifications_ReadResponse>;
  /** Mark notifications as read/unread by the list of ids */
  setNotificationsRead?: Maybe<Notifications_ReadResponse>;
  /** Start board export */
  startBoardExport?: Maybe<Export>;
  /** Start enterprise export */
  startEnterpriseExport?: Maybe<Export>;
  /** Toggle the auto upgrade for product override */
  toggleAutoUpgrade?: Maybe<Organization>;
  /** Unarchives a card */
  unarchiveCard?: Maybe<Card>;
  /** Set aaBlockSyncUntil to one day in the future */
  unblockMemberProfileSync?: Maybe<Member>;
  /** Updates a board's card covers preference */
  updateBoardCardCoversPref?: Maybe<Board>;
  /** Update board member permission */
  updateBoardMemberPermission?: Maybe<UpdateBoardMemberPermission_Response>;
  /** Update a board's name */
  updateBoardName?: Maybe<Board>;
  /** Updates a board's org. If no boardId is given, the board becomes a personal board. */
  updateBoardOrg?: Maybe<Board>;
  /** Updates board star for the user */
  updateBoardStar?: Maybe<BoardStar>;
  /** Updates a board's switcher views preference */
  updateBoardSwitcherViewsPref?: Maybe<Board>;
  /** Updates a board's visibility. If an orgId is given, the board is also moved into the org. */
  updateBoardVisibility?: Maybe<Board>;
  /** Updates a collection of board's org */
  updateBoardsOrg: Array<Maybe<Board>>;
  /** Update invoice details for a Business Class paid account */
  updateBusinessClassBillingContactDetails: Organization;
  /** Update invoice details for a Business Class paid account */
  updateBusinessClassBillingInvoiceDetails: Organization;
  /** Update the Credit Card on file for a Business Class paid account */
  updateBusinessClassCreditCard: Organization;
  /** Update product associated with a Business Class paid account */
  updateBusinessClassPaidProduct: Organization;
  /** Update the 'calendarFeedEnabled' state of the board */
  updateCalendarFeedEnabledPref?: Maybe<Board>;
  /** Generate a new calendarKey for the board */
  updateCalendarKey?: Maybe<Board>;
  /** Updates a campaign */
  updateCampaign?: Maybe<Campaign>;
  /** Update a card cover */
  updateCardCover?: Maybe<Card>;
  /** Update card start and due date */
  updateCardDates?: Maybe<Card>;
  /** Update a card dueComplete */
  updateCardDueComplete?: Maybe<Card>;
  /** Update labels on a card */
  updateCardLabels?: Maybe<Card>;
  /** Change a card's list */
  updateCardList?: Maybe<Card>;
  /** Change a card's name */
  updateCardName?: Maybe<Card>;
  /** Update the role of a card (board, separator, regular) */
  updateCardRole: Card;
  /** Update the due date of a CheckItem */
  updateCheckItemDueDate?: Maybe<CheckItem>;
  /** Update the name of a CheckItem */
  updateCheckItemName?: Maybe<CheckItem>;
  /** Update the vertical position of a CheckItem in its Checklist */
  updateCheckItemPos?: Maybe<CheckItem>;
  /** Update the 'checked' state of a CheckItem */
  updateCheckItemState?: Maybe<CheckItem>;
  /** Update the name of a Checklist */
  updateChecklistName?: Maybe<Checklist>;
  /** Update the position of a Checklist */
  updateChecklistPos?: Maybe<Checklist>;
  /** Update an existing Custom Field */
  updateCustomField?: Maybe<CustomField>;
  /** Update card custom field items value */
  updateCustomFieldItem?: Maybe<CustomFieldItem>;
  /** Update an existing List Option on an existing Custom Field */
  updateCustomFieldOption?: Maybe<CustomField_Option>;
  updateDashboardViewTile: Board_DashboardViewTile;
  /** Update the setting that determines whether or not managed members can issue consent tokens to third-party apps */
  updateEnterpriseApiTokenCreationPermission?: Maybe<Enterprise>;
  /** Update invoice details for a Gold paid account */
  updateGoldBillingContactDetails: Member;
  /** Update invoice details for a Gold paid account */
  updateGoldBillingInvoiceDetails: Member;
  /** Update product associated with a Gold paid account */
  updateGoldPaidProduct: Member;
  /** Update to show or hide a plugins board buttons on the main header */
  updateHiddenPluginBoardButtonShortcuts?: Maybe<Board>;
  /** Update a Label */
  updateLabel?: Maybe<Label>;
  /** Update the marketing opt in settings for a user */
  updateMarketingOptIn?: Maybe<Member>;
  /** Updates the member's active channel */
  updateMemberActiveChannel?: Maybe<Member>;
  /** Update a member's profile information */
  updateMemberProfile?: Maybe<Member>;
  /** Updates the notification frequency preference for a user */
  updateNotificationEmailFrequency?: Maybe<Member>;
  /** Updates the organization */
  updateOrganization?: Maybe<Organization>;
  /** Update an organization view */
  updateOrganizationView?: Maybe<OrganizationView>;
  /** Update a Plugin */
  updatePlugin?: Maybe<Plugin>;
  /** Set the value for enabling header shortcuts */
  updatePluginHeaderShortcutsEnabled?: Maybe<Board>;
  /** Update a Plugin's listing */
  updatePluginListing?: Maybe<Plugin_Listing>;
  /** Set the teamifyVoluntaryDone field */
  updateTeamifyVoluntaryDone?: Maybe<Member>;
  /** Update the locale of the user */
  updateUserLocale?: Maybe<Member>;
  /** Update a single view within an organizationView */
  updateViewInOrganizationView?: Maybe<OrganizationView>;
  /** Upload a card cover */
  uploadCardCover?: Maybe<Attachment>;
  /** Upload a organization profile image */
  uploadOrganizationImage?: Maybe<Organization>;
};


export type MutationAcceptDeveloperTermsArgs = {
  memberId: Scalars['ID'];
};


export type MutationAddAttachmentToCardArgs = {
  cardId: Scalars['ID'];
  file?: InputMaybe<Scalars['FileUpload']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};


export type MutationAddBoardArgs = {
  creationMethod?: InputMaybe<CreationMethod>;
  defaultLabels?: InputMaybe<Scalars['Boolean']>;
  defaultLists?: InputMaybe<Scalars['Boolean']>;
  desc?: InputMaybe<Scalars['String']>;
  idBoardSource?: InputMaybe<Scalars['ID']>;
  idOrganization?: InputMaybe<Scalars['ID']>;
  keepFromSource?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  powerUps?: InputMaybe<AddBoardPowerUpsArgs>;
  prefs_background?: InputMaybe<Scalars['String']>;
  prefs_background_url?: InputMaybe<Scalars['String']>;
  prefs_cardAging?: InputMaybe<Board_Prefs_CardAging>;
  prefs_cardCovers?: InputMaybe<Scalars['Boolean']>;
  prefs_comments?: InputMaybe<Board_Prefs_Comments>;
  prefs_invitations?: InputMaybe<Board_Prefs_Invitations>;
  prefs_isTemplate?: InputMaybe<Scalars['Boolean']>;
  prefs_permissionLevel?: InputMaybe<Board_Prefs_PermissionLevel>;
  prefs_selfJoin?: InputMaybe<Scalars['Boolean']>;
  prefs_switcherViews?: InputMaybe<Board_Prefs_SwitcherView_ViewType>;
  prefs_voting?: InputMaybe<Board_Prefs_Voting>;
  traceId: Scalars['String'];
};


export type MutationAddBoardStarArgs = {
  boardId: Scalars['ID'];
  memberId: Scalars['ID'];
  pos: Scalars['Int'];
};


export type MutationAddButlerButtonArgs = {
  butlerButton: InputButlerButton;
  idScope: Scalars['ID'];
  scope: Scalars['String'];
};


export type MutationAddCampaignArgs = {
  currentStep: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddCheckItemArgs = {
  cardId: Scalars['ID'];
  checklistId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  temporaryId: Scalars['String'];
};


export type MutationAddChecklistArgs = {
  boardId: Scalars['ID'];
  cardId: Scalars['ID'];
  checklistSourceId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  temporaryId: Scalars['String'];
};


export type MutationAddCustomFieldOptionArgs = {
  idCustomField: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddFreeTrialArgs = {
  count?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  traceId: Scalars['String'];
  via?: InputMaybe<Scalars['String']>;
};


export type MutationAddMemberToBoardArgs = {
  acceptUnconfirmed?: InputMaybe<Scalars['Boolean']>;
  allowBillableGuest?: InputMaybe<Scalars['Boolean']>;
  boardId: Scalars['ID'];
  invitationMessage?: InputMaybe<Scalars['String']>;
  member: MemberOrEmail;
  traceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type MutationAddMemberToOrgArgs = {
  invitationMessage: Scalars['String'];
  orgId: Scalars['ID'];
  traceId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  user: MemberOrEmail;
};


export type MutationAddMessageDismissedArgs = {
  lastDismissed: Scalars['String'];
  memberId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationAddOneTimeMessagesDismissedArgs = {
  memberId: Scalars['ID'];
  messageId: Scalars['ID'];
};


export type MutationAddPluginCollaboratorArgs = {
  memberId: Scalars['ID'];
  pluginId: Scalars['ID'];
};


export type MutationAddReactionArgs = {
  idAction: Scalars['ID'];
  skinVariation?: InputMaybe<Scalars['String']>;
  unified?: InputMaybe<Scalars['String']>;
};


export type MutationAddSavedSearchArgs = {
  memberId?: InputMaybe<Scalars['ID']>;
  savedSearch: InputSavedSearch;
};


export type MutationAddTagArgs = {
  orgId: Scalars['ID'];
  tag: Scalars['String'];
};


export type MutationApplyBcDiscountArgs = {
  orgId: Scalars['ID'];
};


export type MutationArchiveCardArgs = {
  idCard: Scalars['ID'];
};


export type MutationBulkDisableWorkspacePowerUpArgs = {
  orgId: Scalars['ID'];
  pluginId: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationBulkEnableWorkspacePowerUpArgs = {
  orgId: Scalars['ID'];
  pluginId: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationCancelGoldPaidAccountArgs = {
  accountId: Scalars['ID'];
};


export type MutationCancelWorkspacePaidAccountArgs = {
  accountId: Scalars['ID'];
};


export type MutationChangeCardDueDateArgs = {
  due?: InputMaybe<Scalars['String']>;
  dueReminder?: InputMaybe<Scalars['String']>;
  idCard: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationChangeMemberEmailArgs = {
  dismissMessage?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  loginId: Scalars['ID'];
  primary?: InputMaybe<Scalars['Boolean']>;
};


export type MutationClaimOrganizationArgs = {
  idEnterprise: Scalars['ID'];
  idOrganizations: Array<InputMaybe<Scalars['ID']>>;
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationCloseBoardArgs = {
  boardId: Scalars['ID'];
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCopyBoardToOrgArgs = {
  boardId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type MutationCopyCardArgs = {
  idCardSource: Scalars['ID'];
  idList: Scalars['ID'];
  keepFromSource?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
};


export type MutationCreateBoardInviteSecretArgs = {
  idBoard: Scalars['ID'];
  type?: InputMaybe<Board_Invite_MemberType>;
};


export type MutationCreateCardArgs = {
  closed?: InputMaybe<Scalars['Boolean']>;
  due?: InputMaybe<Scalars['String']>;
  idLabels?: InputMaybe<Array<Scalars['ID']>>;
  idList: Scalars['ID'];
  idMembers?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
  pos?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
};


export type MutationCreateCardTemplateArgs = {
  closed?: InputMaybe<Scalars['Boolean']>;
  listId: Scalars['ID'];
  name: Scalars['String'];
  traceId: Scalars['String'];
};


export type MutationCreateCustomFieldArgs = {
  display: CreateCustomField_Display;
  idModel: Scalars['String'];
  modelType: Scalars['String'];
  name: Scalars['String'];
  options?: InputMaybe<Array<CreateCustomField_Option>>;
  type: Scalars['String'];
};


export type MutationCreateDashboardViewTileArgs = {
  idBoard: Scalars['ID'];
  tile: CreateDashboardViewTile;
};


export type MutationCreateLabelArgs = {
  color?: InputMaybe<Label_Color>;
  idBoard: Scalars['ID'];
  idCard?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
};


export type MutationCreateListArgs = {
  idBoard: Scalars['ID'];
  name: Scalars['String'];
  pos?: InputMaybe<Scalars['Float']>;
  traceId: Scalars['String'];
};


export type MutationCreateOrganizationArgs = {
  creationMethod?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  enterprise?: InputMaybe<Scalars['String']>;
  teamType?: InputMaybe<Scalars['String']>;
  traceId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  visibility?: InputMaybe<Organization_Prefs_PermissionLevel>;
};


export type MutationCreateOrganizationInviteSecretArgs = {
  idOrganization: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateOrganizationViewArgs = {
  idOrganization: Scalars['ID'];
  name: Scalars['String'];
  prefs: InputOrganizationView_Prefs;
  traceId: Scalars['String'];
  views?: InputMaybe<Array<InputMaybe<InputOrganizationView_View>>>;
};


export type MutationCreatePluginArgs = {
  agreementId: Scalars['ID'];
  author?: InputMaybe<Scalars['String']>;
  iframeConnectorUrl?: InputMaybe<Scalars['String']>;
  listings: Array<InputPluginListing>;
  organizationId: Scalars['ID'];
};


export type MutationCreatePluginListingArgs = {
  description: Scalars['String'];
  locale: Scalars['String'];
  name: Scalars['String'];
  overview: Scalars['String'];
  pluginId: Scalars['ID'];
};


export type MutationCreateSelfServeExpansionArgs = {
  idEnterprise: Scalars['String'];
  seats: Scalars['Int'];
};


export type MutationCreateWorkspacePaidAccountArgs = {
  acceptTOS: Scalars['Boolean'];
  country: Scalars['String'];
  discountCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  freeTrial?: InputMaybe<Scalars['Boolean']>;
  idOrganization: Scalars['ID'];
  locale: Scalars['String'];
  name: Scalars['String'];
  nonce: Scalars['String'];
  products: Array<Scalars['Int']>;
  stateTaxId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAccessRequestArgs = {
  id: Scalars['ID'];
  idInvitedMember: Scalars['ID'];
  modelType: RequestAccessModelType;
  signature: Scalars['String'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAllManagedMemberTokensArgs = {
  filter?: InputMaybe<Scalars['String']>;
  idEnterprise: Scalars['ID'];
};


export type MutationDeleteBoardArgs = {
  boardId: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationDeleteButlerButtonArgs = {
  idBoard: Scalars['ID'];
  idButton: Scalars['ID'];
  idOrganization: Scalars['ID'];
  scope: Scalars['String'];
};


export type MutationDeleteCardArgs = {
  idCard: Scalars['ID'];
};


export type MutationDeleteCheckItemArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
};


export type MutationDeleteChecklistArgs = {
  checklistId: Scalars['ID'];
};


export type MutationDeleteCustomFieldArgs = {
  idCustomField: Scalars['String'];
};


export type MutationDeleteCustomFieldOptionArgs = {
  idCustomField: Scalars['String'];
  idCustomFieldOption: Scalars['String'];
};


export type MutationDeleteDashboardViewTileArgs = {
  idBoard: Scalars['ID'];
  idTile: Scalars['ID'];
};


export type MutationDeleteLabelArgs = {
  id: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationDeleteManagedMemberTokensArgs = {
  filter?: InputMaybe<Scalars['String']>;
  idEnterprise: Scalars['ID'];
  idMember: Scalars['ID'];
};


export type MutationDeleteOneTimeMessagesDismissedArgs = {
  memberId: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationDeleteOrganizationArgs = {
  idOrganization: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteOrganizationInviteSecretArgs = {
  idOrganization: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationDeleteOrganizationLogoArgs = {
  orgId: Scalars['ID'];
};


export type MutationDeleteOrganizationViewArgs = {
  idOrganizationView: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationDeletePluginArgs = {
  pluginId: Scalars['ID'];
};


export type MutationDeletePluginListingArgs = {
  pluginId: Scalars['ID'];
  pluginListingId: Scalars['ID'];
};


export type MutationDeleteReactionArgs = {
  idAction: Scalars['ID'];
  reactionId: Scalars['ID'];
};


export type MutationDeleteSavedSearchArgs = {
  memberId?: InputMaybe<Scalars['ID']>;
  savedSearchId: Scalars['ID'];
};


export type MutationDisableBoardInviteSecretArgs = {
  idBoard: Scalars['ID'];
};


export type MutationDismissAnnouncementArgs = {
  announcementId: Scalars['ID'];
};


export type MutationEnableMemberProfileSyncArgs = {
  memberId: Scalars['ID'];
};


export type MutationEnablePluginArgs = {
  boardId: Scalars['ID'];
  pluginId: Scalars['ID'];
  traceId: Scalars['String'];
};


export type MutationLinkEnterpriseWithAtlassianOrganizationArgs = {
  atlOrgId: Scalars['ID'];
  idEnterprise: Scalars['ID'];
};


export type MutationReactivateGoldPaidAccountArgs = {
  idMember: Scalars['ID'];
  product: Scalars['Int'];
  traceId: Scalars['String'];
};


export type MutationReactivateWorkspacePaidAccountArgs = {
  acceptTOS: Scalars['Boolean'];
  country: Scalars['String'];
  discountCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  idOrganization: Scalars['ID'];
  locale: Scalars['String'];
  name: Scalars['String'];
  nonce: Scalars['String'];
  products: Array<Scalars['Int']>;
  stateTaxId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  traceId: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationRedeemPromoCodeArgs = {
  accountId: Scalars['ID'];
  promoCode: Scalars['String'];
};


export type MutationRemoveBoardStarArgs = {
  boardStarId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationRemoveMemberFromBoardArgs = {
  idBoard: Scalars['ID'];
  idMember: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveMemberFromCardArgs = {
  idCard: Scalars['ID'];
  idMember: Scalars['ID'];
};


export type MutationRemoveMemberFromWorkspaceArgs = {
  orgId: Scalars['ID'];
  traceId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  user: MemberOrEmail;
};


export type MutationRemovePluginCollaboratorArgs = {
  memberId: Scalars['ID'];
  pluginId: Scalars['ID'];
};


export type MutationReopenBoardArgs = {
  boardId: Scalars['ID'];
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendAccessRequestArgs = {
  id: Scalars['ID'];
  modelType: RequestAccessModelType;
  traceId: Scalars['String'];
};


export type MutationSetNotificationsReadArgs = {
  ids: Array<Scalars['String']>;
  read: Scalars['Boolean'];
};


export type MutationStartBoardExportArgs = {
  id: Scalars['ID'];
};


export type MutationStartEnterpriseExportArgs = {
  enterpriseAssociationType: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationToggleAutoUpgradeArgs = {
  orgId: Scalars['ID'];
  upgrade?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUnarchiveCardArgs = {
  idCard: Scalars['ID'];
};


export type MutationUnblockMemberProfileSyncArgs = {
  memberId: Scalars['ID'];
};


export type MutationUpdateBoardCardCoversPrefArgs = {
  boardId: Scalars['ID'];
  cardCovers: Scalars['Boolean'];
};


export type MutationUpdateBoardMemberPermissionArgs = {
  boardId: Scalars['ID'];
  memberId: Scalars['ID'];
  traceId: Scalars['String'];
  type: Board_Membership_MemberType;
};


export type MutationUpdateBoardNameArgs = {
  boardId: Scalars['ID'];
  boardName: Scalars['String'];
  traceId: Scalars['String'];
};


export type MutationUpdateBoardOrgArgs = {
  boardId: Scalars['ID'];
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['ID']>;
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBoardStarArgs = {
  boardStarId: Scalars['ID'];
  memberId: Scalars['ID'];
  pos: Scalars['Int'];
};


export type MutationUpdateBoardSwitcherViewsPrefArgs = {
  boardId: Scalars['ID'];
  switcherViews: Array<Input_Board_Prefs_SwitcherView>;
};


export type MutationUpdateBoardVisibilityArgs = {
  boardId: Scalars['ID'];
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['ID']>;
  visibility: Board_Prefs_PermissionLevel;
};


export type MutationUpdateBoardsOrgArgs = {
  boardIds: Array<InputMaybe<Scalars['ID']>>;
  keepBillableGuests?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['ID']>;
  staggerRequests?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateBusinessClassBillingContactDetailsArgs = {
  accountId: Scalars['ID'];
  contactEmail: Scalars['String'];
  contactLocale: Scalars['String'];
  contactName: Scalars['String'];
};


export type MutationUpdateBusinessClassBillingInvoiceDetailsArgs = {
  accountId: Scalars['ID'];
  invoiceDetails: Scalars['String'];
};


export type MutationUpdateBusinessClassCreditCardArgs = {
  accountId: Scalars['ID'];
  country: Scalars['String'];
  nonce: Scalars['String'];
  stateTaxId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBusinessClassPaidProductArgs = {
  accountId: Scalars['ID'];
  products: Array<Scalars['Int']>;
};


export type MutationUpdateCalendarFeedEnabledPrefArgs = {
  boardId: Scalars['ID'];
  calendarFeedEnabled: Scalars['Boolean'];
};


export type MutationUpdateCalendarKeyArgs = {
  boardId: Scalars['ID'];
};


export type MutationUpdateCampaignArgs = {
  campaignId: Scalars['ID'];
  currentStep?: InputMaybe<Scalars['String']>;
  dateDismissed?: InputMaybe<Scalars['String']>;
  isDismissed?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateCardCoverArgs = {
  cardId: Scalars['ID'];
  cover?: InputMaybe<InputCover>;
  traceId: Scalars['String'];
};


export type MutationUpdateCardDatesArgs = {
  due?: InputMaybe<Scalars['String']>;
  dueReminder?: InputMaybe<Scalars['String']>;
  idCard: Scalars['ID'];
  start?: InputMaybe<Scalars['String']>;
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCardDueCompleteArgs = {
  cardId: Scalars['ID'];
  dueComplete: Scalars['Boolean'];
  traceId: Scalars['String'];
};


export type MutationUpdateCardLabelsArgs = {
  idCard: Scalars['ID'];
  idLabels: Array<Scalars['ID']>;
  traceId: Scalars['String'];
};


export type MutationUpdateCardListArgs = {
  idCard: Scalars['ID'];
  idList: Scalars['ID'];
  traceId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCardNameArgs = {
  idCard: Scalars['ID'];
  name: Scalars['String'];
  traceId: Scalars['String'];
};


export type MutationUpdateCardRoleArgs = {
  cardRole?: InputMaybe<CardRole>;
  idCard: Scalars['ID'];
};


export type MutationUpdateCheckItemDueDateArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
  due: Scalars['String'];
};


export type MutationUpdateCheckItemNameArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateCheckItemPosArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
  pos: Scalars['Float'];
};


export type MutationUpdateCheckItemStateArgs = {
  cardId: Scalars['ID'];
  checkItemId: Scalars['ID'];
  checklistId: Scalars['ID'];
  state: CheckItem_State;
  traceId: Scalars['String'];
};


export type MutationUpdateChecklistNameArgs = {
  checklistId: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateChecklistPosArgs = {
  checklistId: Scalars['ID'];
  pos: Scalars['Float'];
};


export type MutationUpdateCustomFieldArgs = {
  display?: InputMaybe<CreateCustomField_Display>;
  idCustomField: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  pos?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateCustomFieldItemArgs = {
  idCard: Scalars['ID'];
  idCustomField: Scalars['ID'];
  idValue: Scalars['ID'];
  value?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCustomFieldOptionArgs = {
  color?: InputMaybe<Scalars['String']>;
  idCustomField: Scalars['String'];
  idCustomFieldOption: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  pos?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateDashboardViewTileArgs = {
  idBoard: Scalars['ID'];
  tile: UpdateDashboardViewTile;
};


export type MutationUpdateEnterpriseApiTokenCreationPermissionArgs = {
  idEnterprise: Scalars['ID'];
  isAllowed: Scalars['Boolean'];
};


export type MutationUpdateGoldBillingContactDetailsArgs = {
  accountId: Scalars['ID'];
  contactEmail: Scalars['String'];
  contactLocale: Scalars['String'];
  contactName: Scalars['String'];
};


export type MutationUpdateGoldBillingInvoiceDetailsArgs = {
  accountId: Scalars['ID'];
  invoiceDetails: Scalars['String'];
};


export type MutationUpdateGoldPaidProductArgs = {
  accountId: Scalars['ID'];
  products: Array<Scalars['Int']>;
};


export type MutationUpdateHiddenPluginBoardButtonShortcutsArgs = {
  addPlugin: Scalars['Boolean'];
  boardId: Scalars['ID'];
  pluginId: Scalars['String'];
};


export type MutationUpdateLabelArgs = {
  label: InputLabel;
  traceId: Scalars['String'];
};


export type MutationUpdateMarketingOptInArgs = {
  optedIn: Scalars['Boolean'];
  prompt?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMemberActiveChannelArgs = {
  channel: Scalars['String'];
  memberId: Scalars['ID'];
};


export type MutationUpdateMemberProfileArgs = {
  profile: MemberProfileFields;
};


export type MutationUpdateNotificationEmailFrequencyArgs = {
  frequency: Scalars['Int'];
  id: Scalars['ID'];
};


export type MutationUpdateOrganizationArgs = {
  desc?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orgId: Scalars['ID'];
  teamType?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Organization_Prefs_PermissionLevel>;
  website?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateOrganizationViewArgs = {
  idOrganizationView: Scalars['ID'];
  organizationView: InputOrganizationView;
  traceId: Scalars['String'];
};


export type MutationUpdatePluginArgs = {
  fields?: InputMaybe<UpdatePluginFields>;
  pluginId: Scalars['ID'];
};


export type MutationUpdatePluginHeaderShortcutsEnabledArgs = {
  boardId: Scalars['ID'];
  defaultEnabled: Scalars['Boolean'];
};


export type MutationUpdatePluginListingArgs = {
  description?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  overview?: InputMaybe<Scalars['String']>;
  pluginId: Scalars['ID'];
  pluginListingId: Scalars['ID'];
};


export type MutationUpdateTeamifyVoluntaryDoneArgs = {
  memberId: Scalars['ID'];
};


export type MutationUpdateUserLocaleArgs = {
  locale: Scalars['String'];
  memberId: Scalars['ID'];
};


export type MutationUpdateViewInOrganizationViewArgs = {
  idOrganizationView: Scalars['ID'];
  idView: Scalars['ID'];
  traceId: Scalars['String'];
  view: InputOrganizationView_View;
};


export type MutationUploadCardCoverArgs = {
  cardId: Scalars['ID'];
  file: Scalars['FileUpload'];
  traceId: Scalars['String'];
};


export type MutationUploadOrganizationImageArgs = {
  file: Scalars['FileUpload'];
  orgId: Scalars['ID'];
};

/** The Board preferences specific to the current Member */
export type MyPrefs = {
  __typename: 'MyPrefs';
  /** Allows for generating a calendar from url */
  calendarKey: Scalars['String'];
  /** The generated key used in the email address for the Board */
  emailKey?: Maybe<Scalars['String']>;
  /** The position in the List to add cards to when the Board is emailed */
  emailPosition?: Maybe<MyPrefs_EmailPosition>;
  /** The id of the List to add cards to when the Board is emailed */
  idEmailList?: Maybe<Scalars['String']>;
  /** Whether the sidebar should be shown */
  showSidebar: Scalars['Boolean'];
};

/** The position in the List to add cards to when the Board is emailed */
export const MyPrefs_EmailPosition = {
  /** The bottom of the List */
  Bottom: 'bottom',
  /** The top of the List */
  Top: 'top'
} as const;

export type MyPrefs_EmailPosition = typeof MyPrefs_EmailPosition[keyof typeof MyPrefs_EmailPosition];
export type NameEntity = {
  __typename: 'NameEntity';
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Notification = {
  __typename: 'Notification';
  appCreator?: Maybe<AppCreator>;
  data?: Maybe<NotificationData>;
  date: Scalars['String'];
  dateRead?: Maybe<Scalars['String']>;
  display?: Maybe<NotificationDisplay>;
  id: Scalars['String'];
  idAction: Scalars['String'];
  idMemberCreator: Scalars['String'];
  isReactable?: Maybe<Scalars['Boolean']>;
  memberCreator: Member;
  reactions: Array<Reaction>;
  type: Scalars['String'];
  unread?: Maybe<Scalars['Boolean']>;
};

export type NotificationData = {
  __typename: 'NotificationData';
  board?: Maybe<BoardNotificationData>;
  card?: Maybe<CardNotificationData>;
  organization?: Maybe<OrganizationNotificationData>;
  signature?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type NotificationDisplay = {
  __typename: 'NotificationDisplay';
  entities?: Maybe<NotificationDisplayEntity>;
  translationKey?: Maybe<Scalars['String']>;
};

export type NotificationDisplayEntity = {
  __typename: 'NotificationDisplayEntity';
  board?: Maybe<BoardEntity>;
  card?: Maybe<CardEntity>;
  comment?: Maybe<CommentEntity>;
  due?: Maybe<DueEntity>;
  enterprise?: Maybe<EnterpriseEntity>;
  list?: Maybe<ListEntity>;
  memberCreator?: Maybe<MemberEntity>;
  name?: Maybe<NameEntity>;
  organization?: Maybe<OrganizationEntity>;
};

export type NotificationGroup = {
  __typename: 'NotificationGroup';
  card?: Maybe<Card>;
  id: Scalars['String'];
  notifications: Array<Notification>;
};

/** An object representing the response from the setNotificationsRead and setAllNotificationsRead mutations */
export type Notifications_ReadResponse = {
  __typename: 'Notifications_ReadResponse';
  /** Whether marking as read was successful */
  success: Scalars['Boolean'];
};

/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type Organization = {
  __typename: 'Organization';
  accessRequests?: Maybe<Array<WorkspaceAccessRequestsItem>>;
  /** The count of active billable members in the organization. Used if the organization is build only for active members. */
  activeBillableMemberCount?: Maybe<Scalars['Int']>;
  /** The count of available licenses in the organization */
  availableLicenseCount?: Maybe<Scalars['Int']>;
  /** The count of billable collaborators (board guests) */
  billableCollaboratorCount?: Maybe<Scalars['Int']>;
  /** The count of billable members in the organization. */
  billableMemberCount?: Maybe<Scalars['Int']>;
  /**
   * The boards belonging to the Organization that are visible to the user. Note that arguments you use here need to match
   * the ones in the type Query { organization... } so that parseQuery can grab the argument for nestedResources. Right now
   * thats boardIds, boardsStartIndex, and boardsCount, since those are ones you might programmatically input to a query.
   */
  boards: Array<Board>;
  /** Whether or not this Workspace's Domain can be changed */
  canEditDomain?: Maybe<Scalars['Boolean']>;
  /** The cards given a list of board IDs for Multi-Board Views. */
  cards: OrganizationCards;
  /** The Guests in the Organization */
  collaborators: Array<Member>;
  /** How the Organization was created */
  creationMethod?: Maybe<Scalars['String']>;
  /** The Credits owned by this Organization */
  credits: Array<Credit>;
  /** The description of the workspace */
  desc: Scalars['String'];
  /** If the bio includes custom emoji, this object will contain the information necessary to display them. */
  descData?: Maybe<Scalars['JSONString']>;
  /** The name for the workspace. For example: Trello Inc */
  displayName: Scalars['String'];
  domain?: Maybe<DomainOrganization>;
  /** The domain name of the workspace is the mapping of the workspace to its organization */
  domainName?: Maybe<Scalars['String']>;
  /** The Enterprise this Organization belongs to */
  enterprise?: Maybe<Enterprise>;
  /** Exports created from this Organization */
  exports?: Maybe<Array<Export>>;
  /** The ID of the organization. */
  id: Scalars['ID'];
  /** The list of board ids belonging to the Organization that are visible to the user */
  idBoards: Array<Scalars['String']>;
  /** The list of the most active boards in the Organization */
  idBoardsMostActive?: Maybe<Array<Scalars['String']>>;
  /** The ID of the Enterprise this Organization belongs to */
  idEnterprise?: Maybe<Scalars['String']>;
  /** The ID of the member that created the organization */
  idMemberCreator?: Maybe<Scalars['String']>;
  /** The limits on the Organization */
  limits: Organization_Limits;
  /** Hash for the organization's logo */
  logoHash?: Maybe<Scalars['String']>;
  /** The Members in the Organization */
  members: Array<Member>;
  /** The count of active confirmed members in an Organization */
  membersCount?: Maybe<Scalars['Int']>;
  /** The Memberships of the Organization */
  memberships: Array<Organization_Membership>;
  /** The programmatic name for the team. For example: trelloinc */
  name: Scalars['String'];
  /** The new billable guests that would be added as a result of adding this board to the organization */
  newBillableGuests: Array<Organization_NewBillableGuest>;
  /** The organization views that belong to an organization */
  organizationViews: Array<OrganizationView>;
  /** The Plugins owned by the Organization */
  ownedPlugins: Array<Plugin>;
  /** Information about the paid account of an organization */
  paidAccount?: Maybe<PaidAccount>;
  /** Whether not the organization currently has a pending product */
  pendingProduct?: Maybe<Scalars['Int']>;
  /** The PluginData for this Organization */
  pluginData: Array<PluginData>;
  /** The Plugins associated with this Organization */
  plugins: Array<Plugin>;
  /** The preferences (settings) for the team */
  prefs: Organization_Prefs;
  /** The premium features allowed for this team */
  premiumFeatures: Array<PremiumFeatures>;
  /** The Butler Buttons the organization owns */
  privateButlerButtons: Array<ButlerButton>;
  /** The list of product SKUs belonging to this Organization */
  products: Array<Scalars['Int']>;
  /** The promotions used for this Organization */
  promotions: Array<Scalars['String']>;
  sharedButlerButtons: Array<ButlerButton>;
  standardVariation?: Maybe<Scalars['String']>;
  /** The Stats of the Organization used for reporting */
  stats: Organization_Stats;
  /** The Collections(Tags) belonging to the Organization */
  tags: Array<Tag>;
  /** Defines the intent of the team */
  teamType?: Maybe<Scalars['String']>;
  /** The URL to the team page on Trello */
  url: Scalars['String'];
  /** The URL for the organization */
  website?: Maybe<Scalars['String']>;
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationBoardsArgs = {
  boardIds?: InputMaybe<Array<Scalars['ID']>>;
  boardsCount?: InputMaybe<Scalars['Int']>;
  boardsStartIndex?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Board_Filter>;
  sortBy?: InputMaybe<Boards_SortBy>;
  sortOrder?: InputMaybe<Boards_SortOrder>;
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationCardsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<Scalars['String']>;
  dueComplete?: InputMaybe<Scalars['Boolean']>;
  idBoards: Array<Scalars['ID']>;
  idLists?: InputMaybe<Array<Scalars['ID']>>;
  idMembers?: InputMaybe<Array<Scalars['ID']>>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationCollaboratorsArgs = {
  filter?: InputMaybe<Member_Filter>;
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationCreditsArgs = {
  filter?: InputMaybe<Array<Credit_Type>>;
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationMembersArgs = {
  filter?: InputMaybe<Member_Filter>;
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationMembershipsArgs = {
  filter?: InputMaybe<Organization_Memberships_Filter>;
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationNewBillableGuestsArgs = {
  boardId: Scalars['ID'];
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationOrganizationViewsArgs = {
  organizationViewsFilter?: InputMaybe<Array<OrganizationView_Filters>>;
  sortBy?: InputMaybe<OrganizationView_SortBy>;
  sortOrder?: InputMaybe<OrganizationView_SortOrder>;
};


/** Organizations, or as they are referred to in Trello, "Workspaces", represent collections of members and boards. */
export type OrganizationPluginsArgs = {
  filter?: InputMaybe<Plugin_Filter>;
};

export type OrganizationCards = {
  __typename: 'OrganizationCards';
  cards: Array<Card>;
  cursor: Scalars['String'];
  total: Scalars['Int'];
};

export type OrganizationEntity = {
  __typename: 'OrganizationEntity';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OrganizationInviteSecretResponse = {
  __typename: 'OrganizationInviteSecretResponse';
  secret: Scalars['String'];
  type: Scalars['String'];
};

export type OrganizationNotificationData = {
  __typename: 'OrganizationNotificationData';
  id?: Maybe<Scalars['String']>;
};

/** Details of an organization view, referred to as a Workspace View in the app. */
export type OrganizationView = {
  __typename: 'OrganizationView';
  /** The id of an organization view */
  id: Scalars['ID'];
  /** The id of the enterprise the view belongs to */
  idEnterprise: Scalars['String'];
  /** The id of the member that created the organization view */
  idMemberCreator: Scalars['ID'];
  /** The id of the organization the view belongs to */
  idOrganization: Scalars['ID'];
  /** The name of the organization view */
  name: Scalars['String'];
  /** The organization that the organization view belongs to */
  organization: Organization;
  /** An object that describes the permission level of the organization view */
  prefs: OrganizationView_Prefs;
  /** The slug of the organization view */
  shortLink: Scalars['String'];
  /** The set of views within an organization view */
  views: Array<OrganizationView_View>;
};

/**
 * The filters for an organization views request. For example, used when
 * requesting all the OrganizationViews within a particular Organization
 */
export const OrganizationView_Filters = {
  /** Returns all organization views that exist in the organization. Can only be yused by team admins. */
  All: 'all',
  /** Returns all organization views that your user created. */
  Created: 'created',
  /** Returns the private organization views that only your user can see. */
  Private: 'private',
  /** Returns all organization views you can see within your team */
  Team: 'team'
} as const;

export type OrganizationView_Filters = typeof OrganizationView_Filters[keyof typeof OrganizationView_Filters];
/** Permission level of an organization view */
export type OrganizationView_Prefs = {
  __typename: 'OrganizationView_Prefs';
  /** The permission level for the organizaiton view. Currently we support 'team' and 'private' */
  permissionLevel: Scalars['String'];
};

export const OrganizationView_Prefs_PermissionLevel = {
  Private: 'private',
  Team: 'team'
} as const;

export type OrganizationView_Prefs_PermissionLevel = typeof OrganizationView_Prefs_PermissionLevel[keyof typeof OrganizationView_Prefs_PermissionLevel];
/**
 * The sorting criteria for an organization view request. For example, used when
 * requesting all the OrganizationViews within a particular Organization
 */
export const OrganizationView_SortBy = {
  /** Sorts returned organization views by their creation date */
  DateCreated: 'dateCreated',
  /** Sorts returned organization views by their name */
  Name: 'name'
} as const;

export type OrganizationView_SortBy = typeof OrganizationView_SortBy[keyof typeof OrganizationView_SortBy];
/**
 * The sort order for an organization view request. For example, used when
 * requesting all the OrganizationViews within a particular Organization
 */
export const OrganizationView_SortOrder = {
  /** Sorts returned organization views in ascending order */
  Asc: 'asc',
  /** Sorts returned organization views in ascending order */
  Ascending: 'ascending',
  /** Sorts returned organization views in descending order */
  Desc: 'desc',
  /** Sorts returned organization views in descending order */
  Descending: 'descending'
} as const;

export type OrganizationView_SortOrder = typeof OrganizationView_SortOrder[keyof typeof OrganizationView_SortOrder];
/**
 * Details of one view within an organization view. (This object is similar to a
 * single tab in a spreadsheet, where OrganizationView is the whole spreadsheet)
 */
export type OrganizationView_View = {
  __typename: 'OrganizationView_View';
  /** An object specifying which cards to include in the view */
  cardFilter: OrganizationView_View_CardFilter;
  /** The type of visualization this view uses, such as 'table' or 'timeline' */
  defaultViewType: Scalars['String'];
  /** The ID for this view */
  id: Scalars['ID'];
  viewOptions?: Maybe<OrganizationView_View_ViewOptions>;
};

/** CardFilter model, specifying which cards are included in the view. */
export type OrganizationView_View_CardFilter = {
  __typename: 'OrganizationView_View_CardFilter';
  /** An object specifying the criteria that determines which cards are included in the view */
  criteria: Array<OrganizationView_View_CardFilter_Criteria>;
};

/**
 * CardFilter_Criteria model, specifying the criteria that decides which cards are
 * included in the view.
 */
export type OrganizationView_View_CardFilter_Criteria = {
  __typename: 'OrganizationView_View_CardFilter_Criteria';
  due?: Maybe<CardFilter_Criteria_DateRange>;
  dueComplete?: Maybe<Scalars['Boolean']>;
  /** A list of board IDs whose cards will be included in the view */
  idBoards?: Maybe<Array<Scalars['ID']>>;
  idLists?: Maybe<Array<Scalars['ID']>>;
  idMembers?: Maybe<Array<Scalars['String']>>;
  labels?: Maybe<Array<Scalars['String']>>;
  sort?: Maybe<Array<Scalars['String']>>;
  start?: Maybe<CardFilter_Criteria_DateRange>;
};

export type OrganizationView_View_ViewOptions = {
  __typename: 'OrganizationView_View_ViewOptions';
  Calendar?: Maybe<OrganizationView_View_ViewOptions_Calendar>;
};

export type OrganizationView_View_ViewOptions_Calendar = {
  __typename: 'OrganizationView_View_ViewOptions_Calendar';
  timeHorizon?: Maybe<CalendarView_TimeHorizons>;
};

/** A filter for the Organizations being requested */
export const Organization_Filter = {
  /** Returns all Organizations that have visibility set to Private */
  Members: 'members',
  /** Returns all Organizations that have visibility set to Public */
  Public: 'public'
} as const;

export type Organization_Filter = typeof Organization_Filter[keyof typeof Organization_Filter];
/** The limits on the Organization */
export type Organization_Limits = {
  __typename: 'Organization_Limits';
  /** The org limits */
  orgs: Organization_Limits_Orgs;
};

export type Organization_Limits_Orgs = {
  __typename: 'Organization_Limits_Orgs';
  /** The free Boards per Organization limit */
  freeBoardsPerOrg: Limit;
  /** The total Members per Organization limit */
  totalMembersPerOrg: Limit;
};

/** An association between a Member and an Organization */
export type Organization_Membership = {
  __typename: 'Organization_Membership';
  /** Whether the Member has been deactivated */
  deactivated: Scalars['Boolean'];
  /** The ID of the Membership */
  id: Scalars['String'];
  /** The ID of the Member */
  idMember: Scalars['String'];
  /** The Member this membership is for */
  member: Member;
  /** The type of Membership this is */
  memberType: Organization_Membership_MemberType;
  /** Whether the Member has confirmed their email address */
  unconfirmed: Scalars['Boolean'];
};

/** The type of membership a member has on an Organization */
export const Organization_Membership_MemberType = {
  /** An admin */
  Admin: 'admin',
  /** A normal member */
  Normal: 'normal'
} as const;

export type Organization_Membership_MemberType = typeof Organization_Membership_MemberType[keyof typeof Organization_Membership_MemberType];
/** Filter for the memberships of an organization */
export const Organization_Memberships_Filter = {
  /** Get the active memberships */
  Active: 'active',
  /** Get the memberships with memberType admin */
  Admin: 'admin',
  /** Get the deactivated memberships */
  Deactivated: 'deactivated',
  /** Get only my memberships */
  Me: 'me',
  /** Get the memberships with memberType normal */
  Normal: 'normal'
} as const;

export type Organization_Memberships_Filter = typeof Organization_Memberships_Filter[keyof typeof Organization_Memberships_Filter];
/** Information about a member that would become a billable guest */
export type Organization_NewBillableGuest = {
  __typename: 'Organization_NewBillableGuest';
  /** Whether the member has confirmed their email address after signing up. */
  confirmed: Scalars['Boolean'];
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>;
  /** The ID of the Member */
  id: Scalars['ID'];
  /** The member's initials, used for display when there isn't an avatar set. */
  initials: Scalars['String'];
  /** The username for the member. What is shown in @mentions for example. */
  username: Scalars['String'];
};

/** The preferences for an Organization */
export type Organization_Prefs = {
  __typename: 'Organization_Prefs';
  /** The associated google apps domain */
  associatedDomain?: Maybe<Scalars['String']>;
  /** An array of attachment types. Will always include 'trello' */
  attachmentRestrictions?: Maybe<Array<Scalars['String']>>;
  /** The restrictions on who can delete a Board */
  boardDeleteRestrict?: Maybe<Organization_Prefs_BoardDeleteRestrict>;
  /** Restrictions on emails allowed to invite to the Organization */
  boardInviteRestrict?: Maybe<Scalars['String']>;
  /** The restrictions on who can view a Board */
  boardVisibilityRestrict?: Maybe<Organization_Prefs_BoardVisibilityRestrict>;
  /** Whether external members can be added to an Organization's boards */
  externalMembersDisabled?: Maybe<Scalars['Boolean']>;
  /** Restrictions on emails allowed to invite to the Organization */
  orgInviteRestrict?: Maybe<Array<Scalars['String']>>;
  /** The visibility of the Organization */
  permissionLevel?: Maybe<Organization_Prefs_PermissionLevel>;
};

/** An object that represents a set of restrictions for a Board deletion */
export type Organization_Prefs_BoardDeleteRestrict = {
  __typename: 'Organization_Prefs_BoardDeleteRestrict';
  /** How enterprise boards should be restricted */
  enterprise: Organization_Prefs_RestrictionType;
  /** How organization boards should be restricted */
  org: Organization_Prefs_RestrictionType;
  /** How private boards should be restricted */
  private: Organization_Prefs_RestrictionType;
  /** How public boards should be restricted */
  public: Organization_Prefs_RestrictionType;
};

/** An object that represents a set of restrictions for a Board visibility */
export type Organization_Prefs_BoardVisibilityRestrict = {
  __typename: 'Organization_Prefs_BoardVisibilityRestrict';
  /** How enterprise boards should be restricted */
  enterprise: Organization_Prefs_RestrictionType;
  /** How organization boards should be restricted */
  org: Organization_Prefs_RestrictionType;
  /** How private boards should be restricted */
  private: Organization_Prefs_RestrictionType;
  /** How public boards should be restricted */
  public: Organization_Prefs_RestrictionType;
};

/** The permission level (visibility) of an Organization */
export const Organization_Prefs_PermissionLevel = {
  /** domain visible */
  Domain: 'domain',
  /** Only visible to Members of the Organization */
  Private: 'private',
  /** Publicly visible */
  Public: 'public'
} as const;

export type Organization_Prefs_PermissionLevel = typeof Organization_Prefs_PermissionLevel[keyof typeof Organization_Prefs_PermissionLevel];
/** A permission level for a board restriction */
export const Organization_Prefs_RestrictionType = {
  /** Only admins */
  Admin: 'admin',
  /** No one */
  None: 'none',
  /** Anyone in the Organization */
  Org: 'org'
} as const;

export type Organization_Prefs_RestrictionType = typeof Organization_Prefs_RestrictionType[keyof typeof Organization_Prefs_RestrictionType];
/** Stats reported on at the organization level */
export type Organization_Stats = {
  __typename: 'Organization_Stats';
  /** The cards stats for the organization. */
  cards: Organization_Stats_Cards;
  /** The id of the organization the stats are for. */
  id: Scalars['ID'];
  /** The labelNames used on boards in the organization. */
  labelNames: Organization_Stats_LabelNames;
};


/** Stats reported on at the organization level */
export type Organization_StatsCardsArgs = {
  dueDateSince?: InputMaybe<Scalars['String']>;
  dueDateUntil?: InputMaybe<Scalars['String']>;
  groupBy?: InputMaybe<Organization_Stats_Cards_GroupBy>;
  idBoards?: InputMaybe<Array<Scalars['ID']>>;
  idLabels?: InputMaybe<Array<Scalars['ID']>>;
  idMembers?: InputMaybe<Array<Scalars['ID']>>;
  refreshTime?: InputMaybe<Scalars['Int']>;
};

/** Cards stats reported on at the organization level */
export type Organization_Stats_Cards = {
  __typename: 'Organization_Stats_Cards';
  /** Whether the stats are complete or not  */
  incomplete: Scalars['Boolean'];
  /** The cards stats */
  stats: Array<Organization_Stats_Cards_Stat>;
};

/** The possible options for grouping an organization's card stats */
export const Organization_Stats_Cards_GroupBy = {
  Label: 'label',
  LabelName: 'labelName',
  Member: 'member'
} as const;

export type Organization_Stats_Cards_GroupBy = typeof Organization_Stats_Cards_GroupBy[keyof typeof Organization_Stats_Cards_GroupBy];
/**
 * A stat on the number of cards in an organization
 * with a certain property, potentially grouped and filtered
 */
export type Organization_Stats_Cards_Stat = {
  __typename: 'Organization_Stats_Cards_Stat';
  /** The number and ids of done cards. */
  done: Organization_Stats_Cards_Stat_Done;
  /** The id of the label that the stat is grouped by. */
  idLabel?: Maybe<Scalars['ID']>;
  /** The id of the member that the stat is grouped by. */
  idMember?: Maybe<Scalars['ID']>;
  /** The name of the label that the stat is grouped by. */
  labelName?: Maybe<Scalars['String']>;
  /** The number and ids of cards with no due date. */
  noDueDate: Organization_Stats_Cards_Stat_NoDueDate;
  /** The number and ids of overdue cards. */
  overdue: Organization_Stats_Cards_Stat_Overdue;
  /** The number and ids of upcoming cards. */
  upcoming: Organization_Stats_Cards_Stat_Upcoming;
};

export type Organization_Stats_Cards_Stat_Done = {
  __typename: 'Organization_Stats_Cards_Stat_Done';
  /** The number of done cards */
  count: Scalars['Int'];
  /** The IDs of the done cards */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type Organization_Stats_Cards_Stat_NoDueDate = {
  __typename: 'Organization_Stats_Cards_Stat_NoDueDate';
  /** The number of cards with no due date */
  count: Scalars['Int'];
  /** The IDs of the cards with no due date */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type Organization_Stats_Cards_Stat_Overdue = {
  __typename: 'Organization_Stats_Cards_Stat_Overdue';
  /** The number of overdue cards */
  count: Scalars['Int'];
  /** The IDs of the overdue cards */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type Organization_Stats_Cards_Stat_Upcoming = {
  __typename: 'Organization_Stats_Cards_Stat_Upcoming';
  /** The number of upcoming cards */
  count: Scalars['Int'];
  /** The IDs of the upcoming cards */
  ids?: Maybe<Array<Scalars['ID']>>;
};

/** Grouped labels with the same name at the organization level */
export type Organization_Stats_LabelName_Stat = {
  __typename: 'Organization_Stats_LabelName_Stat';
  /** Number of unique labels with this name */
  count: Scalars['Int'];
  /** The IDs of each label within this group */
  ids: Array<Scalars['ID']>;
  /** The name of the label */
  name: Scalars['String'];
  /** The number of times a label with this name has been used */
  totalUses: Scalars['Int'];
};

/** LabelNames stats reported at the organization level */
export type Organization_Stats_LabelNames = {
  __typename: 'Organization_Stats_LabelNames';
  /** Whether the stats are complete or not  */
  incomplete: Scalars['Boolean'];
  /** The labelName stats */
  stats: Array<Organization_Stats_LabelName_Stat>;
};

/** Details of a paid account */
export type PaidAccount = {
  __typename: 'PaidAccount';
  /** The billing dates of the account's products */
  billingDates: Scalars['JSONString'];
  /** Product can renew based on CC information on file */
  canRenew: Scalars['Boolean'];
  /** The last 4 digits of the account's credit card */
  cardLast4: Scalars['String'];
  /** The type of the credit card used for the account */
  cardType: Scalars['String'];
  /** The email of the account's contact */
  contactEmail: Scalars['String'];
  /** The full name of the account's contact */
  contactFullName: Scalars['String'];
  /** The locale of the account's contact */
  contactLocale: Scalars['String'];
  /** Billing address: Country */
  country?: Maybe<Scalars['String']>;
  /** The date when the account's paidAccount was initialized */
  dateFirstSubscription: Scalars['String'];
  /** Date the subscription will be disabled */
  datePendingDisabled?: Maybe<Scalars['String']>;
  /** The expiration dates of the account's products */
  expirationDates: Scalars['JSONString'];
  /** Details about the account's invoice */
  invoiceDetails?: Maybe<Scalars['String']>;
  /** The subscriber ID of the account */
  ixSubscriber: Scalars['Int'];
  needsCreditCardUpdate?: Maybe<Scalars['Boolean']>;
  /** The current paid product */
  paidProduct: Scalars['Int'];
  /** Previous subscription data for cancelled or expired accounts */
  previousSubscription?: Maybe<PreviousSubscription>;
  /** The free trial product data on a paid workspace */
  productOverride?: Maybe<ProductOverride>;
  /** The product codes associated with this account */
  products: Array<Scalars['Int']>;
  /** Object containing product code and date for next subscribed product */
  scheduledChange?: Maybe<ScheduledChange>;
  /** The standing of the account */
  standing: Scalars['Int'];
  /** The state taxId for this account */
  stateTaxId?: Maybe<Scalars['String']>;
  /** The federal taxId for this account */
  taxId?: Maybe<Scalars['String']>;
  /** The expiration date for the account's free trial */
  trialExpiration?: Maybe<Scalars['String']>;
  /** The type of trial credits on the account. Either 'promocode' or 'freeTrial' */
  trialType?: Maybe<Scalars['String']>;
  /** Billing address: Zip/Postal code */
  zip?: Maybe<Scalars['String']>;
};

export const PaidAccountType = {
  Members: 'members',
  Organizations: 'organizations'
} as const;

export type PaidAccountType = typeof PaidAccountType[keyof typeof PaidAccountType];
export type Plugin = {
  __typename: 'Plugin';
  /** API Key associated with this plugin. */
  apiKey?: Maybe<Scalars['String']>;
  /** The name of the plugin's author. */
  author: Scalars['String'];
  /** Capabilities represent areas of the UX that a plugin can hook into. */
  capabilities: Array<Scalars['String']>;
  /** Options that modify the way capabilities are called and responded to. */
  capabilitiesOptions: Array<Scalars['String']>;
  /** A list of categories which the plugin will be listed under. */
  categories: Array<Scalars['String']>;
  /** The plugin collaborators who can edit the plugin */
  collaborators: Array<Member>;
  /** The compliance information of the plugin. */
  compliance?: Maybe<Plugin_Compliance>;
  /** The email address of the plugin author. */
  email?: Maybe<Scalars['String']>;
  /** The boards that have the plugin enabled for a specific Workspace */
  enabledBoards: Array<Board>;
  /** Urls to the hero image of a plugin. */
  heroImageUrl?: Maybe<Scalars['JSONString']>;
  /** The icon of the plugin. */
  icon: Plugin_Icon;
  /** The ID of the plugin. */
  id: Scalars['ID'];
  /** The ID of the organization the plugin belongs to. */
  idOrganizationOwner: Scalars['String'];
  /** The URL to the main iframe of the plugin. */
  iframeConnectorUrl: Scalars['String'];
  /** If the plugin is compliant with privacy standards. */
  isCompliantWithPrivacyStandards?: Maybe<Scalars['Boolean']>;
  /** Listing information of the plugin. */
  listing?: Maybe<Plugin_Listing>;
  /** A list of listing information of the plugin in different locales. */
  listings?: Maybe<Array<Plugin_Listings>>;
  /** The moderated state of a plugin. Used to hide or turn off problematic plugins. */
  moderatedState?: Maybe<Plugin_ModeratedState>;
  /** Deprecated name of the plugin. */
  name?: Maybe<Scalars['String']>;
  /** The URL to the privacy policy of the plugin. */
  privacyUrl?: Maybe<Scalars['String']>;
  /** Whether the plugin is available to the public. */
  public: Scalars['Boolean'];
  /** Daily statistics about the plugin. */
  stats: Array<Plugin_Stat>;
  /** The support email of a plugin. */
  supportEmail?: Maybe<Scalars['String']>;
  /** A list of tags used to make a plugin featued. */
  tags: Array<Scalars['String']>;
  /** Usage bracket information of the plugin. */
  usageBrackets: Plugin_UsageBrackets;
};

/** Data stored by a plugin */
export type PluginData = {
  __typename: 'PluginData';
  /** Whether the PluginData is private or shared */
  access: PluginData_Access;
  /** The id of the PluginData */
  id: Scalars['ID'];
  /** The id of the model the data is scoped to */
  idModel: Scalars['String'];
  /** The id of the Plugin */
  idPlugin: Scalars['String'];
  /** The model type the data is scoped to */
  scope: PluginData_Scope;
  /** The data being stored */
  value: Scalars['String'];
};

/** Whether the PluginData is private or shared */
export const PluginData_Access = {
  Private: 'private',
  Shared: 'shared'
} as const;

export type PluginData_Access = typeof PluginData_Access[keyof typeof PluginData_Access];
/** The model type the data is scoped to */
export const PluginData_Scope = {
  Board: 'board',
  Card: 'card',
  Member: 'member',
  Organization: 'organization'
} as const;

export type PluginData_Scope = typeof PluginData_Scope[keyof typeof PluginData_Scope];
/** An object representing the response of the updatePluginCollaborator mutation. */
export type Plugin_Collaborators_UpdateResponse = {
  __typename: 'Plugin_Collaborators_UpdateResponse';
  /** Whether or not the update was successful */
  success: Scalars['Boolean'];
};

/** The compliance information of the plugin. */
export type Plugin_Compliance = {
  __typename: 'Plugin_Compliance';
  /** The timestamp of when the storesPersonalData property was changed. */
  dateUpdatedStoresPersonalData: Scalars['String'];
  /** The timestamps of when the plugin last polled the compliance URLs. */
  lastPolled: Plugin_Compliance_LastPolled;
  /** Whether the plugin stores personal data. */
  storesPersonalData: Scalars['Boolean'];
};

/** The timestamps of when the plugin last polled the compliance URLs. */
export type Plugin_Compliance_LastPolled = {
  __typename: 'Plugin_Compliance_LastPolled';
  /** When it last hit the member privacy polling URL. */
  memberPrivacy: Scalars['String'];
};

/** An object representing the response from the deletePlugin mutation. */
export type Plugin_DeleteResponse = {
  __typename: 'Plugin_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

export type Plugin_EnableResponse = {
  __typename: 'Plugin_EnableResponse';
  /** Error message for why enablement failed. */
  error?: Maybe<Scalars['String']>;
  /** Whether the enablement was successful. */
  success: Scalars['Boolean'];
};

export const Plugin_Filter = {
  All: 'all',
  Available: 'available',
  Editable: 'editable',
  Enabled: 'enabled',
  HasClaimedDomains: 'hasClaimedDomains',
  None: 'none',
  Owned: 'owned'
} as const;

export type Plugin_Filter = typeof Plugin_Filter[keyof typeof Plugin_Filter];
/** The icon of a Organization Owned Plugin. */
export type Plugin_Icon = {
  __typename: 'Plugin_Icon';
  /** The URL to the icon. */
  url: Scalars['String'];
};

/** Localized listing information of a Plugin. */
export type Plugin_Listing = {
  __typename: 'Plugin_Listing';
  /** The description of the plugin. */
  description: Scalars['String'];
  /** The locale of the listing. */
  locale: Scalars['String'];
  /** The name of the plugin. */
  name: Scalars['String'];
  /** The overview of the plugin. */
  overview: Scalars['String'];
};

/** An object representing the response from the deletePluginListing mutation. */
export type Plugin_Listing_DeleteResponse = {
  __typename: 'Plugin_Listing_DeleteResponse';
  /** Whether the deletion was successful */
  success: Scalars['Boolean'];
};

/** Array of Localized listing information of a Plugin. */
export type Plugin_Listings = {
  __typename: 'Plugin_Listings';
  /** The description of the plugin. */
  description: Scalars['String'];
  /** id of the plugin listing. */
  id: Scalars['ID'];
  /** The locale of the listing. */
  locale: Scalars['String'];
  /** The name of the plugin. */
  name: Scalars['String'];
  /** The overview of the plugin. */
  overview: Scalars['String'];
};

/** The moderated state of a plugin. Used to hide or turn off problematic plugins. */
export const Plugin_ModeratedState = {
  /** The plugin is hidden from listings but still functional on boards that have it enabled. */
  Hidden: 'hidden',
  /** The plugin is hidden from listings and boards. */
  Moderated: 'moderated'
} as const;

export type Plugin_ModeratedState = typeof Plugin_ModeratedState[keyof typeof Plugin_ModeratedState];
/** A record of daily statistics about the plugin. */
export type Plugin_Stat = {
  __typename: 'Plugin_Stat';
  /** The number of boards using this plugin. */
  boardCount: Scalars['Int'];
  /** The date the stat was captured. */
  date: Scalars['String'];
};

/** Usage bracket information of the plugin. */
export type Plugin_UsageBrackets = {
  __typename: 'Plugin_UsageBrackets';
  /** The number of boards the plugin is enabled on. */
  boards: Scalars['Int'];
};

/**
 * All premium features associated with a given product returned by server
 * Should be synchronized with: https://bitbucket.org/trello/server/src/main/app/data/features.js
 */
export const PremiumFeatures = {
  Activity: 'activity',
  AdditionalBoardBackgrounds: 'additionalBoardBackgrounds',
  AdditionalStickers: 'additionalStickers',
  AdvancedChecklists: 'advancedChecklists',
  BoardExport: 'boardExport',
  Butler: 'butler',
  ButlerBc: 'butlerBC',
  ButlerEnterprise: 'butlerEnterprise',
  ButlerPremium: 'butlerPremium',
  ButlerStandard: 'butlerStandard',
  Crown: 'crown',
  CsvExport: 'csvExport',
  CustomBoardBackgrounds: 'customBoardBackgrounds',
  CustomEmoji: 'customEmoji',
  CustomStickers: 'customStickers',
  Deactivated: 'deactivated',
  EnterpriseUi: 'enterpriseUI',
  Export: 'export',
  GoldMembers: 'goldMembers',
  GoogleApps: 'googleApps',
  InfinitePlugins: 'infinitePlugins',
  InviteBoard: 'inviteBoard',
  InviteOrg: 'inviteOrg',
  IsBc: 'isBC',
  IsPremium: 'isPremium',
  IsStandard: 'isStandard',
  LabelVariants: 'labelVariants',
  LargeAttachments: 'largeAttachments',
  MultiBoardGuests: 'multiBoardGuests',
  Observers: 'observers',
  PaidCorePlugins: 'paidCorePlugins',
  Plugins: 'plugins',
  PrivateTemplates: 'privateTemplates',
  ReadSecrets: 'readSecrets',
  Removal: 'removal',
  RestrictVis: 'restrictVis',
  SavedSearches: 'savedSearches',
  ShortExportHistory: 'shortExportHistory',
  StarCounts: 'starCounts',
  Stats: 'stats',
  SuperAdmins: 'superAdmins',
  Tags: 'tags',
  ThreePlugins: 'threePlugins',
  Views: 'views'
} as const;

export type PremiumFeatures = typeof PremiumFeatures[keyof typeof PremiumFeatures];
/** Previous subscription data for cancelled or expired accounts */
export type PreviousSubscription = {
  __typename: 'PreviousSubscription';
  /** The date that the previous product was cancelled */
  dtCancelled: Scalars['String'];
  /** The previous product on the account */
  ixSubscriptionProductId: Scalars['Int'];
};

/** Price quote for a subscription */
export type PriceQuote = {
  __typename: 'PriceQuote';
  /** The number of billable collaborators being converted */
  cBillableCollaboratorConversions: Scalars['Int'];
  /** The number of billable collaborators being quoted */
  cBillableCollaborators: Scalars['Int'];
  /** The number of team members being quoted */
  cTeamMembers: Scalars['Int'];
  /** The billing date for the price quote */
  dtBilling: Scalars['String'];
  /** The expiration date of the pricing adjustment for the quote, or null */
  dtPricingAdjustmentExpiration?: Maybe<Scalars['String']>;
  /** The subscription discount type for the quote */
  ixSubscriptionDiscountType: Scalars['Int'];
  /** The product code for the product being quoted */
  ixSubscriptionProduct: Scalars['Int'];
  /** The pricing adjustment (discount multiplier) for the quote */
  nPricingAdjustment: Scalars['Float'];
  /** The subscription period in months (1 or 12) */
  nSubscriptionPeriodMonths: Scalars['Int'];
  /** The pre-tax subtotal of the quote */
  nSubtotal: Scalars['Float'];
  /** The per-user pre-tax subtotal of the quote */
  nSubtotalPerUser: Scalars['Float'];
  /** The tax for the quote, null if tax info is unavailable */
  nTax?: Maybe<Scalars['Float']>;
  /** The per-user tax for the quote, null if tax info is unavailable */
  nTaxPerUser?: Maybe<Scalars['Float']>;
  /** The tax rate for the quote, null if tax info is unavailable */
  nTaxRate?: Maybe<Scalars['Float']>;
  /** The total for the quote, null if tax info is unavailable */
  nTotal?: Maybe<Scalars['Float']>;
  /** The per-user total for the quote, null if tax info is unavailable */
  nTotalPerUser?: Maybe<Scalars['Float']>;
  /** The abbreviation for the region the tax is applied from (such as the state), null if tax info is unavailable */
  sTaxRegion?: Maybe<Scalars['String']>;
};

/** Price quotes for a subscription */
export type PriceQuoteInfo = {
  __typename: 'PriceQuoteInfo';
  /** The price quote for an annual subscription */
  annual?: Maybe<PriceQuote>;
  /** The price quote for a monthly subscription */
  monthly?: Maybe<PriceQuote>;
  /** The percentage savings for choosing an annual subscription */
  nAnnualPercentageSavings?: Maybe<Scalars['Float']>;
  /** The annual savings for choosing an annual subscription */
  nAnnualSavings?: Maybe<Scalars['Float']>;
};

/** The free trial product data on a paid workspace */
export type ProductOverride = {
  __typename: 'ProductOverride';
  /** Whether the workspace will upgrade to a new product at the end of the free trial */
  autoUpgrade: Scalars['Boolean'];
  /** The date that the free trial product will end */
  dateEnd: Scalars['String'];
  /** The date that the free trial product was started */
  dateStart: Scalars['String'];
  /** The free trial product */
  product: Scalars['Int'];
};

export type ProfileSyncResponse = {
  __typename: 'ProfileSyncResponse';
  emailVerificationRequired: Scalars['Boolean'];
  redirect_url: Scalars['String'];
};

/** Base64 encoded image data for the QR code. */
export type QrCode = {
  __typename: 'QrCode';
  imageData: Scalars['String'];
};

/** GraphQL root query type. */
export type Query = {
  __typename: 'Query';
  accessRequest: AccessRequest;
  accessRequestVerification: AccessRequestVerification;
  action?: Maybe<Action>;
  addMembersPriceQuotes: AddMembersPriceQuotes;
  announcements: Array<Announcement>;
  atlassianAccounts: Array<AtlassianAccount>;
  board?: Maybe<Board>;
  boards: Array<Board>;
  boardsSearch: Array<Maybe<Board>>;
  card?: Maybe<Card>;
  cards: Array<Card>;
  certCaptureToken: CertCaptureToken;
  checklist?: Maybe<Checklist>;
  checklists: Array<Checklist>;
  customField: CustomField;
  domain: DomainOrganization;
  /** This field will echo back the word `echo`.  Its only useful for testing */
  echo?: Maybe<Scalars['String']>;
  emailProvider: EmailProvider;
  enterprise?: Maybe<Enterprise>;
  enterprises: Array<Enterprise>;
  invitationSecret?: Maybe<BoardInviteSecret>;
  label?: Maybe<Label>;
  labels: Array<Label>;
  list?: Maybe<List>;
  lists: Array<List>;
  member?: Maybe<Member>;
  memberCards: Array<Card>;
  memberSearch: Array<Maybe<Member_Search_Result>>;
  members: Array<Member>;
  modelType: ModelType;
  newSubscriptionListPriceQuotes: ListPriceQuoteInfo;
  newSubscriptionPriceQuotes: PriceQuoteInfo;
  notificationGroups?: Maybe<Array<Maybe<NotificationGroup>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  notificationsCount?: Maybe<Scalars['JSONString']>;
  organization?: Maybe<Organization>;
  organizationInviteSecret?: Maybe<OrganizationInviteSecretResponse>;
  organizationMemberCards: Array<Card>;
  organizationView?: Maybe<OrganizationView>;
  organizationViews: Array<OrganizationView>;
  organizations: Array<Organization>;
  plugin?: Maybe<Plugin>;
  pluginCategories: Array<Scalars['String']>;
  plugins: Array<Plugin>;
  publicPlugins: Array<Plugin>;
  qrCode: QrCode;
  renewalPriceQuotes: PriceQuoteInfo;
  search: Search;
  selfServeExpansionEstimate: ExpansionPriceEstimate;
  statements: Array<Statement>;
  templateCategories: Array<TemplateCategory>;
  templateGallery: Array<Board>;
  templateLanguages: Array<TemplateLanguage>;
  trello?: Maybe<TrelloQueryApi>;
  unsplashPhotos: Array<UnsplashPhoto>;
  upgradePriceQuotes: UpgradePriceQuoteInfo;
};


/** GraphQL root query type. */
export type QueryAccessRequestArgs = {
  id: Scalars['ID'];
  modelType: RequestAccessModelType;
  traceId?: InputMaybe<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryAccessRequestVerificationArgs = {
  id: Scalars['ID'];
  idInvitedMember: Scalars['ID'];
  modelType: RequestAccessModelType;
  signature?: InputMaybe<Scalars['String']>;
  traceId?: InputMaybe<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryActionArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryAddMembersPriceQuotesArgs = {
  accountId: Scalars['ID'];
  members: Array<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryAnnouncementsArgs = {
  filter?: InputMaybe<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryBoardArgs = {
  count?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  organizationDisableMock?: InputMaybe<Scalars['Boolean']>;
};


/** GraphQL root query type. */
export type QueryBoardsArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryBoardsSearchArgs = {
  limit: Scalars['Int'];
  query: Scalars['String'];
};


/** GraphQL root query type. */
export type QueryCardArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryCardsArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryCertCaptureTokenArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
};


/** GraphQL root query type. */
export type QueryChecklistArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryChecklistsArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryCustomFieldArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryDomainArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


/** GraphQL root query type. */
export type QueryEmailProviderArgs = {
  email: Scalars['String'];
};


/** GraphQL root query type. */
export type QueryEnterpriseArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryEnterprisesArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryInvitationSecretArgs = {
  idBoard: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryLabelArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryLabelsArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryListArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryListsArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryMemberArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryMemberCardsArgs = {
  before?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  modifiedSince?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryMemberSearchArgs = {
  idBoard?: InputMaybe<Scalars['ID']>;
  idOrganization?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  onlyOrgMembers?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
};


/** GraphQL root query type. */
export type QueryMembersArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryModelTypeArgs = {
  idOrName: Scalars['String'];
};


/** GraphQL root query type. */
export type QueryNewSubscriptionListPriceQuotesArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
  includeUnconfirmed?: InputMaybe<Scalars['Boolean']>;
  product: Scalars['Int'];
};


/** GraphQL root query type. */
export type QueryNewSubscriptionPriceQuotesArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
  country: Scalars['String'];
  includeUnconfirmed?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  product: Scalars['Int'];
  promoCode?: InputMaybe<Scalars['String']>;
  stateTaxId?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryNotificationGroupsArgs = {
  idCards?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** GraphQL root query type. */
export type QueryNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  readFilter?: InputMaybe<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryNotificationsCountArgs = {
  filter?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
};


/** GraphQL root query type. */
export type QueryOrganizationArgs = {
  boardIds?: InputMaybe<Array<Scalars['ID']>>;
  boardsCount?: InputMaybe<Scalars['Int']>;
  boardsStartIndex?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  organizationViewsFilter?: InputMaybe<Array<OrganizationView_Filters>>;
};


/** GraphQL root query type. */
export type QueryOrganizationInviteSecretArgs = {
  idOrganization: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryOrganizationMemberCardsArgs = {
  id: Scalars['ID'];
  idMember: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryOrganizationViewArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryOrganizationViewsArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryOrganizationsArgs = {
  ids: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryPluginArgs = {
  id: Scalars['ID'];
};


/** GraphQL root query type. */
export type QueryPluginsArgs = {
  id: Array<Scalars['ID']>;
};


/** GraphQL root query type. */
export type QueryPublicPluginsArgs = {
  preferredLocales?: InputMaybe<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryQrCodeArgs = {
  url: Scalars['String'];
};


/** GraphQL root query type. */
export type QueryRenewalPriceQuotesArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
};


/** GraphQL root query type. */
export type QuerySearchArgs = {
  idBoards?: InputMaybe<Array<Scalars['ID']>>;
  idCards?: InputMaybe<Array<Scalars['ID']>>;
  idOrganizations?: InputMaybe<Array<Scalars['ID']>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  partial?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
};


/** GraphQL root query type. */
export type QuerySelfServeExpansionEstimateArgs = {
  idEnterprise: Scalars['String'];
  seats: Scalars['Int'];
};


/** GraphQL root query type. */
export type QueryStatementsArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
};


/** GraphQL root query type. */
export type QueryTemplateGalleryArgs = {
  locale: Scalars['String'];
};


/** GraphQL root query type. */
export type QueryUnsplashPhotosArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


/** GraphQL root query type. */
export type QueryUpgradePriceQuotesArgs = {
  accountId: Scalars['ID'];
  accountType: PaidAccountType;
  product: Scalars['Int'];
};

/**
 * The available rate limit budgets,
 * denominated by the currency enums,
 * that a client of this GraphQL API is
 * able to operate against.
 */
export const RateLimitingCurrency = {
  TrelloCurrency: 'TRELLO_CURRENCY'
} as const;

export type RateLimitingCurrency = typeof RateLimitingCurrency[keyof typeof RateLimitingCurrency];
/** Reactions give Members the option to add an emoji to an Action. */
export type Reaction = {
  __typename: 'Reaction';
  /** The Emoji used on the Reaction */
  emoji: Reaction_Emoji;
  /** The ID of the Reaction */
  id: Scalars['ID'];
  /** The ID of the emoji used in the Reaction */
  idEmoji: Scalars['String'];
  /** The ID of the Member who added the Reaction */
  idMember: Scalars['String'];
  /** The ID of the entity this Reaction is on */
  idModel: Scalars['String'];
  /** The Member who added the Reaction */
  member: Member;
};

/** The emoji used on the Reaction */
export type Reaction_Emoji = {
  __typename: 'Reaction_Emoji';
  /** The name of the Emoji */
  name: Scalars['String'];
  /** The native Emoji */
  native: Scalars['String'];
  /** The short name for the Emoji */
  shortName: Scalars['String'];
  /** The skin variation of the Emoji */
  skinVariation?: Maybe<Scalars['String']>;
  /** The ID of the Emoji */
  unified: Scalars['String'];
};

/** Information about Recommended Members */
export type RecommendedMember = {
  __typename: 'RecommendedMember';
  /** Whether the member has been active recently */
  active?: Maybe<Scalars['Boolean']>;
  /** Whether activity has been blocked for this Member */
  activityBlocked?: Maybe<Scalars['Boolean']>;
  /** Avatar hash of the member */
  avatarHash?: Maybe<Scalars['String']>;
  /** The URL of the current avatar being used, regardless of whether it is a gravatar or uploaded avatar. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Whether the member has confirmed their email address after signing up. */
  confirmed?: Maybe<Scalars['Boolean']>;
  /** The primary email address for the member. You can only read your own. */
  email?: Maybe<Scalars['String']>;
  /** The full display name for the member. */
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** An array of board IDs this member is on. */
  idBoards?: Maybe<Array<Scalars['String']>>;
  /** The id of the Member that referred this Member to Trello */
  idMemberReferrer?: Maybe<Scalars['String']>;
  /** An array of organization IDs this member is in. */
  idOrganizations?: Maybe<Array<Scalars['String']>>;
  /** The member's initials, used for display when there isn't an avatar set. */
  initials?: Maybe<Scalars['String']>;
  /** One of: 'normal', 'ghost'. A ghost is an individual who has been invited to join but has not yet created a Trello account. */
  memberType: Member_MemberType;
  /** The information the Member has chosen to be non-public */
  nonPublic?: Maybe<Member_NonPublic>;
  /** Whether non public information is available for the Member */
  nonPublicAvailable?: Maybe<Scalars['Boolean']>;
  /** Short for 'preferences', these are the settings for the board */
  prefs?: Maybe<Board_Prefs>;
  /** The username for the member. What is shown in @mentions for example. */
  username?: Maybe<Scalars['String']>;
  /** Indicates whether this member would be become a multi-board billable guest */
  wouldBecomeBillableGuest?: Maybe<Scalars['Boolean']>;
};

/** Response from removing a member from a Workspace */
export type RemoveMembersFromWorkspace_Response = {
  __typename: 'RemoveMembersFromWorkspace_Response';
  success: Scalars['Boolean'];
};

/** Request Access to cards/boards */
export const RequestAccessModelType = {
  Board: 'board',
  Card: 'card',
  Organization: 'organization'
} as const;

export type RequestAccessModelType = typeof RequestAccessModelType[keyof typeof RequestAccessModelType];
/** The data necessary to render Aa onboarding UI */
export type RequiresAaOnboarding = {
  __typename: 'RequiresAaOnboarding';
  /** The user's Trello Enterprise data */
  enterprise?: Maybe<Enterprise>;
  /** The user's Aa profile data */
  profile?: Maybe<AaOnboardingProfile>;
  /**
   * The Aa onboarding UI to render
   * values: domainClaim | inactive | enterprise
   */
  template?: Maybe<Scalars['String']>;
};

/** A saved search query belonging to a Member */
export type SavedSearch = {
  __typename: 'SavedSearch';
  /** The ID of the saved search */
  id: Scalars['ID'];
  /** The name of the saved search */
  name: Scalars['String'];
  /** The position of the saved search in the UI */
  pos: Scalars['Int'];
  /** The query of the saved search */
  query: Scalars['String'];
};

/** An object representing the product code and dates for the next product subscribed */
export type ScheduledChange = {
  __typename: 'ScheduledChange';
  ixSubscriptionProduct: Scalars['Int'];
  nextChangeTimestamp: Scalars['String'];
};

export const Scope = {
  /** outbound-auth */
  AdminContainer: 'ADMIN_CONTAINER',
  /**
   * jira - granular scopes.
   * Each Jira Mutation and Query should have one or more of these in an `@scope` tag and one of the non-granular scopes above
   */
  ApplicationRoleRead: 'APPLICATION_ROLE_READ',
  AsyncTaskDelete: 'ASYNC_TASK_DELETE',
  AttachmentDelete: 'ATTACHMENT_DELETE',
  AttachmentRead: 'ATTACHMENT_READ',
  AttachmentWrite: 'ATTACHMENT_WRITE',
  AuditLogRead: 'AUDIT_LOG_READ',
  AuthConfluenceUser: 'AUTH_CONFLUENCE_USER',
  AvatarDelete: 'AVATAR_DELETE',
  AvatarRead: 'AVATAR_READ',
  AvatarWrite: 'AVATAR_WRITE',
  CommentDelete: 'COMMENT_DELETE',
  CommentPropertyDelete: 'COMMENT_PROPERTY_DELETE',
  CommentPropertyRead: 'COMMENT_PROPERTY_READ',
  CommentPropertyWrite: 'COMMENT_PROPERTY_WRITE',
  CommentRead: 'COMMENT_READ',
  CommentWrite: 'COMMENT_WRITE',
  /** compass */
  CompassAtlassianExternal: 'COMPASS_ATLASSIAN_EXTERNAL',
  /** confluence */
  ConfluenceAtlassianExternal: 'CONFLUENCE_ATLASSIAN_EXTERNAL',
  CustomFieldContextualConfigurationRead: 'CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_READ',
  CustomFieldContextualConfigurationWrite: 'CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_WRITE',
  DashboardDelete: 'DASHBOARD_DELETE',
  DashboardPropertyDelete: 'DASHBOARD_PROPERTY_DELETE',
  DashboardPropertyRead: 'DASHBOARD_PROPERTY_READ',
  DashboardPropertyWrite: 'DASHBOARD_PROPERTY_WRITE',
  DashboardRead: 'DASHBOARD_READ',
  DashboardWrite: 'DASHBOARD_WRITE',
  DeleteConfluenceAttachment: 'DELETE_CONFLUENCE_ATTACHMENT',
  DeleteConfluenceBlogpost: 'DELETE_CONFLUENCE_BLOGPOST',
  DeleteConfluenceComment: 'DELETE_CONFLUENCE_COMMENT',
  DeleteConfluenceCustomContent: 'DELETE_CONFLUENCE_CUSTOM_CONTENT',
  DeleteConfluencePage: 'DELETE_CONFLUENCE_PAGE',
  DeleteConfluenceSpace: 'DELETE_CONFLUENCE_SPACE',
  DeleteJswBoardScopeAdmin: 'DELETE_JSW_BOARD_SCOPE_ADMIN',
  DeleteJswSprint: 'DELETE_JSW_SPRINT',
  DeleteOrganization: 'DELETE_ORGANIZATION',
  DeleteOrganizationProperty: 'DELETE_ORGANIZATION_PROPERTY',
  DeleteOrganizationUser: 'DELETE_ORGANIZATION_USER',
  DeleteRequesttypeProperty: 'DELETE_REQUESTTYPE_PROPERTY',
  DeleteRequestFeedback: 'DELETE_REQUEST_FEEDBACK',
  DeleteRequestNotification: 'DELETE_REQUEST_NOTIFICATION',
  DeleteRequestParticipant: 'DELETE_REQUEST_PARTICIPANT',
  DeleteServicedeskCustomer: 'DELETE_SERVICEDESK_CUSTOMER',
  DeleteServicedeskOrganization: 'DELETE_SERVICEDESK_ORGANIZATION',
  DeleteServicedeskProperty: 'DELETE_SERVICEDESK_PROPERTY',
  FieldConfigurationDelete: 'FIELD_CONFIGURATION_DELETE',
  FieldConfigurationRead: 'FIELD_CONFIGURATION_READ',
  FieldConfigurationSchemeDelete: 'FIELD_CONFIGURATION_SCHEME_DELETE',
  FieldConfigurationSchemeRead: 'FIELD_CONFIGURATION_SCHEME_READ',
  FieldConfigurationSchemeWrite: 'FIELD_CONFIGURATION_SCHEME_WRITE',
  FieldConfigurationWrite: 'FIELD_CONFIGURATION_WRITE',
  FieldDefaultValueRead: 'FIELD_DEFAULT_VALUE_READ',
  FieldDefaultValueWrite: 'FIELD_DEFAULT_VALUE_WRITE',
  FieldDelete: 'FIELD_DELETE',
  FieldOptionsRead: 'FIELD_OPTIONS_READ',
  FieldOptionDelete: 'FIELD_OPTION_DELETE',
  FieldOptionRead: 'FIELD_OPTION_READ',
  FieldOptionWrite: 'FIELD_OPTION_WRITE',
  FieldRead: 'FIELD_READ',
  FieldWrite: 'FIELD_WRITE',
  FilterColumnDelete: 'FILTER_COLUMN_DELETE',
  FilterColumnRead: 'FILTER_COLUMN_READ',
  FilterColumnWrite: 'FILTER_COLUMN_WRITE',
  FilterDefaultShareScopeRead: 'FILTER_DEFAULT_SHARE_SCOPE_READ',
  FilterDefaultShareScopeWrite: 'FILTER_DEFAULT_SHARE_SCOPE_WRITE',
  FilterDelete: 'FILTER_DELETE',
  FilterRead: 'FILTER_READ',
  FilterWrite: 'FILTER_WRITE',
  GroupDelete: 'GROUP_DELETE',
  GroupRead: 'GROUP_READ',
  GroupWrite: 'GROUP_WRITE',
  IdentityAtlassianExternal: 'IDENTITY_ATLASSIAN_EXTERNAL',
  InstanceConfigurationRead: 'INSTANCE_CONFIGURATION_READ',
  InstanceConfigurationWrite: 'INSTANCE_CONFIGURATION_WRITE',
  IssueAdjustmentsDelete: 'ISSUE_ADJUSTMENTS_DELETE',
  IssueAdjustmentsRead: 'ISSUE_ADJUSTMENTS_READ',
  IssueAdjustmentsWrite: 'ISSUE_ADJUSTMENTS_WRITE',
  IssueChangelogRead: 'ISSUE_CHANGELOG_READ',
  IssueDelete: 'ISSUE_DELETE',
  IssueDetailsRead: 'ISSUE_DETAILS_READ',
  IssueEventRead: 'ISSUE_EVENT_READ',
  IssueFieldValuesRead: 'ISSUE_FIELD_VALUES_READ',
  IssueLinkDelete: 'ISSUE_LINK_DELETE',
  IssueLinkRead: 'ISSUE_LINK_READ',
  IssueLinkTypeDelete: 'ISSUE_LINK_TYPE_DELETE',
  IssueLinkTypeRead: 'ISSUE_LINK_TYPE_READ',
  IssueLinkTypeWrite: 'ISSUE_LINK_TYPE_WRITE',
  IssueLinkWrite: 'ISSUE_LINK_WRITE',
  IssueMetaRead: 'ISSUE_META_READ',
  IssuePropertyDelete: 'ISSUE_PROPERTY_DELETE',
  IssuePropertyRead: 'ISSUE_PROPERTY_READ',
  IssuePropertyWrite: 'ISSUE_PROPERTY_WRITE',
  IssueRead: 'ISSUE_READ',
  IssueRemoteLinkDelete: 'ISSUE_REMOTE_LINK_DELETE',
  IssueRemoteLinkRead: 'ISSUE_REMOTE_LINK_READ',
  IssueRemoteLinkWrite: 'ISSUE_REMOTE_LINK_WRITE',
  IssueSecurityLevelRead: 'ISSUE_SECURITY_LEVEL_READ',
  IssueSecuritySchemeRead: 'ISSUE_SECURITY_SCHEME_READ',
  IssueStatusRead: 'ISSUE_STATUS_READ',
  IssueTimeTrackingRead: 'ISSUE_TIME_TRACKING_READ',
  IssueTimeTrackingWrite: 'ISSUE_TIME_TRACKING_WRITE',
  IssueTransitionRead: 'ISSUE_TRANSITION_READ',
  IssueTypeDelete: 'ISSUE_TYPE_DELETE',
  IssueTypeHierarchyRead: 'ISSUE_TYPE_HIERARCHY_READ',
  IssueTypePropertyDelete: 'ISSUE_TYPE_PROPERTY_DELETE',
  IssueTypePropertyRead: 'ISSUE_TYPE_PROPERTY_READ',
  IssueTypePropertyWrite: 'ISSUE_TYPE_PROPERTY_WRITE',
  IssueTypeRead: 'ISSUE_TYPE_READ',
  IssueTypeSchemeDelete: 'ISSUE_TYPE_SCHEME_DELETE',
  IssueTypeSchemeRead: 'ISSUE_TYPE_SCHEME_READ',
  IssueTypeSchemeWrite: 'ISSUE_TYPE_SCHEME_WRITE',
  IssueTypeScreenSchemeDelete: 'ISSUE_TYPE_SCREEN_SCHEME_DELETE',
  IssueTypeScreenSchemeRead: 'ISSUE_TYPE_SCREEN_SCHEME_READ',
  IssueTypeScreenSchemeWrite: 'ISSUE_TYPE_SCREEN_SCHEME_WRITE',
  IssueTypeWrite: 'ISSUE_TYPE_WRITE',
  IssueVotesRead: 'ISSUE_VOTES_READ',
  IssueVoteRead: 'ISSUE_VOTE_READ',
  IssueVoteWrite: 'ISSUE_VOTE_WRITE',
  IssueWatcherRead: 'ISSUE_WATCHER_READ',
  IssueWatcherWrite: 'ISSUE_WATCHER_WRITE',
  IssueWorklogDelete: 'ISSUE_WORKLOG_DELETE',
  IssueWorklogPropertyDelete: 'ISSUE_WORKLOG_PROPERTY_DELETE',
  IssueWorklogPropertyRead: 'ISSUE_WORKLOG_PROPERTY_READ',
  IssueWorklogPropertyWrite: 'ISSUE_WORKLOG_PROPERTY_WRITE',
  IssueWorklogRead: 'ISSUE_WORKLOG_READ',
  IssueWorklogWrite: 'ISSUE_WORKLOG_WRITE',
  IssueWrite: 'ISSUE_WRITE',
  JiraAtlassianExternal: 'JIRA_ATLASSIAN_EXTERNAL',
  JiraExpressionsRead: 'JIRA_EXPRESSIONS_READ',
  JqlRead: 'JQL_READ',
  JqlValidate: 'JQL_VALIDATE',
  LabelRead: 'LABEL_READ',
  LicenseRead: 'LICENSE_READ',
  /** ecosystem */
  ManageApp: 'MANAGE_APP',
  ManageDirectory: 'MANAGE_DIRECTORY',
  ManageJiraConfiguration: 'MANAGE_JIRA_CONFIGURATION',
  ManageJiraDataProvider: 'MANAGE_JIRA_DATA_PROVIDER',
  ManageJiraProject: 'MANAGE_JIRA_PROJECT',
  ManageJiraWebhook: 'MANAGE_JIRA_WEBHOOK',
  /** identity */
  ManageOrg: 'MANAGE_ORG',
  ManageServicedeskCustomer: 'MANAGE_SERVICEDESK_CUSTOMER',
  /** platform */
  MigrateConfluence: 'MIGRATE_CONFLUENCE',
  NotificationSchemeRead: 'NOTIFICATION_SCHEME_READ',
  NotificationSend: 'NOTIFICATION_SEND',
  PermissionDelete: 'PERMISSION_DELETE',
  PermissionRead: 'PERMISSION_READ',
  PermissionSchemeDelete: 'PERMISSION_SCHEME_DELETE',
  PermissionSchemeRead: 'PERMISSION_SCHEME_READ',
  PermissionSchemeWrite: 'PERMISSION_SCHEME_WRITE',
  PermissionWrite: 'PERMISSION_WRITE',
  PriorityRead: 'PRIORITY_READ',
  ProjectAvatarDelete: 'PROJECT_AVATAR_DELETE',
  ProjectAvatarRead: 'PROJECT_AVATAR_READ',
  ProjectAvatarWrite: 'PROJECT_AVATAR_WRITE',
  ProjectCategoryDelete: 'PROJECT_CATEGORY_DELETE',
  ProjectCategoryRead: 'PROJECT_CATEGORY_READ',
  ProjectCategoryWrite: 'PROJECT_CATEGORY_WRITE',
  ProjectComponentDelete: 'PROJECT_COMPONENT_DELETE',
  ProjectComponentRead: 'PROJECT_COMPONENT_READ',
  ProjectComponentWrite: 'PROJECT_COMPONENT_WRITE',
  ProjectDelete: 'PROJECT_DELETE',
  ProjectEmailRead: 'PROJECT_EMAIL_READ',
  ProjectEmailWrite: 'PROJECT_EMAIL_WRITE',
  ProjectFeatureRead: 'PROJECT_FEATURE_READ',
  ProjectFeatureWrite: 'PROJECT_FEATURE_WRITE',
  ProjectPropertyDelete: 'PROJECT_PROPERTY_DELETE',
  ProjectPropertyRead: 'PROJECT_PROPERTY_READ',
  ProjectPropertyWrite: 'PROJECT_PROPERTY_WRITE',
  ProjectRead: 'PROJECT_READ',
  ProjectRoleDelete: 'PROJECT_ROLE_DELETE',
  ProjectRoleRead: 'PROJECT_ROLE_READ',
  ProjectRoleWrite: 'PROJECT_ROLE_WRITE',
  ProjectTypeRead: 'PROJECT_TYPE_READ',
  ProjectVersionDelete: 'PROJECT_VERSION_DELETE',
  ProjectVersionRead: 'PROJECT_VERSION_READ',
  ProjectVersionWrite: 'PROJECT_VERSION_WRITE',
  ProjectWrite: 'PROJECT_WRITE',
  ReadAccount: 'READ_ACCOUNT',
  /** avocado */
  ReadAvocadoEntity: 'READ_AVOCADO_ENTITY',
  ReadCompassComponent: 'READ_COMPASS_COMPONENT',
  ReadCompassEvent: 'READ_COMPASS_EVENT',
  ReadCompassMetric: 'READ_COMPASS_METRIC',
  ReadCompassScorecard: 'READ_COMPASS_SCORECARD',
  ReadConfluenceAttachment: 'READ_CONFLUENCE_ATTACHMENT',
  ReadConfluenceAuditLog: 'READ_CONFLUENCE_AUDIT_LOG',
  ReadConfluenceBlogpost: 'READ_CONFLUENCE_BLOGPOST',
  ReadConfluenceComment: 'READ_CONFLUENCE_COMMENT',
  ReadConfluenceConfiguration: 'READ_CONFLUENCE_CONFIGURATION',
  ReadConfluenceContentAnalytics: 'READ_CONFLUENCE_CONTENT_ANALYTICS',
  ReadConfluenceContentMetadata: 'READ_CONFLUENCE_CONTENT_METADATA',
  ReadConfluenceContentPermission: 'READ_CONFLUENCE_CONTENT_PERMISSION',
  ReadConfluenceContentProperty: 'READ_CONFLUENCE_CONTENT_PROPERTY',
  ReadConfluenceContentRestriction: 'READ_CONFLUENCE_CONTENT_RESTRICTION',
  ReadConfluenceCustomContent: 'READ_CONFLUENCE_CUSTOM_CONTENT',
  ReadConfluenceGroup: 'READ_CONFLUENCE_GROUP',
  ReadConfluenceInlineTask: 'READ_CONFLUENCE_INLINE_TASK',
  ReadConfluenceLabel: 'READ_CONFLUENCE_LABEL',
  ReadConfluencePage: 'READ_CONFLUENCE_PAGE',
  ReadConfluenceRelation: 'READ_CONFLUENCE_RELATION',
  ReadConfluenceSpace: 'READ_CONFLUENCE_SPACE',
  ReadConfluenceSpacePermission: 'READ_CONFLUENCE_SPACE_PERMISSION',
  ReadConfluenceSpaceProperty: 'READ_CONFLUENCE_SPACE_PROPERTY',
  ReadConfluenceSpaceSetting: 'READ_CONFLUENCE_SPACE_SETTING',
  ReadConfluenceTemplate: 'READ_CONFLUENCE_TEMPLATE',
  ReadConfluenceUser: 'READ_CONFLUENCE_USER',
  ReadConfluenceUserProperty: 'READ_CONFLUENCE_USER_PROPERTY',
  ReadConfluenceWatcher: 'READ_CONFLUENCE_WATCHER',
  ReadContainer: 'READ_CONTAINER',
  /**
   * jira-servicedesk - granular
   * Each JSM Mutation and Query should have one or more of these in an `@scope` tag and one of the non-granular scopes above.
   * You can mix them with Jira scopes if needed.
   */
  ReadCustomer: 'READ_CUSTOMER',
  /**
   * jira - non granular
   * Please add a granular scope as well.
   */
  ReadJiraUser: 'READ_JIRA_USER',
  ReadJiraWork: 'READ_JIRA_WORK',
  /**
   * jsw scopes
   * Note - JSW does not have non granular scopes so it does not need two scope tags like JSM/Jira
   */
  ReadJswBoardScope: 'READ_JSW_BOARD_SCOPE',
  ReadJswBoardScopeAdmin: 'READ_JSW_BOARD_SCOPE_ADMIN',
  ReadJswBuild: 'READ_JSW_BUILD',
  ReadJswDeployment: 'READ_JSW_DEPLOYMENT',
  ReadJswEpic: 'READ_JSW_EPIC',
  ReadJswFeatureFlag: 'READ_JSW_FEATURE_FLAG',
  ReadJswIssue: 'READ_JSW_ISSUE',
  ReadJswRemoteLink: 'READ_JSW_REMOTE_LINK',
  ReadJswSourceCode: 'READ_JSW_SOURCE_CODE',
  ReadJswSprint: 'READ_JSW_SPRINT',
  ReadKnowledgebase: 'READ_KNOWLEDGEBASE',
  ReadMe: 'READ_ME',
  /** notification-log */
  ReadNotifications: 'READ_NOTIFICATIONS',
  ReadOrganization: 'READ_ORGANIZATION',
  ReadOrganizationProperty: 'READ_ORGANIZATION_PROPERTY',
  ReadOrganizationUser: 'READ_ORGANIZATION_USER',
  ReadQueue: 'READ_QUEUE',
  ReadRequest: 'READ_REQUEST',
  ReadRequesttype: 'READ_REQUESTTYPE',
  ReadRequesttypeProperty: 'READ_REQUESTTYPE_PROPERTY',
  ReadRequestAction: 'READ_REQUEST_ACTION',
  ReadRequestApproval: 'READ_REQUEST_APPROVAL',
  ReadRequestAttachment: 'READ_REQUEST_ATTACHMENT',
  ReadRequestComment: 'READ_REQUEST_COMMENT',
  ReadRequestFeedback: 'READ_REQUEST_FEEDBACK',
  ReadRequestNotification: 'READ_REQUEST_NOTIFICATION',
  ReadRequestParticipant: 'READ_REQUEST_PARTICIPANT',
  ReadRequestSla: 'READ_REQUEST_SLA',
  ReadRequestStatus: 'READ_REQUEST_STATUS',
  ReadServicedesk: 'READ_SERVICEDESK',
  ReadServicedeskCustomer: 'READ_SERVICEDESK_CUSTOMER',
  ReadServicedeskOrganization: 'READ_SERVICEDESK_ORGANIZATION',
  ReadServicedeskProperty: 'READ_SERVICEDESK_PROPERTY',
  /**
   * jira-servicedesk - non-granular
   * Please add a granular scope as well.
   */
  ReadServicedeskRequest: 'READ_SERVICEDESK_REQUEST',
  ResolutionRead: 'RESOLUTION_READ',
  ScreenableFieldDelete: 'SCREENABLE_FIELD_DELETE',
  ScreenableFieldRead: 'SCREENABLE_FIELD_READ',
  ScreenableFieldWrite: 'SCREENABLE_FIELD_WRITE',
  ScreenDelete: 'SCREEN_DELETE',
  ScreenFieldRead: 'SCREEN_FIELD_READ',
  ScreenRead: 'SCREEN_READ',
  ScreenSchemeDelete: 'SCREEN_SCHEME_DELETE',
  ScreenSchemeRead: 'SCREEN_SCHEME_READ',
  ScreenSchemeWrite: 'SCREEN_SCHEME_WRITE',
  ScreenTabDelete: 'SCREEN_TAB_DELETE',
  ScreenTabRead: 'SCREEN_TAB_READ',
  ScreenTabWrite: 'SCREEN_TAB_WRITE',
  ScreenWrite: 'SCREEN_WRITE',
  StatusRead: 'STATUS_READ',
  StorageApp: 'STORAGE_APP',
  UserColumnsRead: 'USER_COLUMNS_READ',
  UserConfigurationDelete: 'USER_CONFIGURATION_DELETE',
  UserConfigurationRead: 'USER_CONFIGURATION_READ',
  UserConfigurationWrite: 'USER_CONFIGURATION_WRITE',
  UserPropertyDelete: 'USER_PROPERTY_DELETE',
  UserPropertyRead: 'USER_PROPERTY_READ',
  UserPropertyWrite: 'USER_PROPERTY_WRITE',
  UserRead: 'USER_READ',
  ViewUserprofile: 'VIEW_USERPROFILE',
  WebhookDelete: 'WEBHOOK_DELETE',
  WebhookRead: 'WEBHOOK_READ',
  WebhookWrite: 'WEBHOOK_WRITE',
  WorkflowDelete: 'WORKFLOW_DELETE',
  WorkflowPropertyDelete: 'WORKFLOW_PROPERTY_DELETE',
  WorkflowPropertyRead: 'WORKFLOW_PROPERTY_READ',
  WorkflowPropertyWrite: 'WORKFLOW_PROPERTY_WRITE',
  WorkflowRead: 'WORKFLOW_READ',
  WorkflowSchemeDelete: 'WORKFLOW_SCHEME_DELETE',
  WorkflowSchemeRead: 'WORKFLOW_SCHEME_READ',
  WorkflowSchemeWrite: 'WORKFLOW_SCHEME_WRITE',
  WorkflowWrite: 'WORKFLOW_WRITE',
  WriteCompassComponent: 'WRITE_COMPASS_COMPONENT',
  WriteCompassEvent: 'WRITE_COMPASS_EVENT',
  WriteCompassMetric: 'WRITE_COMPASS_METRIC',
  WriteCompassScorecard: 'WRITE_COMPASS_SCORECARD',
  WriteConfluenceAttachment: 'WRITE_CONFLUENCE_ATTACHMENT',
  WriteConfluenceAuditLog: 'WRITE_CONFLUENCE_AUDIT_LOG',
  WriteConfluenceBlogpost: 'WRITE_CONFLUENCE_BLOGPOST',
  WriteConfluenceComment: 'WRITE_CONFLUENCE_COMMENT',
  WriteConfluenceConfiguration: 'WRITE_CONFLUENCE_CONFIGURATION',
  WriteConfluenceContentProperty: 'WRITE_CONFLUENCE_CONTENT_PROPERTY',
  WriteConfluenceContentRestriction: 'WRITE_CONFLUENCE_CONTENT_RESTRICTION',
  WriteConfluenceCustomContent: 'WRITE_CONFLUENCE_CUSTOM_CONTENT',
  WriteConfluenceGroup: 'WRITE_CONFLUENCE_GROUP',
  WriteConfluenceInlineTask: 'WRITE_CONFLUENCE_INLINE_TASK',
  WriteConfluenceLabel: 'WRITE_CONFLUENCE_LABEL',
  WriteConfluencePage: 'WRITE_CONFLUENCE_PAGE',
  WriteConfluenceRelation: 'WRITE_CONFLUENCE_RELATION',
  WriteConfluenceSpace: 'WRITE_CONFLUENCE_SPACE',
  WriteConfluenceSpacePermission: 'WRITE_CONFLUENCE_SPACE_PERMISSION',
  WriteConfluenceSpaceProperty: 'WRITE_CONFLUENCE_SPACE_PROPERTY',
  WriteConfluenceSpaceSetting: 'WRITE_CONFLUENCE_SPACE_SETTING',
  WriteConfluenceTemplate: 'WRITE_CONFLUENCE_TEMPLATE',
  WriteConfluenceUserProperty: 'WRITE_CONFLUENCE_USER_PROPERTY',
  WriteConfluenceWatcher: 'WRITE_CONFLUENCE_WATCHER',
  WriteContainer: 'WRITE_CONTAINER',
  WriteCustomer: 'WRITE_CUSTOMER',
  WriteJiraWork: 'WRITE_JIRA_WORK',
  WriteJswBoardScope: 'WRITE_JSW_BOARD_SCOPE',
  WriteJswBoardScopeAdmin: 'WRITE_JSW_BOARD_SCOPE_ADMIN',
  WriteJswBuild: 'WRITE_JSW_BUILD',
  WriteJswDeployment: 'WRITE_JSW_DEPLOYMENT',
  WriteJswEpic: 'WRITE_JSW_EPIC',
  WriteJswFeatureFlag: 'WRITE_JSW_FEATURE_FLAG',
  WriteJswIssue: 'WRITE_JSW_ISSUE',
  WriteJswRemoteLink: 'WRITE_JSW_REMOTE_LINK',
  WriteJswSourceCode: 'WRITE_JSW_SOURCE_CODE',
  WriteJswSprint: 'WRITE_JSW_SPRINT',
  WriteNotifications: 'WRITE_NOTIFICATIONS',
  WriteOrganization: 'WRITE_ORGANIZATION',
  WriteOrganizationProperty: 'WRITE_ORGANIZATION_PROPERTY',
  WriteOrganizationUser: 'WRITE_ORGANIZATION_USER',
  WriteRequest: 'WRITE_REQUEST',
  WriteRequesttype: 'WRITE_REQUESTTYPE',
  WriteRequesttypeProperty: 'WRITE_REQUESTTYPE_PROPERTY',
  WriteRequestApproval: 'WRITE_REQUEST_APPROVAL',
  WriteRequestAttachment: 'WRITE_REQUEST_ATTACHMENT',
  WriteRequestComment: 'WRITE_REQUEST_COMMENT',
  WriteRequestFeedback: 'WRITE_REQUEST_FEEDBACK',
  WriteRequestNotification: 'WRITE_REQUEST_NOTIFICATION',
  WriteRequestParticipant: 'WRITE_REQUEST_PARTICIPANT',
  WriteRequestStatus: 'WRITE_REQUEST_STATUS',
  WriteServicedesk: 'WRITE_SERVICEDESK',
  WriteServicedeskCustomer: 'WRITE_SERVICEDESK_CUSTOMER',
  WriteServicedeskOrganization: 'WRITE_SERVICEDESK_ORGANIZATION',
  WriteServicedeskProperty: 'WRITE_SERVICEDESK_PROPERTY',
  WriteServicedeskRequest: 'WRITE_SERVICEDESK_REQUEST'
} as const;

export type Scope = typeof Scope[keyof typeof Scope];
/** The result returned from a search query */
export type Search = {
  __typename: 'Search';
  /** Board results from the search */
  boards: Array<Board>;
  /** Card results from the search */
  cards: Array<Card>;
  /**
   * There is currently a server bug where the `members` field
   * won't be present if there are no member results. `members`
   * should be non-nullable when that bug is fixed.
   *
   * Member results from the search
   */
  members?: Maybe<Array<Member>>;
  /** Info about the search performed */
  options?: Maybe<Search_Options>;
  /** Organization results from the search */
  organizations: Array<Organization>;
};


/** The result returned from a search query */
export type SearchBoardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** The result returned from a search query */
export type SearchCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


/** The result returned from a search query */
export type SearchMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** The result returned from a search query */
export type SearchOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/** Info about the options passed to the performed search */
export type Search_Options = {
  __typename: 'Search_Options';
  /** The modelTypes requested */
  modelTypes?: Maybe<Array<Scalars['String']>>;
  /** The modifiers used to perform the search (parsed from the passed in query) */
  modifiers?: Maybe<Array<Search_Options_Modifier>>;
  /**
   * Whether or not the partial flag was set for the search.
   *
   * By default, search will match the words in your query exactly. Setting the `partial`
   * flag to true means that search will look for content that starts with any of the
   * words in your query.
   */
  partial?: Maybe<Scalars['Boolean']>;
  /** The terms used to perform the search (parsed from the passed in query) */
  terms?: Maybe<Array<Search_Options_Term>>;
};

/**
 * A modifier used in a search query
 * e.g. In the query "is:open sort:created development",
 * `is:open` and `sort:created` are the modifiers
 */
export type Search_Options_Modifier = {
  __typename: 'Search_Options_Modifier';
  /** The text of the modifier */
  text?: Maybe<Scalars['String']>;
};

/**
 * A term used in a search query
 * e.g. In the query "is:open sort:created development",
 * `development` is the only term
 */
export type Search_Options_Term = {
  __typename: 'Search_Options_Term';
  text?: Maybe<Scalars['String']>;
};

export type SelfServeExpansionResponse = {
  __typename: 'SelfServeExpansionResponse';
  ok: Scalars['Boolean'];
};

/** The counts for a Board being starred */
export type StarCounts = {
  __typename: 'StarCounts';
  /** The number of Organization Members who have starred this Board */
  organization: Scalars['Int'];
};

/** Items in your Billing History */
export type Statement = {
  __typename: 'Statement';
  /** Dollar amount credited or debited */
  amount: Scalars['Float'];
  /** Date payment or credit was applied */
  date: Scalars['String'];
  /** Id for this statement. Same as the statementToken */
  id: Scalars['ID'];
  /** Description of the statement */
  item: Scalars['String'];
  /** Id for this statement */
  statementToken: Scalars['ID'];
  /** URL to the meta page to view the receipt/invoice */
  statementUrl: Scalars['String'];
  /** Translation key used for localizing the item description */
  translationKey: Scalars['String'];
  /** Translation substitutions */
  translationSubstitutions?: Maybe<TranslationSubstitutions>;
};

/** An instance of a sticker on a card */
export type Sticker = {
  __typename: 'Sticker';
  /** ID of the card sticker */
  id: Scalars['ID'];
  /** ID of the image used for the sticker */
  image: Scalars['String'];
  /** List of different scalings of the sticker image */
  imageScaled: Array<Sticker_ImageScaled>;
  /** URL of the image used for the sticker */
  imageUrl: Scalars['String'];
  /** Left position of the sticker on the card */
  left: Scalars['Int'];
  /** Rotations of the sticker on the card */
  rotate: Scalars['Int'];
  /** Top position of the sticker on the card */
  top: Scalars['Int'];
  /** z-index of the sticker on the card */
  zIndex: Scalars['Int'];
};

/** A scaled version of a cards sticker image */
export type Sticker_ImageScaled = {
  __typename: 'Sticker_ImageScaled';
  /** Size of the image in bytes. (only present for custom stickers) */
  bytes?: Maybe<Scalars['Int']>;
  /** Height of the image */
  height: Scalars['Int'];
  /** ID of the sticker image scaled */
  id: Scalars['ID'];
  /** Whether or not the image was scaled */
  scaled: Scalars['Boolean'];
  /** URL of the image */
  url: Scalars['String'];
  /** Width of the image */
  width: Scalars['Int'];
};

/** A Tag (or Collection as it is known in-app) is a 'category' that can be applied to Boards */
export type Tag = {
  __typename: 'Tag';
  /** ID of the Tag */
  id: Scalars['ID'];
  /** name of the Tag */
  name: Scalars['String'];
};

/** Category for template gallery returned from /resources/templates/categories */
export type TemplateCategory = {
  __typename: 'TemplateCategory';
  /** Translations key for template category */
  key: Scalars['String'];
};

/** An object containing information about a the gallery listing */
export type TemplateGallery = {
  __typename: 'TemplateGallery';
  /** The shape the avatar should be */
  avatarShape: Scalars['String'];
  /** The url for the listing's avatar */
  avatarUrl: Scalars['String'];
  /** The blurb for the template's gallery listing */
  blurb: Scalars['String'];
  /** The authors name */
  byline: Scalars['String'];
  /** The category the template is in */
  category: Scalars['String'];
  /** The featured status of the board */
  featured: Scalars['Boolean'];
  /** The precedence the template has for ordering */
  precedence: Scalars['Int'];
  /** The view and copy counts of the board */
  stats: Board_Stats;
};

/** Language for template gallery returned from /resources/templates/languages */
export type TemplateLanguage = {
  __typename: 'TemplateLanguage';
  /** The english user-readable description of the language */
  description: Scalars['String'];
  /** Flag to determine if language is currently enabled */
  enabled: Scalars['Boolean'];
  /** The language key */
  language: Scalars['String'];
  /** The language's locale code */
  locale: Scalars['String'];
  /** The localized user-readable description of the language */
  localizedDescription: Scalars['String'];
};

/** Token model */
export type Token = {
  __typename: 'Token';
  dateCreated: Scalars['String'];
  dateExpires?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idMember: Scalars['String'];
  identifier: Scalars['String'];
  permissions: Array<Maybe<TokenPermission>>;
};

/** The permissions for a specific token */
export type TokenPermission = {
  __typename: 'TokenPermission';
  idModel: Scalars['String'];
  modelType: Scalars['String'];
  read?: Maybe<Scalars['Boolean']>;
  write?: Maybe<Scalars['Boolean']>;
};

/** Data which represents the effects of transferring a team to an enterprise. */
export type TransferrableData = {
  __typename: 'TransferrableData';
  /** The ID of the team */
  id?: Maybe<Scalars['ID']>;
  /** A list of members who will be counted towards billing upon transferring the team */
  newBillableMembers: Array<TransferrableDataMember>;
  /** A list of members who will be removed from the team upon transfering it to the enterprise */
  restrictedMembers: Array<TransferrableDataMember>;
  /** Whether the team is transferrable */
  transferrable?: Maybe<Scalars['Boolean']>;
};

/**
 * Either a billable member of a restricted member (see TransferrableData). It is not a model,
 * but rather just a set of fields of a Member that is solely used for the enteprise dashboard.
 */
export type TransferrableDataMember = {
  __typename: 'TransferrableDataMember';
  avatarUrl?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  initials: Scalars['String'];
  username: Scalars['String'];
};

export type TranslationSubstitutions = {
  __typename: 'TranslationSubstitutions';
  productName?: Maybe<Scalars['String']>;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoard = {
  __typename: 'TrelloBoard';
  /** True if the board has been closed. False otherwise. */
  closed: Scalars['Boolean'];
  /** The board's primary identifier. */
  id: Scalars['ID'];
  /**
   * Last time a change was made to the board. Note: this can be null when board
   * is first created.
   */
  lastActivityAt?: Maybe<Scalars['TrelloDateTime']>;
  /** The name of the board. */
  name: Scalars['String'];
  /** Preferences for the board. */
  prefs: TrelloBoardPrefs;
  /** The board's unique shortened link id (not a complete URL). */
  shortLink: Scalars['TrelloShortLink'];
  /**
   * State on the board that is dependent on the currently
   * authenticated user.
   */
  viewer?: Maybe<TrelloBoardViewer>;
  /** The workspace this board belongs to. */
  workspace?: Maybe<TrelloWorkspace>;
};

/** Collection of attributes representing the board background. */
export type TrelloBoardBackground = {
  __typename: 'TrelloBoardBackground';
  /** The background color or null if there's an image background. */
  color?: Maybe<Scalars['String']>;
  /** The url of the background image or null if there's a color. */
  image?: Maybe<Scalars['String']>;
  /** A list of scaled images and their dimensions */
  imageScaled?: Maybe<Array<TrelloScaleProps>>;
  /** True if the image is tiled. */
  tile: Scalars['Boolean'];
};

/** Collection of preferences for the board. */
export type TrelloBoardPrefs = {
  __typename: 'TrelloBoardPrefs';
  /** Attributes relating to the board background. */
  background: TrelloBoardBackground;
  /** If true, indicates this is a board template or false if it's a typical board. */
  isTemplate: Scalars['Boolean'];
};

/**
 * Information about the board that is dependent on the
 * currently authenticated user "viewing" a board.
 */
export type TrelloBoardViewer = {
  __typename: 'TrelloBoardViewer';
  /** The last time the viewer visited the board. */
  lastSeenAt?: Maybe<Scalars['TrelloDateTime']>;
  /** True if the board is starred. */
  starred: Scalars['Boolean'];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApi = {
  __typename: 'TrelloQueryApi';
  /** Get a Trello board by id. */
  board?: Maybe<TrelloBoard>;
  /**
   * This field will echo back the word echo.
   * It's only useful for testing.
   */
  echo: Scalars['String'];
  /** The list of template categories that each Trello template is classified with. */
  templateCategories: Array<TrelloTemplateGalleryCategory>;
  /** The list of languages that Trello Templates have been translated to. */
  templateLanguages: Array<TrelloTemplateGalleryLanguage>;
};


/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiBoardArgs = {
  id: Scalars['ID'];
};

/** Grouping of image scale properties. */
export type TrelloScaleProps = {
  __typename: 'TrelloScaleProps';
  /** height in pixels */
  height: Scalars['Int'];
  /** Url of the image */
  url: Scalars['String'];
  /** width in pixels */
  width: Scalars['Int'];
};

/** The categories for the Trello template gallery. */
export type TrelloTemplateGalleryCategory = {
  __typename: 'TrelloTemplateGalleryCategory';
  key: Scalars['String'];
};

/** The language metadata to describe each language that the Trello template gallery has been translated to. */
export type TrelloTemplateGalleryLanguage = {
  __typename: 'TrelloTemplateGalleryLanguage';
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  /** The language string determines which language the template gallery will be translated to. */
  language: Scalars['String'];
  /** The locale code determines the regional specification for the language. */
  locale: Scalars['String'];
  localizedDescription: Scalars['String'];
};

/**
 * A workspace is a primary way to group content and collaborate with other Trello
 * users.
 */
export type TrelloWorkspace = {
  __typename: 'TrelloWorkspace';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

/**
 * A photo returned from the Unsplash API
 * https://unsplash.com/documentation
 */
export type UnsplashPhoto = {
  __typename: 'UnsplashPhoto';
  /** List of categories associated with the photo */
  categories: Array<Scalars['String']>;
  /** A color associated with the image, in html hex format (e.g., #DCDBE1) */
  color: Scalars['String'];
  /** Date and time of when the photo was created, in ISO 8601 format (e.g., 2019-08-21T19:58:40-04:00) */
  created_at: Scalars['String'];
  /** Text describing what is shown in the photo */
  description?: Maybe<Scalars['String']>;
  /** Height of the full size image in pixels */
  height: Scalars['Int'];
  /** ID of the UnsplashPhoto */
  id: Scalars['ID'];
  /** Number of users that have liked this photo */
  likes: Scalars['Int'];
  /** Links to various ways of accessing this photo (through the API or in a web browser) */
  links: UnsplashPhoto_Links;
  /** Date and time of when the photo was last updated, in ISO 8601 format (e.g., 2019-08-21T19:58:40-04:00) */
  updated_at: Scalars['String'];
  /** Urls pointing to various sizes of the image */
  urls: UnsplashPhoto_Urls;
  /** Information about the Unsplash user who created this photo */
  user: UnsplashPhoto_User;
  /** Width of the full size image in pixels */
  width: Scalars['Int'];
};

/**
 * Links to various ways of accessing an Unsplash photo (through the API or in a web browser)
 * https://unsplash.com/documentation#photos
 */
export type UnsplashPhoto_Links = {
  __typename: 'UnsplashPhoto_Links';
  /** Url of the image file on Unsplash's website */
  download: Scalars['String'];
  /** Url of the image file on Unsplash's API */
  download_location: Scalars['String'];
  /** Url of the html page for viewing this photo on Unsplash's website */
  html: Scalars['String'];
  /** The Unsplash API url for this photo */
  self: Scalars['String'];
};

/**
 * Urls pointing to various sizes of the UnsplashPhoto image
 * https://unsplash.com/documentation#example-image-use
 */
export type UnsplashPhoto_Urls = {
  __typename: 'UnsplashPhoto_Urls';
  /** The photo in jpg format with its maximum dimensions. For performance purposes, we don’t recommend using this as the photos will load slowly for your users. */
  full: Scalars['String'];
  /** A base image URL with just the photo path and the ixid parameter for your API application. Use this to easily add additional image parameters to construct your own image URL. */
  raw: Scalars['String'];
  /** The photo in jpg format with a width of 1080 pixels */
  regular: Scalars['String'];
  /** The photo in jpg format with a width of 400 pixels */
  small: Scalars['String'];
  /** The photo in jpg format with a width of 200 pixels */
  thumb: Scalars['String'];
};

/**
 * Information about an Unsplash user's public profile
 * https://unsplash.com/documentation#get-a-users-public-profile
 */
export type UnsplashPhoto_User = {
  __typename: 'UnsplashPhoto_User';
  /** ID of the UnsplashPhoto_user */
  id: Scalars['ID'];
  /** Links to various ways of accessing this user's info (through the API or through a web browser) */
  links: UnsplashPhoto_User_Links;
  /** The user's full name */
  name: Scalars['String'];
};

/**
 * Links to various ways of accessing an Unsplash user's public profile info (through the API or through a web browser)
 * https://unsplash.com/documentation#get-a-users-public-profile
 */
export type UnsplashPhoto_User_Links = {
  __typename: 'UnsplashPhoto_User_Links';
  /** Url of the user's html profile page on Unsplash's website */
  html: Scalars['String'];
};

/** Object that represents the response of the updateBoardMemberPermission mutation */
export type UpdateBoardMemberPermission_Response = {
  __typename: 'UpdateBoardMemberPermission_Response';
  /** Board id */
  id: Scalars['ID'];
  members: Array<Member>;
  memberships: Array<Board_Membership>;
};

export type UpdateDashboardViewTile = {
  from?: InputMaybe<UpdateDashboardViewTile_From>;
  graph?: InputMaybe<UpdateDashboardViewTile_Graph>;
  id: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateDashboardViewTile_From = {
  dateType: Scalars['String'];
  value: Scalars['Int'];
};

export type UpdateDashboardViewTile_Graph = {
  type: Scalars['String'];
};

export type UpdatePluginFields = {
  /** API Key associated with this plugin. */
  apiKey?: InputMaybe<Scalars['String']>;
  /** The name of the plugin's author. */
  author?: InputMaybe<Scalars['String']>;
  /** Capabilities represent areas of the UX that a plugin can hook into. */
  capabilities?: InputMaybe<Array<Scalars['String']>>;
  /** Capabilities Options represent areas of capabilities that can be customized. */
  capabilitiesOptions?: InputMaybe<Array<Scalars['String']>>;
  /** A list of categories which the plugin will be listed under. */
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** The email address of the plugin author. */
  email?: InputMaybe<Scalars['String']>;
  /** The icon of the plugin. */
  icon?: InputMaybe<Scalars['String']>;
  /** The URL to the main iframe of the plugin. */
  iframeConnectorUrl?: InputMaybe<Scalars['String']>;
  /** The URL to the privacy policy of the plugin. */
  privacyUrl?: InputMaybe<Scalars['String']>;
  /** Whether the plugin stores personal data. */
  storesPersonalData?: InputMaybe<Scalars['Boolean']>;
  /** The support email of a plugin. */
  supportEmail?: InputMaybe<Scalars['String']>;
};

/** Price quotes for upgrading from Standard to BC */
export type UpgradePriceQuoteInfo = {
  __typename: 'UpgradePriceQuoteInfo';
  /** The price quote for the prorated amount */
  immediate?: Maybe<PriceQuote>;
  /** The dollar amount in account credits available */
  nAccountCreditsTotal?: Maybe<Scalars['Float']>;
  /** The total of the quote, minus any account credits */
  nImmediateTotalLessAccountCredits?: Maybe<Scalars['Float']>;
  /** The price quote for the new subscription */
  renewal?: Maybe<PriceQuote>;
};

export type WorkspaceAccessRequestsItem = {
  __typename: 'WorkspaceAccessRequestsItem';
  dateExpires: Scalars['String'];
  id: Scalars['ID'];
  idMemberRequestor: Scalars['ID'];
  idModel: Scalars['ID'];
  signature: Scalars['String'];
  timestamp: Scalars['String'];
};
